// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/toastify-js/src/toastify.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/gif;base64,R0lGODlhCgAKAJECAAAAAP///////wAAACH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUDw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OEI5RDc5MTFDNkE2MTFFM0JCMDZEODI2QTI4MzJBOTIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OEI5RDc5MTBDNkE2MTFFM0JCMDZEODI2QTI4MzJBOTIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuZGlkOjAyODAxMTc0MDcyMDY4MTE4MDgzQzNDMjA5MzREQ0ZDIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjAyODAxMTc0MDcyMDY4MTE4MDgzQzNDMjA5MzREQ0ZDIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEBQoAAgAsAAAAAAoACgAAAhWEERkn7W3ei7KlagMWF/dKgYeyGAUAIfkEBQoAAgAsAAAAAAoACgAAAg+UYwLJ7RnQm7QmsCyVKhUAIfkEBQoAAgAsAAAAAAoACgAAAhCUYgLJHdiinNSAVfOEKoUCACH5BAUKAAIALAAAAAAKAAoAAAIRVISAdusPo3RAzYtjaMIaUQAAIfkEBQoAAgAsAAAAAAoACgAAAg+MDiem7Q8bSLFaG5il6xQAIfkEBQoAAgAsAAAAAAoACgAAAg+UYRLJ7QnQm7SmsCyVKhUAIfkEBQoAAgAsAAAAAAoACgAAAhCUYBLJDdiinNSEVfOEKoECACH5BAUKAAIALAAAAAAKAAoAAAIRFISBdusPo3RBzYsjaMIaUQAAOw==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("Assets/fonts/Panton-Black.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("Assets/fonts/Panton-BlackItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("Assets/fonts/Panton-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("Assets/fonts/Panton-BoldItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("Assets/fonts/Panton-ExtraBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("Assets/fonts/Panton-ExtraBoldItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("Assets/fonts/Panton-ExtraLight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("Assets/fonts/Panton-Fat.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("Assets/fonts/Panton-FatItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("Assets/fonts/Panton-Heavy.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("Assets/fonts/Panton-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("Assets/fonts/Panton-LightItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("Assets/fonts/Panton-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("Assets/fonts/Panton-RegularItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("Assets/fonts/Panton-SemiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("Assets/fonts/Panton-SemiBoldItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("Assets/fonts/Panton-Thin.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("Assets/fonts/Panton-ThinItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("Assets/fonts/OpenDyslexic-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("Assets/fonts/OpenDyslexic-Italic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("Assets/fonts/OpenDyslexic-BoldItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("Assets/fonts/OpenDyslexic-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("Assets/png/background.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("Assets/png/first-video-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("Assets/png/background-yconnect-login.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.ReactCrop {
  position: relative;
  display: inline-block;
  cursor: crosshair;
  overflow: hidden;
  max-width: 100%; }
  .ReactCrop:focus {
    outline: none; }
  .ReactCrop--disabled, .ReactCrop--locked {
    cursor: inherit; }
  .ReactCrop__image {
    display: block;
    max-width: 100%;
    touch-action: manipulation; }
  .ReactCrop__crop-selection {
    position: absolute;
    top: 0;
    left: 0;
    transform: translate3d(0, 0, 0);
    box-sizing: border-box;
    cursor: move;
    box-shadow: 0 0 0 9999em rgba(0, 0, 0, 0.5);
    touch-action: manipulation;
    border: 1px solid;
    border-image-source: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    border-image-slice: 1;
    border-image-repeat: repeat; }
    .ReactCrop--disabled .ReactCrop__crop-selection {
      cursor: inherit; }
    .ReactCrop--circular-crop .ReactCrop__crop-selection {
      border-radius: 50%;
      box-shadow: 0px 0px 1px 1px white, 0 0 0 9999em rgba(0, 0, 0, 0.5); }
  .ReactCrop--invisible-crop .ReactCrop__crop-selection {
    display: none; }
  .ReactCrop__rule-of-thirds-vt::before, .ReactCrop__rule-of-thirds-vt::after, .ReactCrop__rule-of-thirds-hz::before, .ReactCrop__rule-of-thirds-hz::after {
    content: '';
    display: block;
    position: absolute;
    background-color: rgba(255, 255, 255, 0.4); }
  .ReactCrop__rule-of-thirds-vt::before, .ReactCrop__rule-of-thirds-vt::after {
    width: 1px;
    height: 100%; }
  .ReactCrop__rule-of-thirds-vt::before {
    left: 33.3333%;
    left: calc(100% / 3); }
  .ReactCrop__rule-of-thirds-vt::after {
    left: 66.6666%;
    left: calc(100% / 3 * 2); }
  .ReactCrop__rule-of-thirds-hz::before, .ReactCrop__rule-of-thirds-hz::after {
    width: 100%;
    height: 1px; }
  .ReactCrop__rule-of-thirds-hz::before {
    top: 33.3333%;
    top: calc(100% / 3); }
  .ReactCrop__rule-of-thirds-hz::after {
    top: 66.6666%;
    top: calc(100% / 3 * 2); }
  .ReactCrop__drag-handle {
    position: absolute; }
    .ReactCrop__drag-handle::after {
      position: absolute;
      content: '';
      display: block;
      width: 10px;
      height: 10px;
      background-color: rgba(0, 0, 0, 0.2);
      border: 1px solid rgba(255, 255, 255, 0.7);
      box-sizing: border-box;
      outline: 1px solid transparent; }
  .ReactCrop .ord-nw {
    top: 0;
    left: 0;
    margin-top: -5px;
    margin-left: -5px;
    cursor: nw-resize; }
    .ReactCrop .ord-nw::after {
      top: 0;
      left: 0; }
  .ReactCrop .ord-n {
    top: 0;
    left: 50%;
    margin-top: -5px;
    margin-left: -5px;
    cursor: n-resize; }
    .ReactCrop .ord-n::after {
      top: 0; }
  .ReactCrop .ord-ne {
    top: 0;
    right: 0;
    margin-top: -5px;
    margin-right: -5px;
    cursor: ne-resize; }
    .ReactCrop .ord-ne::after {
      top: 0;
      right: 0; }
  .ReactCrop .ord-e {
    top: 50%;
    right: 0;
    margin-top: -5px;
    margin-right: -5px;
    cursor: e-resize; }
    .ReactCrop .ord-e::after {
      right: 0; }
  .ReactCrop .ord-se {
    bottom: 0;
    right: 0;
    margin-bottom: -5px;
    margin-right: -5px;
    cursor: se-resize; }
    .ReactCrop .ord-se::after {
      bottom: 0;
      right: 0; }
  .ReactCrop .ord-s {
    bottom: 0;
    left: 50%;
    margin-bottom: -5px;
    margin-left: -5px;
    cursor: s-resize; }
    .ReactCrop .ord-s::after {
      bottom: 0; }
  .ReactCrop .ord-sw {
    bottom: 0;
    left: 0;
    margin-bottom: -5px;
    margin-left: -5px;
    cursor: sw-resize; }
    .ReactCrop .ord-sw::after {
      bottom: 0;
      left: 0; }
  .ReactCrop .ord-w {
    top: 50%;
    left: 0;
    margin-top: -5px;
    margin-left: -5px;
    cursor: w-resize; }
    .ReactCrop .ord-w::after {
      left: 0; }
  .ReactCrop__disabled .ReactCrop__drag-handle {
    cursor: inherit; }
  .ReactCrop__drag-bar {
    position: absolute; }
    .ReactCrop__drag-bar.ord-n {
      top: 0;
      left: 0;
      width: 100%;
      height: 6px;
      margin-top: -3px; }
    .ReactCrop__drag-bar.ord-e {
      right: 0;
      top: 0;
      width: 6px;
      height: 100%;
      margin-right: -3px; }
    .ReactCrop__drag-bar.ord-s {
      bottom: 0;
      left: 0;
      width: 100%;
      height: 6px;
      margin-bottom: -3px; }
    .ReactCrop__drag-bar.ord-w {
      top: 0;
      left: 0;
      width: 6px;
      height: 100%;
      margin-left: -3px; }
  .ReactCrop--new-crop .ReactCrop__drag-bar,
  .ReactCrop--new-crop .ReactCrop__drag-handle,
  .ReactCrop--fixed-aspect .ReactCrop__drag-bar {
    display: none; }
  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-n,
  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-e,
  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-s,
  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-w {
    display: none; }
  @media (pointer: coarse) {
    .ReactCrop .ord-n,
    .ReactCrop .ord-e,
    .ReactCrop .ord-s,
    .ReactCrop .ord-w {
      display: none; }
    .ReactCrop__drag-handle {
      width: 24px;
      height: 24px; } }

@font-face {
  font-family: "Panton-Black";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); }

@font-face {
  font-family: "Panton-BlackItalic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); }

@font-face {
  font-family: "Panton-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}); }

@font-face {
  font-family: "Panton-BoldItalic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}); }

@font-face {
  font-family: "Panton-ExtraBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}); }

@font-face {
  font-family: "Panton-ExtraBoldItalic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); }

@font-face {
  font-family: "Panton-ExtraLight";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}); }

@font-face {
  font-family: "Panton-Fat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}); }

@font-face {
  font-family: "Panton-FatItalic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}); }

@font-face {
  font-family: "Panton-Heavy";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}); }

@font-face {
  font-family: "Panton-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}); }

@font-face {
  font-family: "Panton-LightItalic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}); }

@font-face {
  font-family: "Panton-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}); }

@font-face {
  font-family: "Panton-RegularItalic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}); }

@font-face {
  font-family: "Panton-SemiBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}); }

@font-face {
  font-family: "Panton-SemiBoldItalic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}); }

@font-face {
  font-family: "Panton-Thin";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}); }

@font-face {
  font-family: "Panton-ThinItalic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}); }

@font-face {
  font-family: "OpenDyslexic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}); }

@font-face {
  font-family: "OpenDyslexic-Italic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___}); }

@font-face {
  font-family: "OpenDyslexic-BoldItalic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_21___}); }

@font-face {
  font-family: "OpenDyslexic-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___}); }

* {
  box-sizing: border-box;
  font-size: 16px;
  margin: 0;
  padding: 0; }

body {
  background-color: #f0f5f6;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  color: #565656;
  font-family: 'Panton-Regular', 'arial';
  overflow-x: hidden; }

main {
  position: relative;
  min-height: calc(100vh - 80px - 280px); }
  @media screen and (min-width: 768px) {
    main {
      margin-bottom: 0;
      position: initial;
      top: 0; } }

.main-container {
  min-height: calc(100vh - 80px - 350px);
  margin-top: calc(50px + 32px); }
  @media screen and (min-width: 768px) {
    .main-container {
      margin-top: 0; } }

h1, .h1 {
  font-size: 1.5rem;
  line-height: 1.875rem; }
  @media screen and (min-width: 768px) {
    h1, .h1 {
      font-size: 2.125rem;
      line-height: 2.625rem; } }

h2, .h2 {
  font-size: 1.1875rem;
  line-height: 1.75rem; }
  @media screen and (min-width: 768px) {
    h2, .h2 {
      font-size: 1.75rem;
      line-height: 2.25rem; } }

h3, .h3 {
  font-size: 1rem;
  line-height: 1.375rem; }
  @media screen and (min-width: 768px) {
    h3, .h3 {
      font-size: 1.25rem;
      line-height: 1.75rem; } }

h4, .h4 {
  font-size: 0.875rem;
  line-height: 0.889rem; }
  @media screen and (min-width: 768px) {
    h4, .h4 {
      font-size: 1.0625rem;
      line-height: 1.1875rem; } }

a {
  color: #79b100;
  font-size: 0.9375rem;
  line-height: 1.125rem; }
  @media screen and (min-width: 768px) {
    a {
      font-size: 1rem;
      line-height: 0.843rem; } }

p {
  font-size: 0.9375rem; }
  @media screen and (min-width: 768px) {
    p {
      line-height: 1.5rem; } }

.toastify-error {
  background: #BD362F; }

.toastify-warning {
  background: #F89406; }

.toastify-success {
  background: #51A351; }

.container-input {
  align-items: flex-end;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  user-select: none;
  display: flex;
  flex-flow: row wrap; }

/* Hide the browser's default checkbox */
.container-input input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  margin: 0; }

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none; }

/* Show the checkmark when checked */
.container-input input:checked ~ .checkmark:after {
  display: block; }

/* Style the checkmark/indicator */
.container-input .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: 2px solid #79b100;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg); }

.input-password {
  position: relative; }
  .input-password .input-toggle-password {
    cursor: pointer;
    position: absolute;
    right: 15px;
    top: 32px;
    z-index: 3; }

.modal-backdrop {
  height: 100%;
  min-width: 100vw;
  min-height: 100vh;
  width: 100%; }

.modal-backdrop.show {
  opacity: .9; }

@media screen and (min-width: 1024px) {
  .modal-background {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
    background-size: 95%;
    background-repeat: no-repeat;
    background-position: center; } }

/* TODO Renomear na é usado somente no first access */
.first-access {
  align-items: flex-start;
  border-bottom: 0;
  display: flex;
  flex-flow: column-reverse; }
  @media screen and (min-width: 1024px) {
    .first-access {
      display: flex;
      flex-flow: row;
      align-items: center; } }
  .first-access .close {
    margin-bottom: 40px;
    text-align: right;
    text-shadow: none;
    width: 100%; }
    @media screen and (min-width: 1024px) {
      .first-access .close {
        width: auto;
        margin-bottom: 0; } }
    .first-access .close span:first-child {
      float: right;
      position: relative;
      top: 8px; }
    .first-access .close .sr-only {
      position: relative;
      margin-right: 15px; }
  .first-access .modal-content {
    background-color: transparent !important;
    border: none !important; }
    @media screen and (min-width: 1024px) {
      .first-access .modal-content {
        padding: 50px; } }
    .first-access .modal-content .modal-header {
      color: #fff;
      padding: 0; }
      @media screen and (min-width: 1024px) {
        .first-access .modal-content .modal-header {
          flex-flow: row nowrap; } }
      .first-access .modal-content .modal-header.first-access {
        font-size: 24px;
        margin-bottom: 15px; }
        @media screen and (min-width: 1024px) {
          .first-access .modal-content .modal-header.first-access {
            font-size: 34px;
            margin-bottom: 30px; } }
      .first-access .modal-content .modal-header button {
        color: #fff;
        opacity: 1; }
  .first-access .first-access-iframe {
    height: auto;
    object-fit: cover; }
    @media screen and (min-width: 1024px) {
      .first-access .first-access-iframe {
        height: 452px; } }

.modal-content {
  padding: 24px; }
  .modal-content .modal-body {
    padding: 0;
    border-radius: 8px; }

.explore-table thead th:last-child,
.explore-table .table-line td:last-child {
  text-align: right; }

.card-container {
  width: 70%;
  margin-left: 8px; }
  @media screen and (min-width: 1024px) {
    .card-container {
      width: 33%; } }

.YC-Footer {
  margin-top: 48px; }
  @media screen and (min-width: 1027px) {
    .YC-Footer {
      margin-top: 100px; } }

.YC-Footer-bottom {
  background-color: #505759;
  color: #C5CBCC;
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  height: 86px; }
  @media (min-width: 768px) {
    .YC-Footer-bottom {
      margin-bottom: 0; } }
  .YC-Footer-bottom .container {
    align-items: center;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between; }
    .YC-Footer-bottom .container img {
      width: 120px; }

.allrights {
  color: #FFFFFF;
  font-size: 0.75rem;
  margin: 16px 0 0;
  opacity: 0.6;
  text-align: center; }
  @media screen and (min-width: 1024px) {
    .allrights {
      margin: 0;
      text-align: right; } }

.YC-lateral {
  background-color: #fff;
  color: #424242;
  height: 100vh;
  padding: 36px;
  position: fixed;
  transition: transform 1s cubic-bezier(0, 0.52, 0, 1);
  top: 0;
  z-index: 10; }
  @media screen and (min-width: 768px) {
    .YC-lateral {
      padding: 36px; } }
  .YC-lateral h4 .close-modal {
    max-width: 80px;
    padding-right: 0;
    text-align: right; }

.YC-lateral-menu-enter {
  right: 0;
  transform: translate3d(100vw, 0, 0);
  width: 80%; }
  @media screen and (min-width: 768px) {
    .YC-lateral-menu-enter {
      width: 65%; } }

.YC-lateral-menu-enter-active,
.YC-lateral-menu-enter-done {
  left: 0;
  transform: translate3d(0vw, 0, 0);
  transition: transform 0.8s cubic-bezier(0, 0.52, 0, 1);
  width: 100%; }
  @media screen and (min-width: 768px) {
    .YC-lateral-menu-enter-active,
    .YC-lateral-menu-enter-done {
      left: auto;
      right: 0;
      width: 65%; } }

.YC-lateral-menu-exit {
  box-shadow: none !important;
  right: 0;
  transform: translate3d(100vw, 0, 0); }
  @media screen and (min-width: 768px) {
    .YC-lateral-menu-exit {
      width: 65%; } }

.YC-lateral-menu-exit-active,
.YC-lateral-menu-exit-done {
  transform: translate3d(100vw, 0, 0);
  transition: transform 0.8s cubic-bezier(0, 0.52, 0, 1); }

.lateral-header {
  right: 0;
  padding: 62px 16px 34px;
  width: 80%;
  z-index: 10000; }
  @media screen and (min-width: 1024px) {
    .lateral-header {
      padding: 16px 16px 34px;
      width: 50%; } }
  .lateral-header .lateral-header--title {
    align-items: center;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between; }
  .lateral-header .header-filter {
    align-self: end;
    align-items: center;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
    width: 100%; }
    .lateral-header .header-filter .header-filter--select {
      width: 33%; }
      @media screen and (min-width: 1024px) {
        .lateral-header .header-filter .header-filter--select {
          width: 43%; } }
  .lateral-header.with-navbar {
    padding: 64px 16px 34px; }

.lateral-menu-mobile {
  height: calc(100vh - 55px);
  overflow-y: scroll;
  max-height: calc(100vh - 55px);
  padding: 0;
  top: 55px;
  width: 80%; }
  @media screen and (min-width: 768px) {
    .lateral-menu-mobile {
      display: none;
      height: calc(100vh - 80px);
      top: 80px;
      width: 50%; } }

.lateral-course-stamps {
  right: 0;
  transform: translate3d(700px, 0, 0);
  width: 700px; }
  .lateral-course-stamps.active {
    transform: translate3d(0vw, 0, 0);
    transition: transform 0.8s cubic-bezier(0, 0.52, 0, 1); }

.lateral-course-download {
  right: 0;
  transform: translate3d(700px, 0, 0);
  width: 700px; }
  .lateral-course-download.active {
    transform: translate3d(0vw, 0, 0);
    transition: transform 0.8s cubic-bezier(0, 0.52, 0, 1); }

.lateral-audio {
  right: 0;
  transform: translate3d(110vw, 0, 0);
  width: 100vw;
  z-index: 1030; }
  @media screen and (min-width: 1024px) {
    .lateral-audio {
      width: 50%; } }
  .lateral-audio.active {
    transform: translate3d(0vw, 0, 0);
    transition: transform 0.8s cubic-bezier(0, 0.52, 0, 1); }

.lateral-progress {
  right: 0;
  transform: translate3d(800px, 0, 0);
  width: 800px; }
  .lateral-progress.active {
    transform: translate3d(0vw, 0, 0);
    transition: transform 0.8s cubic-bezier(0, 0.52, 0, 1); }

.lateral-filter {
  right: 0;
  padding: 16px 16px 34px;
  width: 100%;
  z-index: 1040; }
  @media screen and (min-width: 1024px) {
    .lateral-filter {
      padding: 16px 16px 34px;
      width: 50%; } }
  .lateral-filter .lateral-header--title {
    align-items: center;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between; }
  .lateral-filter .header-filter {
    align-self: end;
    align-items: center;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
    width: 100%; }
  .lateral-filter.with-navbar {
    padding: 64px 16px 34px; }

.bg-loader {
  background-color: rgba(0, 0, 0, 0.5);
  height: calc(100% + 50px);
  left: 0;
  max-width: 100vw;
  position: fixed;
  top: -50px;
  width: 100%;
  z-index: 9999; }

.loader-bg {
  position: absolute;
  left: calc(50% - 20px);
  top: calc(50% - 20px);
  width: 40px;
  height: 40px;
  border: 4px #FAFAFA solid;
  border-radius: 30px; }

.loader {
  position: absolute;
  left: calc(50% - 20px);
  top: calc(50% - 20px);
  width: 40px;
  height: 40px;
  border: 4px transparent solid;
  border-top: 4px #643E94 solid;
  border-radius: 30px;
  animation: loader .7s infinite;
  animation-timing-function: linear; }

@-moz-keyframes loader {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

@-webkit-keyframes loader {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

@keyframes loader {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

.modal-dialog .first-access {
  border-bottom: 0; }
  .modal-dialog .first-access .modal-content {
    background-color: transparent !important;
    border: none !important;
    padding: 50px; }
    .modal-dialog .first-access .modal-content .modal-header {
      color: #fff;
      padding: 0; }
      .modal-dialog .first-access .modal-content .modal-header.first-access {
        margin-bottom: 30px;
        z-index: 10; }
      .modal-dialog .first-access .modal-content .modal-header button {
        color: #fff;
        opacity: 1; }

.modal-dialog .modal-header {
  margin-bottom: 24px;
  padding: 0; }
  .modal-dialog .modal-header .modal-title {
    background-color: #fff;
    padding: 4px;
    transform: translateY(-50%);
    color: #4e2d78; }

.search-file {
  cursor: text !important;
  width: 14rem !important; }

.YC-ProfileCard .user-level {
  border-radius: 50%;
  bottom: 0;
  color: #fff;
  height: 40px;
  position: absolute;
  right: 10%;
  width: 40px; }

.YC-ProfileCard .border-line {
  border-top: 1px solid #eeeeee; }

.border-white {
  width: 20%;
  z-index: 3;
  justify-content: center; }

.level-progress-patent {
  font-size: 70%; }

.level-progress-bar {
  background-color: #c9c9c9;
  border-radius: 50px;
  height: 6px;
  margin: 16px 0;
  width: 60%; }
  .level-progress-bar .progress-bar-number {
    align-items: center;
    border: solid 2px #fff;
    border-radius: 50%;
    color: #fff;
    display: flex;
    flex-flow: row wrap;
    font-size: .75rem;
    justify-content: center;
    height: 25px;
    position: relative;
    top: -15px;
    width: 25px;
    z-index: 3; }
  .level-progress-bar small {
    color: #643E94;
    display: block;
    position: relative;
    text-align: center;
    top: -5px;
    width: 80px; }
  .level-progress-bar .completed-progress-bar {
    background-color: #643E94;
    height: 2px;
    position: relative;
    top: 2px; }
    .level-progress-bar .completed-progress-bar::after {
      background-color: #fff;
      border: 2px solid #643E94;
      border-radius: 50%;
      content: '';
      height: 15px;
      position: relative;
      float: right;
      top: -6px;
      width: 15px;
      z-index: 2; }
  .level-progress-bar .completed-tags {
    font-size: 0.75rem;
    margin-top: 8px;
    text-align: center;
    width: 100%; }

.profile-status {
  width: 100%; }
  .profile-status .profile-status-item .status-item-title {
    color: #c0c0c0;
    font-size: 0.75rem; }

.progress-user-steps .progress-steps-bar {
  background-color: #c9c9c9;
  border-radius: 8px;
  max-height: 90%;
  width: 3px; }
  .progress-user-steps .progress-steps-bar .current-progress {
    width: 1px;
    background-color: #643E94;
    left: 1px;
    position: relative; }
    .progress-user-steps .progress-steps-bar .current-progress::after {
      background-color: #fff;
      border: 2px solid #643E94;
      border-radius: 50%;
      bottom: -5px;
      content: '';
      display: block;
      height: 15px;
      left: -7px;
      position: absolute;
      width: 15px;
      z-index: 2; }

.progress-user-steps .user-step .user-step-tag {
  background-color: #fff;
  border: 2px solid #643E94;
  border-radius: 50%;
  filter: grayscale(100%);
  left: -19px;
  padding: 5px;
  position: relative;
  width: 35px;
  z-index: 3; }
  .progress-user-steps .user-step .user-step-tag.completed {
    filter: grayscale(0); }

.YC-Pagination {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -o-user-select: none;
  justify-content: center;
  padding: 16px 0; }
  .YC-Pagination li {
    cursor: pointer;
    padding: 0 4px; }
    .YC-Pagination li:hover {
      color: #79b100; }
  .YC-Pagination li.active {
    font-weight: bold;
    cursor: context-menu; }
    .YC-Pagination li.active > a {
      color: #424242; }
  .YC-Pagination .disabled {
    color: #F0F5F6 !important;
    cursor: not-allowed; }
    .YC-Pagination .disabled:hover {
      color: #F0F5F6;
      text-decoration: none; }

.progress {
  background-color: #e1e6e7;
  height: 8px;
  width: 100%; }
  .progress.w-35 {
    width: 35% !important; }
  .progress .progress-bar {
    background-color: #643E94;
    border-radius: 50px;
    height: 4px;
    margin: 2px;
    width: 40%; }
  .progress.completed {
    background-color: #b8f2e6; }
    .progress.completed .progress-bar {
      background-color: #00a281; }

.tag {
  flex: 1 1 auto;
  height: 60px;
  width: 60px; }
  .tag .tag-title {
    color: #424242;
    position: relative;
    text-align: center;
    top: 4px; }
  .tag .tag-country {
    color: #616161;
    font-size: 13px;
    line-height: 1rem;
    margin-top: 8px;
    position: relative;
    text-align: center;
    text-decoration: none; }

.about-card {
  background-color: #643E94 !important;
  display: flex;
  padding: 0 !important; }
  @media screen and (min-width: 1024px) {
    .about-card {
      align-items: center;
      flex-flow: column wrap;
      height: 351px;
      margin-top: 48px !important;
      margin-left: 56px !important;
      padding: 40px !important; } }
  .about-card .about-card-video {
    border-radius: 8px 8px 0 0;
    max-height: 200px;
    object-fit: cover; }
    @media screen and (min-width: 1024px) {
      .about-card .about-card-video {
        border-radius: 0;
        height: 350px;
        max-height: fit-content;
        transform: translate(-20%, -30%);
        width: 50%; } }
  .about-card .about-card-info {
    color: #fff;
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    height: 100%;
    padding: 16px; }
    @media screen and (min-width: 1024px) {
      .about-card .about-card-info {
        display: flex;
        flex-flow: column wrap;
        justify-content: flex-start;
        height: 100%;
        width: 50%; } }
    .about-card .about-card-info .card-info--title {
      margin: 16px 0; }

.learning .learning-title {
  margin: 0 0 16px; }
  @media screen and (min-width: 1024px) {
    .learning .learning-title {
      margin: 60px 0 40px; } }

.learning .learning-cards {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between; }
  @media screen and (min-width: 1024px) {
    .learning .learning-cards {
      margin-bottom: 60px; } }
  .learning .learning-cards .learning-card {
    align-items: center;
    display: flex;
    flex-flow: column wrap;
    justify-content: space-around;
    margin-bottom: 24px; }
    @media screen and (min-width: 1024px) {
      .learning .learning-cards .learning-card {
        width: 30%; } }
    .learning .learning-cards .learning-card figure {
      margin: 8px 0 24px; }
    .learning .learning-cards .learning-card .learning-card--title {
      margin-bottom: 16px; }
    .learning .learning-cards .learning-card .learning-card--description {
      margin-bottom: 24px;
      text-align: center; }

.comments-cards {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between; }
  .comments-cards .comment {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    margin-right: 8px;
    width: 90%; }
    @media screen and (min-width: 1024px) {
      .comments-cards .comment {
        width: 45%; } }
  @media screen and (min-width: 1024px) {
    .comments-cards .comment-figure {
      transform: translateX(-30%); } }
  .comments-cards .comment-img {
    border-radius: 50%; }
  .comments-cards .comment-statement {
    font-size: 0.75rem; }

@media screen and (min-width: 1024px) {
  .countrypage .country-curiosity {
    font-size: 19px;
    font-weight: 600;
    line-height: 26px;
    position: absolute;
    text-align: left;
    width: 330px; } }

.countrypage .country-about {
  border-left: solid 2px #e1e6e7;
  display: flex;
  flex-flow: column wrap;
  margin-top: 37px;
  margin-left: 8px;
  padding-left: 24px; }
  .countrypage .country-about .about-img-and-stamp {
    display: flex;
    flex-direction: row;
    justify-content: center; }
  .countrypage .country-about .about-img-stamp {
    align-items: center;
    background-color: #ffffff;
    border-radius: 100%;
    box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.11);
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    height: 90px;
    position: absolute;
    right: calc(16%);
    width: 90px; }
    .countrypage .country-about .about-img-stamp img {
      width: 70px; }
  .countrypage .country-about .country-about-img {
    box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.11);
    display: block;
    margin: 0 0 37px 0;
    position: relative;
    right: 32px;
    width: 120px; }
  .countrypage .country-about .country-about-subtitle {
    font-weight: 600;
    margin: 0 0 16px 0; }
    .countrypage .country-about .country-about-subtitle::before {
      background-color: #fff;
      border: 3px solid #e1e6e7;
      border-radius: 50%;
      content: "";
      display: block;
      height: 15px;
      left: 17px;
      position: absolute;
      width: 15px;
      z-index: 2; }
      @media screen and (min-width: 768px) {
        .countrypage .country-about .country-about-subtitle::before {
          left: 42px; } }
  .countrypage .country-about .country-about-description {
    margin-bottom: 40px; }
  .countrypage .country-about .country-about-map {
    height: 320px;
    margin-bottom: 24px;
    width: 100%; }

.countrypage .country-about-desktop {
  border-left: none;
  display: flex;
  flex-flow: row wrap;
  margin-top: 37px;
  margin-left: 0;
  padding-left: 0; }
  .countrypage .country-about-desktop .country-about-img {
    box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.11);
    display: block;
    height: 167px;
    margin: -32px auto 80px;
    position: relative;
    right: 0;
    width: 251px; }
  .countrypage .country-about-desktop .about-img-stamp {
    align-items: center;
    background-color: #ffffff;
    border-radius: 100%;
    box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.11);
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    height: 140px;
    position: absolute;
    right: calc(45% - 140px);
    top: 110px;
    width: 140px; }
    .countrypage .country-about-desktop .about-img-stamp img {
      width: 100px; }
  .countrypage .country-about-desktop .about-country {
    display: flex;
    flex-flow: column wrap;
    text-align: right;
    width: 50%;
    border-right: solid 2px #e1e6e7;
    margin-left: 0px;
    padding-right: 24px; }
  .countrypage .country-about-desktop .about-map {
    display: flex;
    flex-flow: column wrap;
    padding: 0 24px;
    width: 50%; }
  .countrypage .country-about-desktop .country-about-subtitle {
    font-weight: 600;
    margin: 0 0 16px 0; }
    .countrypage .country-about-desktop .country-about-subtitle::after {
      background-color: #fff;
      border: 3px solid #e1e6e7;
      border-radius: 50%;
      content: "";
      display: block;
      height: 15px;
      right: calc(50% - 6px);
      margin-top: -20px;
      position: absolute;
      width: 15px;
      z-index: 2; }
  .countrypage .country-about-desktop .country-map-subtitle {
    font-weight: 600;
    display: block;
    margin: 0 0 16px 0;
    height: 26px;
    width: 100%; }
  .countrypage .country-about-desktop .country-about-map {
    height: 320px;
    width: 100%; }

.countrypage .tags {
  margin-bottom: 36px; }

.countrypage .nav-tabs {
  flex-flow: row nowrap;
  overflow-x: scroll;
  margin-bottom: 0; }
  @media screen and (min-width: 1024px) {
    .countrypage .nav-tabs {
      overflow-x: hidden;
      justify-content: space-between; } }
  .countrypage .nav-tabs .tabheader-icon {
    align-items: center;
    display: flex;
    flex-flow: column wrap;
    justify-content: center; }
    .countrypage .nav-tabs .tabheader-icon svg {
      fill: #79b100;
      height: 35px;
      width: 35px; }
    .countrypage .nav-tabs .tabheader-icon span {
      margin: 8px 0; }
  .countrypage .nav-tabs .nav-link {
    padding: 0 66px;
    white-space: nowrap; }
    @media screen and (min-width: 1024px) {
      .countrypage .nav-tabs .nav-link {
        padding: 0 46px; } }
    .countrypage .nav-tabs .nav-link .tabheader-icon svg {
      fill: #79b100 !important; }
      .countrypage .nav-tabs .nav-link .tabheader-icon svg g {
        fill: #79b100 !important; }
    .countrypage .nav-tabs .nav-link.active {
      white-space: nowrap; }
      .countrypage .nav-tabs .nav-link.active .tabheader-icon svg {
        fill: #4e2d78 !important; }
        .countrypage .nav-tabs .nav-link.active .tabheader-icon svg g {
          fill: #4e2d78 !important; }
    .countrypage .nav-tabs .nav-link.disabled svg {
      fill: #c5cbcc !important; }
      .countrypage .nav-tabs .nav-link.disabled svg g {
        fill: #c5cbcc !important; }
    .countrypage .nav-tabs .nav-link.disabled span {
      color: #c5cbcc !important; }

.countrypage .tab-content {
  background-color: white;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  padding: 16px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px; }
  @media screen and (min-width: 1024px) {
    .countrypage .tab-content .countrytab {
      align-items: center;
      display: flex;
      flex-flow: row wrap;
      padding: 24px 50px; } }
  .countrypage .tab-content .countrytab-picture {
    max-width: 35px; }
  .countrypage .tab-content.w-100 {
    width: 100%; }
  .countrypage .tab-content .countrytab-content1 {
    display: flex;
    flex-flow: row wrap;
    justify-content: center; }
    @media screen and (min-width: 1024px) {
      .countrypage .tab-content .countrytab-content1 {
        width: 45%; } }
    .countrypage .tab-content .countrytab-content1 ul {
      padding: 16px; }
  @media screen and (min-width: 1024px) {
    .countrypage .tab-content .countrytab-content2 {
      display: flex;
      flex-flow: row wrap;
      justify-content: flex-start;
      padding-left: 100px;
      width: 55%; } }
  .countrypage .tab-content .countrytab-content2 ul {
    padding: 16px; }
  .countrypage .tab-content .countrytab-title {
    margin: 40px 0 16px; }
  .countrypage .tab-content .countrytab-tag {
    align-items: center;
    background-color: #fff;
    border-radius: 50%;
    box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.11) !important;
    display: flex;
    flex-flow: row wrap;
    height: 90px;
    justify-content: center;
    position: absolute;
    margin-top: -51px;
    right: 15%;
    width: 90px; }
    @media screen and (min-width: 360px) and (max-width: 767px) {
      .countrypage .tab-content .countrytab-tag {
        margin-top: 88px;
        right: 4%;
        width: 90px; } }
    @media screen and (min-width: 767px) {
      .countrypage .tab-content .countrytab-tag {
        margin-top: 88px;
        width: 90px;
        right: calc(18% - 20px); } }
    @media screen and (min-width: 992px) {
      .countrypage .tab-content .countrytab-tag {
        margin-top: 88px;
        right: 24%;
        width: 90px; } }
    @media screen and (min-width: 1024px) {
      .countrypage .tab-content .countrytab-tag {
        margin-top: 90px;
        right: calc(52% - 25px);
        width: 90px; } }
    @media screen and (min-width: 1200px) {
      .countrypage .tab-content .countrytab-tag {
        margin-top: 90px;
        right: calc(54% - 25px);
        width: 90px; } }
  @media screen and (min-width: 360px) {
    .countrypage .tab-content .video-tab {
      margin-top: 130px;
      right: calc(1% - 25px);
      width: 90px; } }
  @media screen and (min-width: 1024px) {
    .countrypage .tab-content .video-tab {
      margin-top: 82px;
      right: calc(52% - 20px);
      width: 90px; } }
  .countrypage .tab-content .countrytab-tag-padronizing {
    max-width: 100%;
    max-height: 268px; }
    @media screen and (min-width: 1024px) {
      .countrypage .tab-content .countrytab-tag-padronizing {
        max-height: 405px;
        max-width: 415px; } }
    @media not all and (min-resolution: 0.001dpcm) {
      @supports (-webkit-appearance: none) {
        .countrypage .tab-content .countrytab-tag-padronizing {
          /*Safari browser*/
          height: intrinsic; } } }
  @media screen and (min-width: 1024px) {
    .countrypage .tab-content .bigger-width {
      height: 270px;
      max-height: 270px;
      max-width: 405px;
      width: 100%; } }
  @media screen and (min-width: 350px) {
    .countrypage .tab-content .bigger-width {
      height: 270px;
      max-height: 270px;
      max-width: 402px;
      width: 100%; } }
  @media screen and (min-width: 1024px) {
    .countrypage .tab-content .bigger-height {
      height: 415px;
      max-height: 415px;
      max-width: 275px;
      width: 100%; } }
  @media screen and (min-width: 360px) and (max-width: 1022px) {
    .countrypage .tab-content .bigger-height {
      max-height: 268px;
      max-width: 178px;
      height: 267px; } }
  @media screen and (max-width: 1024px) {
    .countrypage .tab-content .default-image {
      max-height: 250px !important; } }

.countrypage .testimonials {
  height: 420px; }
  @media screen and (min-width: 1024px) {
    .countrypage .testimonials {
      height: 342px;
      margin-top: 30px;
      max-height: 342px;
      overflow: hidden; } }

.countrypage .share-card {
  display: flex;
  flex-flow: row wrap;
  margin-top: 30px; }
  @media screen and (max-width: 768px) {
    .countrypage .share-card figure {
      display: block;
      margin: 0 auto 16px; } }
  .countrypage .share-card .form-group {
    margin-top: 16px;
    width: 100%; }
  @media screen and (min-width: 1024px) {
    .countrypage .share-card .form-group {
      margin-top: 0;
      width: 85%; } }

.countrypage .share-footer {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-end;
  margin-bottom: 64px; }

.courses .courses-header img {
  width: 80px; }

.courses .courses-header-title {
  display: flex;
  flex-flow: column wrap;
  justify-content: space-around; }
  @media screen and (min-width: 1024px) {
    .courses .courses-header-title {
      justify-content: flex-start; } }

.courses .courses-stamps {
  border: 1px solid #643E94;
  border-radius: 50px;
  font-size: 0.75rem;
  margin: 0;
  padding: 2px 10px;
  text-align: center; }

.courses-desktop {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around; }
  .courses-desktop figure {
    width: 30%; }
    .courses-desktop figure img {
      width: 250px; }
    .courses-desktop figure .courses-stamps {
      bottom: 24px;
      border-color: #fff;
      color: #fff;
      left: 70px;
      position: absolute; }
      @media screen and (min-width: 1024px) {
        .courses-desktop figure .courses-stamps {
          bottom: 60px;
          left: 100px; } }
  .courses-desktop .courses-info {
    display: flex;
    flex-flow: column wrap;
    justify-content: space-evenly;
    width: 70%; }

.courses-page .course-teacher-header {
  align-items: center;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around; }
  .courses-page .course-teacher-header .course-teacher-content {
    display: flex;
    flex-flow: column wrap; }
    @media screen and (min-width: 1024px) {
      .courses-page .course-teacher-header .course-teacher-content {
        justify-content: space-around;
        align-items: center; } }
  @media screen and (min-width: 1024px) {
    .courses-page .course-teacher-header .searchbar {
      margin: auto;
      max-width: 500px;
      width: 40%; } }

.courses-page .input-group {
  margin-bottom: 43px; }
  .courses-page .input-group .searchbar-input {
    border-right: none;
    height: 58px; }
  .courses-page .input-group .input-group-text {
    background-color: #fff;
    border-left: none;
    height: 58px; }

.courses-page .course-info {
  display: flex;
  flex-flow: column wrap;
  justify-content: space-between; }
  @media screen and (min-width: 768px) {
    .courses-page .course-info {
      margin-left: 3rem;
      width: 60%; } }
  .courses-page .course-info .course-info-subtitle {
    font-size: 0.5em;
    margin-left: 8px; }
  @media screen and (min-width: 768px) {
    .courses-page .course-info .progress {
      width: 35%; } }
  @media screen and (min-width: 768px) {
    .courses-page .course-info .course-info-tasks {
      width: 35%; } }
  .courses-page .course-info .course-info-tasks .course-info-percent {
    color: #4e2d78;
    font-size: 1.3em; }
  .courses-page .course-info .btn-success {
    background-color: #79b100; }
    @media screen and (min-width: 768px) {
      .courses-page .course-info .btn-success {
        width: 50%; } }

.courses-page .book-courses {
  display: flex;
  justify-content: end;
  margin-bottom: 100px;
  width: 100%; }
  @media screen and (min-width: 1024px) {
    .courses-page .book-courses {
      flex-flow: row wrap; } }

.courses-page .book-courses.teacher-card .YC-CourseCard {
  width: 100%; }

.courses-page .yconnect-course {
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover; }

.courses-page .YC-CourseLink {
  cursor: pointer;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin-bottom: 30px;
  width: 80%; }
  @media screen and (min-width: 768px) {
    .courses-page .YC-CourseLink {
      width: calc(40% - 5px); } }
  @media screen and (min-width: 1024px) {
    .courses-page .YC-CourseLink {
      width: calc(24% - 5px); } }

.courses-page .YC-CourseCard {
  width: 80%; }
  @media screen and (min-width: 768px) {
    .courses-page .YC-CourseCard {
      width: calc(40% - 5px); } }
  @media screen and (min-width: 1024px) {
    .courses-page .YC-CourseCard {
      width: calc(24% - 5px); } }

.courses-page .download-menu.download-tab {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -o-user-select: none;
  max-height: 300px !important;
  overflow-y: scroll; }
  @media screen and (min-width: 1440px) {
    .courses-page .download-menu.download-tab {
      max-height: 450px !important; } }

.courses-page .download-menu .download-title {
  max-width: 420px;
  overflow: hidden !important;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap; }

.courses-page .download-menu .download-link {
  align-items: baseline;
  display: flex;
  flex-flow: row nowrap; }
  .courses-page .download-menu .download-link:hover {
    color: #79b100; }
  .courses-page .download-menu .download-link img {
    padding-left: 16px;
    width: 30px; }

.courses-page .lateral-header-course {
  padding: 18px 16px 34px;
  overflow-y: scroll;
  z-index: 9999; }
  @media screen and (min-width: 1024px) {
    .courses-page .lateral-header-course {
      overflow-y: hidden; } }
  .courses-page .lateral-header-course .download-mobile .book {
    border-bottom: 1px solid #79b100;
    margin-bottom: 30px; }
  .courses-page .lateral-header-course .download-mobile .book-row {
    border-bottom: .3px solid #C5CBCC;
    padding: 16px 0; }
    .courses-page .lateral-header-course .download-mobile .book-row span {
      font-weight: bold; }
    .courses-page .lateral-header-course .download-mobile .book-row small {
      font-size: 13px; }

.lateral-audio {
  z-index: 99999 !important; }
  .lateral-audio .audios {
    height: 80vh;
    overflow-y: auto; }
    .lateral-audio .audios .audio-task {
      align-items: center;
      border-bottom: 1px solid #c9c9c9;
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      margin: 16px 0px; }
      .lateral-audio .audios .audio-task .audio-task--player {
        width: 70%; }
        .lateral-audio .audios .audio-task .audio-task--player .audio-title {
          margin: 0;
          max-width: 250px;
          overflow: hidden !important;
          text-decoration: none;
          text-overflow: ellipsis;
          white-space: nowrap; }
      .lateral-audio .audios .audio-task .audio-task--download {
        align-self: center;
        color: #79b100;
        display: flex;
        justify-content: flex-end;
        position: relative;
        top: 5px;
        width: 30%; }
        .lateral-audio .audios .audio-task .audio-task--download img {
          padding-left: 8px; }
    .lateral-audio .audios .text-muted {
      font-size: 0.75rem; }

.recommended {
  border: 2px solid #4e2d78;
  flex-direction: column; }
  @media screen and (min-width: 768px) {
    .recommended {
      flex-direction: row; } }
  @media screen and (min-width: 768px) {
    .recommended .recommended-content {
      width: 70%; } }
  @media screen and (min-width: 1024px) {
    .recommended .recommended-content {
      padding: 0 32px; } }
  .recommended .recommended-content .content-header {
    width: 100%; }
  .recommended .recommended-photo {
    width: 30%; }
    .recommended .recommended-photo img {
      height: 248px;
      width: 220px; }
  .recommended .recommended-buttons {
    align-items: center;
    justify-content: space-between;
    display: flex;
    flex-flow: row wrap; }

.home-teacher-books {
  display: flex;
  flex-flow: column wrap;
  height: 500px;
  overflow-x: scroll; }
  @media screen and (min-width: 1024px) {
    .home-teacher-books {
      height: auto; } }

.home-tags {
  align-items: center;
  display: flex;
  flex-flow: row wrap; }
  .home-tags img {
    align-self: center; }
  .home-tags .tag {
    height: auto;
    margin: 0 16px;
    width: 60px; }
    .home-tags .tag figure {
      text-align: center;
      width: 100%; }
      .home-tags .tag figure img {
        width: 60px;
        height: auto; }

.home-page .recommended-card {
  border: 2px solid #643e94; }

.home-page .home-title {
  margin: 0 0 32px; }
  @media screen and (min-width: 768px) {
    .home-page .home-title {
      margin: 24px 0; } }

.home-page .courses-desktop .text-muted {
  color: #989898;
  font-size: 0.75rem;
  display: block; }

.home-page .courses-desktop figure {
  display: flex;
  flex-flow: row wrap;
  width: 35%; }
  .home-page .courses-desktop figure img {
    object-fit: contain;
    height: 180px;
    width: 180px; }

.home-page .courses-desktop .courses-info {
  width: 65%; }

.home-page .lateral-scroll-books {
  display: flex;
  margin-bottom: 24px; }
  @media screen and (min-width: 1024px) {
    .home-page .lateral-scroll-books {
      height: auto; } }

.home-page .YC-CourseLink {
  margin: 0 16px 0 0;
  width: 80%; }
  .home-page .YC-CourseLink:last-child {
    margin: 0; }
  @media screen and (min-width: 768px) {
    .home-page .YC-CourseLink {
      width: 40%; } }
  @media screen and (min-width: 1024px) {
    .home-page .YC-CourseLink {
      width: 30%; } }
  .home-page .YC-CourseLink .YC-CourseCard {
    width: 100%; }

.lateral-progress-enter {
  right: 0;
  transform: translate3d(100vw, 0, 0);
  width: 80%; }
  @media screen and (min-width: 768px) {
    .lateral-progress-enter {
      width: 50%; } }

.lateral-progress-enter-active,
.lateral-progress-enter-done {
  left: 0;
  transform: translate3d(0vw, 0, 0);
  transition: transform 0.8s cubic-bezier(0, 0.52, 0, 1);
  width: 100%; }
  @media screen and (min-width: 768px) {
    .lateral-progress-enter-active,
    .lateral-progress-enter-done {
      left: auto;
      right: 0;
      width: 50%; } }

.lateral-progress-exit {
  right: 0;
  transform: translate3d(100vw, 0, 0); }
  @media screen and (min-width: 768px) {
    .lateral-progress-exit {
      width: 50%; } }

.lateral-progress-exit-active,
.lateral-progress-exit-done {
  transform: translate3d(100vw, 0, 0);
  transition: transform 0.8s cubic-bezier(0, 0.52, 0, 1); }

.login {
  display: flex;
  flex-flow: column wrap;
  width: 100%;
  min-height: calc(90vh);
  height: auto;
  top: 0 !important; }
  .login .bg-login {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) !important;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center; }
    @media screen and (min-width: 1024px) {
      .login .bg-login {
        width: 100%;
        background-position: center; } }
    @media screen and (min-width: 1400px) {
      .login .bg-login {
        width: 100%;
        background-position: 100% 100%; } }
  .login .content-container {
    display: flex;
    flex-direction: column;
    margin-bottom: 0px;
    justify-content: center; }
    @media screen and (min-width: 1024px) {
      .login .content-container {
        flex-direction: row;
        margin-bottom: 30px; } }
  .login .header-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center; }
    .login .header-container .header-logo {
      height: 36px;
      margin: 40px 0;
      width: 134px;
      align-self: center; }
    .login .header-container .header-separator {
      display: none; }
    .login .header-container .login-body-title {
      margin: 0 0 20px 0;
      text-align: center;
      font-size: 1.5rem; }
      .login .header-container .login-body-title strong {
        font-size: 1.5rem; }
    @media screen and (min-width: 1024px) {
      .login .header-container {
        flex-direction: row;
        text-align: left; }
        .login .header-container .header-separator {
          display: block;
          margin: 40px 20px;
          width: 1px;
          height: 40px;
          background: #50575938; }
        .login .header-container .header-logo {
          height: 48px;
          width: 180px; }
        .login .header-container .login-body-title {
          font-size: 2rem;
          margin: 40px 0px; }
          .login .header-container .login-body-title strong {
            font-size: 2rem; } }
  .login .login-body {
    width: 100%;
    height: 420px;
    padding: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: #FFFFFF; }
    @media screen and (min-width: 1024px) {
      .login .login-body {
        width: 400px; } }
    .login .login-body .login-label {
      font-size: 1.2rem;
      width: 100%;
      text-align: center;
      font-weight: 500; }
      .login .login-body .login-label strong {
        font-size: 1.2rem; }
      @media screen and (min-width: 1024px) {
        .login .login-body .login-label {
          font-size: 1.5rem; }
          .login .login-body .login-label strong {
            font-size: 1.5rem; } }
    .login .login-body .login-form {
      background: #fff;
      padding: 16px; }
      @media screen and (min-width: 768px) {
        .login .login-body .login-form {
          height: 100%;
          width: 35%; } }
      @media screen and (min-width: 1024px) {
        .login .login-body .login-form {
          margin-left: 18%;
          margin-right: 60px;
          max-width: 286px;
          padding: 0;
          width: 36%; } }
    .login .login-body .form-group {
      margin-bottom: 40px; }
    .login .login-body .form-group:first-child {
      margin-top: 40px; }
  @media screen and (min-width: 1024px) {
    .login {
      flex-flow: row nowrap; } }
  .login-forgot {
    color: #79b100;
    font-weight: bold;
    position: relative;
    text-decoration: none;
    top: -29px; }
    @media screen and (min-width: 1024px) {
      .login-forgot {
        top: -40px; } }
  .login .placement-link-container {
    width: 100%;
    height: 200px;
    padding: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: #FFFFFF; }
    @media screen and (min-width: 1024px) {
      .login .placement-link-container {
        width: 400px; } }
    .login .placement-link-container .placement-label {
      font-size: 1.2rem;
      text-align: center; }
      .login .placement-link-container .placement-label strong {
        font-size: 1.2rem; }
      @media screen and (min-width: 1024px) {
        .login .placement-link-container .placement-label {
          font-size: 1.5rem; }
          .login .placement-link-container .placement-label strong {
            font-size: 1.5rem; } }
    .login .placement-link-container button {
      align-self: center; }
  .login .optional-features {
    margin-top: 20px;
    margin-left: 0px; }
    @media screen and (min-width: 1024px) {
      .login .optional-features {
        margin-top: 0px;
        margin-left: 50px; } }

.login-footer-yconnect {
  width: 100%;
  align-items: center;
  display: flex;
  height: 80px;
  flex-flow: row wrap;
  justify-content: center;
  background-color: #FFFFFF; }
  .login-footer-yconnect .logo-gse {
    width: 70px; }
  .login-footer-yconnect .logo-separator {
    background: #50575938;
    display: flex;
    flex-flow: row wrap;
    height: 30px;
    justify-content: center;
    text-align: center;
    margin: 0 24px;
    width: 1px; }
    @media screen and (min-width: 1024px) {
      .login-footer-yconnect .logo-separator {
        margin: 0 40px; } }
  .login-footer-yconnect .logo-yazigi {
    width: 80px; }

.login-footer-pearson {
  align-items: center;
  background-color: #505759;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  min-height: 64px;
  width: 100%; }
  @media screen and (min-width: 1024px) {
    .login-footer-pearson {
      margin-top: 0; } }
  .login-footer-pearson .logo-pearson {
    margin-left: 16px;
    width: 110px; }
    @media screen and (min-width: 1024px) {
      .login-footer-pearson .logo-pearson {
        margin-left: 18%;
        width: 132px; } }
  .login-footer-pearson .logo-always {
    margin-right: 16px;
    width: 120px; }
    @media screen and (min-width: 1024px) {
      .login-footer-pearson .logo-always {
        margin-right: 18%; } }

#forgotPassword {
  padding: 20px;
  margin: 0 !important; }
  @media screen and (min-width: 1024px) {
    #forgotPassword {
      margin-left: 10px !important; } }

.users-table {
  padding: 16px; }
  @media screen and (min-width: 768px) {
    .users-table {
      padding: 40px; } }
  .users-table .users-table-header {
    align-items: center;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between; }
    .users-table .users-table-header .header-options {
      width: 100%; }
      @media (min-width: 768px) {
        .users-table .users-table-header .header-options {
          padding: 0 8px;
          width: 25%; }
          .users-table .users-table-header .header-options:first-child {
            padding: 0 8px 0 0; }
          .users-table .users-table-header .header-options:last-child {
            padding: 0 0 0 8px; } }
      @media (min-width: 1024px) {
        .users-table .users-table-header .header-options {
          width: 19%; } }
    .users-table .users-table-header .header-filter {
      align-items: center;
      display: flex;
      flex-flow: row nowrap; }
    .users-table .users-table-header .user-profile-filter {
      display: none; }
      @media screen and (min-width: 768px) {
        .users-table .users-table-header .user-profile-filter {
          display: flex;
          width: 30%; }
          .users-table .users-table-header .user-profile-filter .form-group {
            width: 50%; } }
    .users-table .users-table-header .search-filter {
      width: 100%; }
      @media screen and (min-width: 768px) {
        .users-table .users-table-header .search-filter {
          display: flex;
          width: 30%; } }
    .users-table .users-table-header .btn-table-header {
      bottom: 12px;
      position: relative; }
    .users-table .users-table-header .user-pagination {
      align-items: center;
      display: none; }
      @media screen and (min-width: 768px) {
        .users-table .users-table-header .user-pagination {
          display: flex;
          flex-flow: row wrap;
          justify-content: flex-end; } }
  .users-table .users-table-name {
    align-items: center;
    display: flex;
    flex-flow: row wrap; }
  .users-table .users-table-icon {
    width: 30px;
    margin-right: 8px; }
  .users-table .users-dropdown button {
    background-color: transparent !important;
    border: none;
    color: #79b100 !important;
    padding: 0; }
    .users-table .users-dropdown button:active, .users-table .users-dropdown button:focus {
      border: none !important;
      box-shadow: none !important; }
  @media screen and (max-width: 1024px) {
    .users-table .users-dropdown .dropdown-menu-right {
      box-shadow: 1px 1px 8px 0 rgba(0, 0, 0, 0.31) !important;
      border-radius: 8px;
      transform: translate3d(0, 25px, 0px) !important;
      top: -10px; } }
  .users-table .users-dropdown .dropdown-item {
    align-items: center;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start; }
  .users-table .select-page {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-end;
    margin-top: 32px;
    width: 100%; }
    .users-table .select-page-label {
      margin-bottom: 8px;
      width: 100%; }
    @media screen and (min-width: 1024px) {
      .users-table .select-page {
        margin-top: 46px; } }
    .users-table .select-page-formgroup {
      width: 100%; }
      @media screen and (min-width: 1024px) {
        .users-table .select-page-formgroup {
          width: 25%; } }

.messages .inbox-header {
  align-items: center;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin-bottom: 24px;
  padding: 0 11px; }
  .messages .inbox-header .email-input {
    display: none; }
    @media screen and (min-width: 1024px) {
      .messages .inbox-header .email-input {
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        height: 42px;
        margin-top: 8px;
        width: 40%; } }

.messages .email-filter {
  align-items: baseline;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-end;
  width: 100%; }
  @media screen and (min-width: 1024px) {
    .messages .email-filter {
      width: 60%; } }
  .messages .email-filter .searchbar {
    margin: 0 0 0 auto;
    max-width: 350px; }
    .messages .email-filter .searchbar .searchbar-input {
      height: 56px; }
      .messages .email-filter .searchbar .searchbar-input::placeholder {
        font-size: 14px; }
    .messages .email-filter .searchbar img {
      height: 20px;
      position: absolute;
      right: 15px;
      top: 18px;
      width: 20px;
      z-index: 5; }
      @media screen and (min-width: 1024px) {
        .messages .email-filter .searchbar img {
          top: 15px; } }

.messages .pagination-footer {
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  margin-top: 46px; }
  .messages .pagination-footer .select-page {
    margin-left: 30px;
    width: 100%; }
    @media screen and (min-width: 1024px) {
      .messages .pagination-footer .select-page {
        width: 25%; } }
    .messages .pagination-footer .select-page:after {
      content: "";
      display: table;
      clear: both; }

@media screen and (min-width: 1024px) {
  .messages .pagination {
    margin-left: 25px; } }

.messages .message-body {
  max-width: 350px; }

.messages .message-mobile-body {
  width: 70%; }
  .messages .message-mobile-body .mobile-body-header {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    margin-bottom: 8px; }
  .messages .message-mobile-body .message-author {
    color: #565656 !important;
    font-size: 0.75rem; }
  .messages .message-mobile-body .mobile-body-message {
    color: #565656 !important;
    font-size: 0.75rem;
    font-weight: bold;
    text-decoration: none;
    margin-top: 16px; }

.message-page-title {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between; }

.option-message {
  min-height: 48px;
  width: 100%; }
  .option-message .recipient-message {
    width: 100%; }
  .option-message .message__control {
    align-items: center;
    border: 0;
    min-height: 56px;
    padding-top: 4px; }
  .option-message .message__multi-value {
    background: #fff;
    border-radius: 40px;
    border: #79b100 1px solid;
    padding: 0 7px; }
  .option-message .message__multi-value__remove:hover {
    background-color: transparent;
    cursor: pointer; }

.message-page-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px; }
  .message-page-actions .btn-delete {
    margin: 0 16px 16px 0; }
  @media screen and (min-width: 1024px) {
    .message-page-actions {
      padding-right: 15px; }
      .message-page-actions .btn-delete {
        margin-right: 20px; } }

.YC-messageById .message-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.11);
  display: flex;
  flex-flow: row wrap;
  padding: 16px; }
  @media screen and (min-width: 1024px) {
    .YC-messageById .message-header {
      padding: 40px 40px 0; } }
  .YC-messageById .message-header .message-header-photo {
    width: 50px;
    border-radius: 50%; }

.YC-messageById .message-header-info {
  display: flex;
  flex-flow: column wrap;
  margin-left: 16px; }
  .YC-messageById .message-header-info .userinfo {
    font-size: 14px; }
    .YC-messageById .message-header-info .userinfo .email {
      color: #989898;
      font-size: 0.75rem;
      display: block;
      margin: 0; }

.YC-messageById .users {
  color: #989898;
  font-size: 0.75rem;
  width: 100%; }
  @media screen and (min-width: 1024px) {
    .YC-messageById .users {
      font-size: 0.85rem; } }

.YC-messageById .header-datetime {
  color: #989898;
  font-size: 0.75rem;
  margin: 0 0 0 auto; }

.YC-messageById .message-body {
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.11); }
  @media screen and (min-width: 1024px) {
    .YC-messageById .message-body {
      max-width: 100%;
      padding: 40px; } }

.YC-messageById .message-reply {
  padding: 16px; }
  @media screen and (min-width: 1024px) {
    .YC-messageById .message-reply {
      padding: 40px; } }
  .YC-messageById .message-reply::after {
    content: '';
    border: .3px solid #C5CBCC;
    left: 0;
    margin: 24px 0;
    position: absolute;
    width: 100%; }

@media screen and (min-width: 1024px) {
  .YC-messageById .message-reply--btn {
    justify-content: flex-end;
    padding: 30px 40px; } }

@media screen and (min-width: 1024px) {
  .YC-messageById footer {
    padding: 30px 40px 40px; } }

.YC-messageById .message-reply .reply-to label {
  align-items: center;
  display: flex;
  width: 100px; }

.YC-messageById .message-reply .reply-to .message__control {
  align-items: center; }

.lateral-header-messages {
  margin-right: 0;
  overflow-y: scroll;
  width: 100% !important; }
  @media screen and (min-width: 1024px) {
    .lateral-header-messages {
      width: 50% !important; } }
  .lateral-header-messages .header-messages-btn {
    max-width: 85px; }

.online-teacher {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin: 0 0 60px !important; }

@media screen and (min-width: 768px) {
  .chat-text {
    max-width: 460px; } }

.chat-text-title {
  margin-bottom: 16px; }

.chat-text-subtitle {
  margin-bottom: 24px; }

.chat-text-cta {
  align-items: center;
  bottom: 0;
  border-top: 1px solid #4e2d78;
  display: flex;
  flex-flow: column wrap;
  left: 0px;
  padding: 8px 0;
  position: fixed;
  text-align: center;
  width: 100vw;
  z-index: 5; }
  @media screen and (min-width: 768px) {
    .chat-text-cta {
      align-items: flex-start;
      border: none;
      background-color: transparent;
      position: initial;
      width: auto; } }
  .chat-text-cta .btn-success {
    margin-top: 16px; }
  .chat-text-cta .chat-direct-message {
    align-items: center;
    display: flex;
    flex-flow: row wrap; }

.chat-schedule {
  border: 1px solid #4e2d78;
  border-radius: 8px;
  font-size: 13px;
  padding: 16px; }
  @media screen and (min-width: 768px) {
    .chat-schedule {
      max-width: 396px; } }
  @media screen and (min-width: 1024px) {
    .chat-schedule {
      max-height: 243px;
      width: 396px; } }
  .chat-schedule .text-secondary, .chat-schedule b {
    font-size: 13px; }
  .chat-schedule .text-secondary:last-child {
    margin-bottom: 16px; }
  .chat-schedule .chat-schedule-title {
    font-weight: bold;
    margin-bottom: 16px; }

.profile {
  min-height: 460px; }
  .profile .profile-picture {
    align-items: center;
    display: flex;
    flex-flow: column wrap;
    justify-content: start; }
    @media screen and (min-width: 1024px) {
      .profile .profile-picture {
        border-right: 2px solid #e8e8e8;
        width: 25%; } }
    .profile .profile-picture .profile-picture--updatePhoto {
      margin-bottom: 20px; }
  .profile .profile-tabs {
    width: 100%; }
    @media screen and (min-width: 1024px) {
      .profile .profile-tabs {
        width: 75%; } }
    .profile .profile-tabs .nav-tabs {
      justify-content: space-between; }
    .profile .profile-tabs .form-component {
      margin-bottom: 16px; }
    .profile .profile-tabs .control-label {
      color: #79b100;
      font-weight: bold; }
    .profile .profile-tabs .row {
      justify-content: flex-start; }
    .profile .profile-tabs .col-1 {
      margin-right: 8px;
      max-width: calc(8.33333% - 8px); }
    .profile .profile-tabs .col-2 {
      margin-right: 8px;
      max-width: calc(16.66667% - 8px); }
    .profile .profile-tabs .col-3 {
      margin-right: 8px;
      max-width: calc(25.0% - 8px); }
    .profile .profile-tabs .col-4 {
      margin-right: 8px;
      max-width: calc(33.33333% - 8px); }
    .profile .profile-tabs .col-5 {
      margin-right: 8px;
      max-width: calc(41.66667% - 8px); }
    .profile .profile-tabs .col-6 {
      margin-right: 8px;
      max-width: calc(50.0% - 8px); }
    .profile .profile-tabs .col-7 {
      margin-right: 8px;
      max-width: calc(58.33333% - 8px); }
    .profile .profile-tabs .col-8 {
      margin-right: 8px;
      max-width: calc(66.66667% - 8px); }
    .profile .profile-tabs .col-9 {
      margin-right: 8px;
      max-width: calc(75.0% - 8px); }
    .profile .profile-tabs .col-10 {
      margin-right: 8px;
      max-width: calc(83.33333% - 8px); }
    .profile .profile-tabs .col-11 {
      margin-right: 8px;
      max-width: calc(91.66667% - 8px); }
    .profile .profile-tabs .col-12 {
      margin-right: 8px;
      max-width: calc(100.0% - 8px); }
    .profile .profile-tabs .form-group {
      margin-bottom: 0; }
    .profile .profile-tabs .gender-btn .btn-radio {
      align-items: center;
      display: flex;
      flex-flow: row wrap;
      font-size: 12px;
      justify-content: center;
      padding: 8px;
      width: 30%; }
    .profile .profile-tabs .gender-btn .isInvalidRadio {
      border-color: #f00; }
    .profile .profile-tabs .profile-reset-password {
      align-items: baseline;
      display: flex;
      flex-flow: row wrap; }

.btn-profile {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-end;
  align-items: right !important; }

@media screen and (min-width: 1024px) {
  .reportsPage .YC-CourseCard {
    margin: 15px !important;
    width: calc(25% - 30px); } }

.support {
  display: flex;
  flex-flow: column wrap;
  justify-content: space-between; }
  @media screen and (min-width: 1024px) {
    .support {
      flex-direction: row; } }
  @media screen and (max-width: 1023px) {
    .support .support-info::after {
      content: '';
      border: .3px solid #C5CBCC;
      left: 0;
      margin: 24px 0;
      position: absolute;
      width: 100%; } }
  @media screen and (min-width: 1024px) {
    .support .support-info {
      width: 40%; } }
  .support .support-form {
    margin-top: 58px; }
    @media screen and (min-width: 1024px) {
      .support .support-form {
        margin-top: 0;
        width: 50%; } }
    .support .support-form .support-recaptcha {
      margin-bottom: 24px; }
    .support .support-form .text-muted {
      color: #989898 !important;
      margin-bottom: 32px; }
      @media screen and (min-width: 1024px) {
        .support .support-form .text-muted {
          margin-bottom: 0; } }

.travel .col-md-8 {
  margin-right: 8px;
  max-width: calc(66.666667% - 8px); }

.travel-world {
  display: flex;
  flex-flow: column wrap;
  justify-content: space-between; }
  .travel-world .travel-subtitle {
    margin: 0 0 16px 0; }
    .travel-world .travel-subtitle::after {
      content: '';
      border: .3px solid #C5CBCC;
      left: 0;
      margin: 30px 0;
      position: absolute;
      width: 100%; }
  @media screen and (min-width: 768px) {
    .travel-world .countries-list {
      width: 50%; } }
  .travel-world .world-map {
    display: none; }
    @media screen and (min-width: 1024px) {
      .travel-world .world-map {
        display: inline; } }

.travel-profile {
  margin: 1rem; }
  @media screen and (min-width: 768px) {
    .travel-profile {
      margin: 0; } }

.dropdown-continent {
  background-color: #FFFFFF;
  border-radius: 8px;
  box-shadow: 1px 1px 8px 0 rgba(0, 0, 0, 0.31);
  padding: 8px;
  position: absolute; }
  .dropdown-continent.northAmerica-dropdown {
    transform: translate(150px, 330px); }
  .dropdown-continent.centralAmerica-dropdown {
    transform: translate(200px, 390px); }
  .dropdown-continent.southAmerica-dropdown {
    transform: translate(150px, 490px); }
  .dropdown-continent.europe-dropdown {
    transform: translate(380px, 320px); }
  .dropdown-continent.africa-dropdown {
    transform: translate(350px, 420px); }
  .dropdown-continent.asia-dropdown {
    transform: translate(550px, 385px); }
  .dropdown-continent.oceania-dropdown {
    transform: translate(520px, 505px); }
  .dropdown-continent .continent-title {
    color: #989898;
    font-size: 0.75rem;
    margin-right: 16px; }
  .dropdown-continent .continent-close {
    position: relative;
    top: -4px; }
  .dropdown-continent .continent-countries {
    margin: 8px 0;
    max-height: 200px;
    min-width: 160px;
    overflow: auto; }
    .dropdown-continent .continent-countries > span {
      display: block; }

.final-score > .card {
  width: calc(100% + 16px); }

.final-score .title,
.final-score .subtitle {
  width: 33.333%; }

.final-score .title {
  font-size: 1rem;
  font-weight: bold; }

.final-score .subtitle {
  color: #989898;
  font-size: .75rem; }

.score-header {
  align-items: flex-start;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin: 32px 0 32px 0; }
  @media screen and (min-width: 1024px) {
    .score-header {
      align-items: flex-end;
      flex-flow: row-reverse; } }
  .score-header .score-filter {
    align-items: baseline;
    display: flex;
    flex-flow: row wrap;
    margin-top: 16px;
    width: 100%; }
    @media screen and (min-width: 1024px) {
      .score-header .score-filter {
        justify-content: flex-end;
        width: 65%; } }
  .score-header .header-cta {
    width: 100%; }
    @media screen and (min-width: 1024px) {
      .score-header .header-cta {
        width: 40%; } }
    @media screen and (min-width: 1024px) {
      .score-header .header-cta .btn:last-child {
        margin-left: 20px; } }
  @media screen and (min-width: 1024px) {
    .score-header .header-student {
      width: 100% !important; } }
  @media screen and (min-width: 1024px) {
    .score-header .grade-sending {
      width: 40% !important; } }
  .score-header .btn-rounded {
    border: 2px solid #79b100;
    border-radius: 20px;
    color: #79b100;
    height: 42px;
    margin: 0 16px 0 0;
    width: 170px; }
  .score-header .header-filter {
    width: 60%; }
    .score-header .header-filter .filter-label {
      align-self: center; }
    .score-header .header-filter .form-group {
      margin-bottom: 0;
      padding-bottom: 0;
      width: 25%; }

.score-table .task-link a {
  color: #79b100; }

.learning-track .font-20 div {
  font-size: 1.25rem; }

.learning-track .learning-class {
  align-self: center;
  top: 8px; }
  .learning-track .learning-class div {
    font-size: 1.25rem; }

.learning-track .learning-row {
  margin-left: -8px !important;
  margin-right: -8px !important; }

.learning-track .next-reenroll {
  font-size: 0.75rem; }
  .learning-track .next-reenroll b,
  .learning-track .next-reenroll span {
    font-size: 0.75rem; }

.learning-track .learning-card-name {
  font-size: 1.125rem;
  color: #5C3989;
  font-weight: bold;
  width: 100%;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis; }

.learning-track .learning-card-current {
  font-size: 0.8125rem;
  font-weight: bold;
  flex: 1; }

.learning-track .learning-card-started {
  font-weight: bold;
  font-size: 0.75rem; }
  .learning-track .learning-card-started div {
    font-size: 0.75rem; }

.learning-track .learning-card-porcent .learning-card-porcent-border {
  height: 5rem;
  width: 5rem;
  border-radius: 5rem; }
  .learning-track .learning-card-porcent .learning-card-porcent-border .learning-card-porcent-circle {
    border: 1px #C8CA2A solid;
    position: relative;
    width: 100%;
    border-radius: 3rem; }
    .learning-track .learning-card-porcent .learning-card-porcent-border .learning-card-porcent-circle .learning-card-porcent-value {
      color: #5F3B8D;
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%; }
      .learning-track .learning-card-porcent .learning-card-porcent-border .learning-card-porcent-circle .learning-card-porcent-value div {
        text-align: center;
        background: white;
        border-radius: 2rem;
        height: 3rem;
        width: 3rem;
        padding: 0.8rem 0.4rem;
        font-size: 0.875rem; }

/*
@-moz-keyframes loader-aaa {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

@-webkit-keyframes loader-aaa {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

@keyframes loader-aaa {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
*/
.pie {
  border-radius: 100%;
  height: calc(var(--size, 5) * 1rem);
  overflow: hidden;
  width: calc(var(--size, 5) * 1rem);
  position: absolute; }

.pie__segment {
  --a: calc(var(--over50, 0) * -100%);
  --b: calc((1 + var(--over50, 0)) * 100%);
  --degrees: calc((var(--offset, 0) / 100) * 360);
  -webkit-clip-path: polygon(var(--a) var(--a), var(--b) var(--a), var(--b) var(--b), var(--a) var(--b));
  clip-path: polygon(var(--a) var(--a), var(--b) var(--a), var(--b) var(--b), var(--a) var(--b));
  height: 100%;
  position: absolute;
  -webkit-transform: translate(0, -50%) rotate(90deg) rotate(calc(var(--degrees) * 1deg));
  transform: translate(0, -50%) rotate(90deg) rotate(calc(var(--degrees) * 1deg));
  -webkit-transform-origin: 50% 100%;
  transform-origin: 50% 100%;
  width: 100%; }

.pie__segment:after,
.pie__segment:before {
  background: var(--bg, #000);
  content: '';
  height: 100%;
  position: absolute;
  width: 100%; }

.pie__segment:before {
  --degrees: calc((var(--value, 45) / 100) * 360);
  -webkit-transform: translate(0, 100%) rotate(calc(var(--degrees) * 1deg));
  transform: translate(0, 100%) rotate(calc(var(--degrees) * 1deg));
  -webkit-transform-origin: 50% 0%;
  transform-origin: 50% 0%; }

.pie__segment:after {
  opacity: var(--over50, 0); }

.select-period {
  width: 100%; }
  @media (min-width: 768px) {
    .select-period {
      padding: 0 0px !important;
      width: 45% !important; } }

.select-period-resource {
  width: 100%; }
  @media (min-width: 768px) {
    .select-period-resource {
      padding: 0 0px !important;
      width: 100% !important;
      display: flex;
      justify-content: flex-end;
      margin-top: 15px; } }

.is-hidden {
  display: none !important; }

.deco-none {
  text-decoration: none; }
  .deco-none:hover {
    text-decoration: none; }

.pointer {
  cursor: pointer; }

.w-10 {
  width: 10% !important; }

.w-20 {
  width: 20% !important; }

.w-30 {
  width: 30% !important; }

.w-40 {
  width: 40% !important; }

.w-50 {
  width: 50% !important; }

.w-60 {
  width: 60% !important; }

.w-70 {
  width: 70% !important; }

.w-80 {
  width: 80% !important; }

.w-90 {
  width: 90% !important; }

.w-100 {
  width: 100% !important; }

.lateral-scroll-books {
  max-height: 500px;
  overflow-x: scroll;
  overflow-y: hidden;
  flex-flow: column wrap; }
  @media screen and (min-width: 1024px) {
    .lateral-scroll-books {
      height: 100%;
      flex-flow: row wrap;
      max-height: none;
      overflow-x: hidden; } }

.rotate {
  transition: all 0.3s ease; }

.rotate.down {
  transform: rotate(180deg); }

.react-datepicker-popper {
  z-index: 3 !important; }

input[type=checkbox] {
  -webkit-appearance: none;
  border: 1px solid #4e2d78;
  padding: inherit;
  border-radius: 3px;
  display: inline-block;
  position: relative;
  color: #4e2d78; }
  input[type=checkbox]:checked:after {
    content: "\\2714";
    font-size: 20px;
    position: absolute;
    left: 4px;
    top: -3px; }
`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./node_modules/react-image-crop/lib/ReactCrop.scss","webpack://./src/Sass/tools/_tools.scss","webpack://./src/Sass/generic/_generic.scss","webpack://./src/Sass/settings/_settings.scss","webpack://./src/Sass/objects/_YC-Checkbox.scss","webpack://./src/Sass/objects/_YC-InputPassword.scss","webpack://./src/Sass/objects/_YC-Modal.scss","webpack://./src/Sass/objects/_YC-Table.scss","webpack://./src/Sass/components/_YC-BookCard.scss","webpack://./src/Sass/components/_YC-Footer.scss","webpack://./src/Sass/components/_YC-Lateral.scss","webpack://./src/Sass/components/_YC-Loader.scss","webpack://./src/Sass/components/_YC-Modal.scss","webpack://./src/Sass/components/_YC-SearchBar.scss","webpack://./src/Sass/components/_YC-ProfileCard.scss","webpack://./src/Sass/components/_YC-Pagination.scss","webpack://./src/Sass/components/_YC-ProgressBar.scss","webpack://./src/Sass/components/_YC-Tag.scss","webpack://./src/Sass/pages/_YC-About.scss","webpack://./src/Sass/pages/_YC-Country.scss","webpack://./src/Sass/pages/_YC-Courses.scss","webpack://./src/Sass/pages/_YC-Home.scss","webpack://./src/Sass/pages/_YC-Login.scss","webpack://./src/Sass/pages/_YC-ManageUsers.scss","webpack://./src/Sass/pages/_YC-Messages.scss","webpack://./src/Sass/pages/_YC-OnlineTeacher.scss","webpack://./src/Sass/pages/_YC-Profile.scss","webpack://./src/Sass/pages/_YC-ReportsPage.scss","webpack://./src/Sass/pages/_YC-Support.scss","webpack://./src/Sass/pages/_YC-TravelWorld.scss","webpack://./src/Sass/pages/_YC-ViewReport.scss","webpack://./src/Sass/trumps/_trumps.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACkBhB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe,EAAA;EALjB;IAQI,aAAa,EAAA;EAGf;IAEE,eAAe,EAAA;EAGjB;IACE,cAAc;IACd,eAAe;IACf,0BAA0B,EAAA;EAG5B;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,+BAA+B;IAC/B,sBAAsB;IACtB,YAAY;IACZ,2CAA2C;IAC3C,0BAA0B;IAW1B,iBAAiB;IACjB,4DAA83D;IAC93D,qBAAqB;IACrB,2BAA2B,EAAA;IAZ3B;MACE,eAAe,EAAA;IAGjB;MACE,kBAAkB;MAClB,kEAAkE,EAAA;EAQtE;IACE,aAAa,EAAA;EAGf;IAIE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,0CAA0C,EAAA;EAG3C;IAGG,UAAU;IACV,YAAY,EAAA;EAJf;IAQG,cAAc;IACd,oBAAoB,EAAA;EATvB;IAaG,cAAc;IACd,wBAAwB,EAAA;EAI3B;IAGG,WAAW;IACX,WAAW,EAAA;EAJd;IAQG,aAAa;IACb,mBAAmB,EAAA;EATtB;IAaG,aAAa;IACb,uBAAuB,EAAA;EAI3B;IACE,kBAAkB,EAAA;IADnB;MAIG,kBAAkB;MAClB,WAAW;MACX,cAAc;MACd,WAvHkB;MAwHlB,YAvHmB;MAwHnB,oCA5G4C;MA6G5C,0CA5GiD;MA6GjD,sBAAsB;MAItB,8BAA8B,EAAA;EA/GpC;IAoHI,MAAM;IACN,OAAO;IACP,gBAA2C;IAC3C,iBAA2C;IAC3C,iBAAiB,EAAA;IAxHrB;MA2HM,MAAM;MACN,OAAO,EAAA;EA5Hb;IAgII,MAAM;IACN,SAAS;IACT,gBAA2C;IAC3C,iBAA2C;IAC3C,gBAAgB,EAAA;IApIpB;MAuIM,MAAM,EAAA;EAvIZ;IA2II,MAAM;IACN,QAAQ;IACR,gBAA2C;IAC3C,kBAA4C;IAC5C,iBAAiB,EAAA;IA/IrB;MAkJM,MAAM;MACN,QAAQ,EAAA;EAnJd;IAuJI,QAAQ;IACR,QAAQ;IACR,gBAA2C;IAC3C,kBAA4C;IAC5C,gBAAgB,EAAA;IA3JpB;MA8JM,QAAQ,EAAA;EA9Jd;IAkKI,SAAS;IACT,QAAQ;IACR,mBAA8C;IAC9C,kBAA4C;IAC5C,iBAAiB,EAAA;IAtKrB;MAyKM,SAAS;MACT,QAAQ,EAAA;EA1Kd;IA8KI,SAAS;IACT,SAAS;IACT,mBAA8C;IAC9C,iBAA2C;IAC3C,gBAAgB,EAAA;IAlLpB;MAqLM,SAAS,EAAA;EArLf;IAyLI,SAAS;IACT,OAAO;IACP,mBAA8C;IAC9C,iBAA2C;IAC3C,iBAAiB,EAAA;IA7LrB;MAgMM,SAAS;MACT,OAAO,EAAA;EAjMb;IAqMI,QAAQ;IACR,OAAO;IACP,gBAA2C;IAC3C,iBAA2C;IAC3C,gBAAgB,EAAA;IAzMpB;MA4MM,OAAO,EAAA;EAMX;IACE,eAAe,EAAA;EAGjB;IACE,kBAAkB,EAAA;IADnB;MAIG,MAAM;MACN,OAAO;MACP,WAAW;MACX,WA3Oa;MA4Ob,gBAAgC,EAAA;IARnC;MAWG,QAAQ;MACR,MAAM;MACN,UAjPa;MAkPb,YAAY;MACZ,kBAAkC,EAAA;IAfrC;MAkBG,SAAS;MACT,OAAO;MACP,WAAW;MACX,WAzPa;MA0Pb,mBAAmC,EAAA;IAtBtC;MAyBG,MAAM;MACN,OAAO;MACP,UA/Pa;MAgQb,YAAY;MACZ,iBAAiC,EAAA;EAIrC;;;IAGE,aAAa,EAAA;EAGf;;;;IAIE,aAAa,EAAA;EAGf;IApQF;;;;MAyQM,aAAa,EAAA;IAGf;MACE,WApRyB;MAqRzB,YApR0B,EAAA,EAqR3B;;ACzRL;EACI,2BAA0B;EAC1B,4CAAwC,EAAA;;AAG5C;EACI,iCAAgC;EAChC,4CAA8C,EAAA;;AAGlD;EACI,0BAAyB;EACzB,4CAAuC,EAAA;;AAG3C;EACI,gCAA+B;EAC/B,4CAA6C,EAAA;;AAIjD;EACI,+BAA8B;EAC9B,4CAA4C,EAAA;;AAIhD;EACI,qCAAoC;EACpC,4CAAkD,EAAA;;AAItD;EACI,gCAA+B;EAC/B,4CAA6C,EAAA;;AAGjD;EACI,yBAAwB;EACxB,4CAAsC,EAAA;;AAG1C;EACI,+BAA8B;EAC9B,4CAA4C,EAAA;;AAGhD;EACI,2BAA0B;EAC1B,6CAAwC,EAAA;;AAG5C;EACI,2BAA0B;EAC1B,6CAAwC,EAAA;;AAG5C;EACI,iCAAgC;EAChC,6CAA8C,EAAA;;AAGlD;EACI,6BAA4B;EAC5B,6CAA0C,EAAA;;AAG9C;EACI,mCAAkC;EAClC,6CAAgD,EAAA;;AAGpD;EACI,8BAA6B;EAC7B,6CAA2C,EAAA;;AAG/C;EACI,oCAAmC;EACnC,6CAAiD,EAAA;;AAGrD;EACI,0BAAyB;EACzB,6CAAuC,EAAA;;AAG3C;EACI,gCAA+B;EAC/B,6CAA6C,EAAA;;AAGjD;EACI,2BAA0B;EAC1B,6CAAgD,EAAA;;AAGpD;EACI,kCAAiC;EACjC,6CAA+C,EAAA;;AAGnD;EACI,sCAAqC;EACrC,6CAAmD,EAAA;;AAGvD;EACI,gCAA+B;EAC/B,6CAA6C,EAAA;;ACpHjD;EACI,sBAAsB;EACtB,eAAe;EACf,SAAS;EACT,UAAU,EAAA;;AAGd;EACI,yBAAyB;EACzB,0DAAkD;EAClD,cAAc;EACd,sCAAsC;EACtC,kBAAkB,EAAA;;AAGtB;EACI,kBAAkB;EAElB,sCAAsC,EAAA;EACtC;IAJJ;MAKQ,gBAAgB;MAChB,iBAAiB;MACjB,MAAM,EAAA,EAEb;;AAED;EACI,sCAAsC;EACtC,6BAA6B,EAAA;EAC7B;IAHJ;MAIQ,aAAa,EAAA,EAEpB;;AAED;EACI,iBAAiB;EACjB,qBAAqB,EAAA;EACrB;IAHJ;MAIQ,mBAAmB;MACnB,qBAAqB,EAAA,EAE5B;;AAED;EACI,oBAAoB;EACpB,oBAAoB,EAAA;EACpB;IAHJ;MAIQ,kBAAkB;MAClB,oBAAoB,EAAA,EAE3B;;AAED;EACI,eAAe;EACf,qBAAqB,EAAA;EACrB;IAHJ;MAIQ,kBAAkB;MAClB,oBAAoB,EAAA,EAE3B;;AAED;EACI,mBAAmB;EACnB,qBAAqB,EAAA;EACrB;IAHJ;MAIQ,oBAAoB;MACpB,sBAAsB,EAAA,EAE7B;;AAED;EACI,cC9DuB;ED+DvB,oBAAoB;EACpB,qBAAqB,EAAA;EACrB;IAJJ;MAKQ,eAAe;MACf,qBAAqB,EAAA,EAE5B;;AAED;EACI,oBAAoB,EAAA;EACpB;IAFJ;MAGQ,mBAAmB,EAAA,EAE1B;;AAED;EACI,mBAAmB,EAAA;;AAGvB;EACI,mBAAmB,EAAA;;AAGvB;EACI,mBAAmB,EAAA;;AElGvB;EACI,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB,EAAA;;AAGvB,wCAAA;AACA;EACI,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;EACR,SAAS,EAAA;;AAIb,6DAAA;AACA;EACI,WAAW;EACX,kBAAkB;EAClB,aAAa,EAAA;;AAGjB,oCAAA;AACA;EACI,cAAc,EAAA;;AAGlB,kCAAA;AACA;EACI,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,yBD7BuB;EC8BvB,yBAAyB;EACzB,wBAAwB,EAAA;;AC1C5B;EACI,kBAAkB,EAAA;EADtB;IAGQ,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,UAAU,EAAA;;ACPlB;EACI,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,WAAW,EAAA;;AAGf;EACI,WAAW,EAAA;;AAIX;EADJ;IAEQ,0DAAsD;IACtD,oBAAoB;IACpB,4BAA4B;IAC5B,2BAA2B,EAAA,EAElC;;AAED,qDAAA;AACA;EACI,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,yBAAyB,EAAA;EAEzB;IANJ;MAOQ,aAAa;MACb,cAAc;MACd,mBAAmB,EAAA,EAmE1B;EA5ED;IAaQ,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW,EAAA;IAEX;MAlBR;QAmBY,WAAW;QACX,gBAAgB,EAAA,EAavB;IAjCL;MAwBY,YAAY;MACZ,kBAAkB;MAClB,QAAQ,EAAA;IA1BpB;MA8BY,kBAAkB;MAClB,kBAAkB,EAAA;EA/B9B;IAoCQ,wCAAwC;IACxC,uBAAuB,EAAA;IAEvB;MAvCR;QAwCY,aAAa,EAAA,EA0BpB;IAlEL;MA4CY,WAAW;MACX,UAAU,EAAA;MAEV;QA/CZ;UAgDgB,qBAAqB,EAAA,EAiB5B;MAjET;QAoDgB,eAAe;QACf,mBAAmB,EAAA;QAEnB;UAvDhB;YAwDoB,eAAe;YACf,mBAAmB,EAAA,EAE1B;MA3Db;QA8DgB,WAAW;QACX,UAAU,EAAA;EA/D1B;IAqEQ,YAAY;IACZ,iBAAiB,EAAA;IAEjB;MAxER;QAyEY,aAAa,EAAA,EAEpB;;AAGL;EACI,aAAa,EAAA;EADjB;IAKQ,UAAU;IACV,kBAAkB,EAAA;;ACzG1B;;EAGQ,iBAAiB,EAAA;;ACFzB;EACI,UAAU;EACV,gBAAgB,EAAA;EAChB;IAHJ;MAIQ,UAAU,EAAA,EAEjB;;ACPD;EACI,gBAAgB,EAAA;EAChB;IAFJ;MAGQ,iBAAiB,EAAA,EAExB;;AAED;EACI,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY,EAAA;EAEZ;IARJ;MASQ,gBAAgB,EAAA,EAavB;EAtBD;IAaQ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B,EAAA;IAhBtC;MAmBY,YAAY,EAAA;;AAKxB;EACI,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB,EAAA;EAClB;IANJ;MAOQ,SAAS;MACT,iBAAiB,EAAA,EAExB;;ACzCD;EACI,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,aAAa;EACb,eAAe;EACf,oDAAmD;EACnD,MAAM;EACN,WAAW,EAAA;EACX;IATJ;MAUQ,aAAa,EAAA,EAUpB;EApBD;IAeY,eAAe;IACf,gBAAgB;IAChB,iBAAiB,EAAA;;AAK7B;EACI,QAAQ;EACR,mCAAmC;EACnC,UAAU,EAAA;EACV;IAJJ;MAKQ,UAAU,EAAA,EAEjB;;AAED;;EAEI,OAAO;EACP,iCAAiC;EACjC,sDAAoD;EACpD,WAAW,EAAA;EAEX;IAPJ;;MAQQ,UAAU;MACV,QAAQ;MACR,UAAU,EAAA,EAEjB;;AAED;EACI,2BAA0B;EAC1B,QAAQ;EACR,mCAAmC,EAAA;EACnC;IAJJ;MAKQ,UAAU,EAAA,EAEjB;;AAED;;EAEI,mCAAmC;EACnC,sDAAoD,EAAA;;AAGxD;EACI,QAAQ;EACR,uBAAuB;EACvB,UAAU;EACV,cAAc,EAAA;EACd;IALJ;MAMQ,uBAAuB;MACvB,UAAU,EAAA,EA8BjB;EArCD;IAWQ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B,EAAA;EAdtC;IAkBQ,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW,EAAA;IAvBnB;MA0BY,UAAU,EAAA;MACV;QA3BZ;UA8BgB,UAAU,EAAA,EAEjB;EAhCT;IAmCQ,uBAAuB,EAAA;;AAI/B;EACI,0BAA0B;EAC1B,kBAAkB;EAClB,8BAA8B;EAC9B,UAAU;EACV,SAAS;EACT,UAAU,EAAA;EACV;IAPJ;MAQQ,aAAa;MACb,0BAA0B;MAC1B,SAAS;MACT,UAAU,EAAA,EAEjB;;AAED;EACI,QAAQ;EACR,mCAAmC;EACnC,YAAY,EAAA;EAHhB;IAKQ,iCAAiC;IACjC,sDAAoD,EAAA;;AAI5D;EACI,QAAQ;EACR,mCAAmC;EACnC,YAAY,EAAA;EAHhB;IAKQ,iCAAiC;IACjC,sDAAoD,EAAA;;AAK5D;EACI,QAAQ;EACR,mCAAmC;EACnC,YAAY;EACZ,aAAa,EAAA;EACb;IALJ;MAMQ,UAAU,EAAA,EAMjB;EAZD;IASQ,iCAAiC;IACjC,sDAAoD,EAAA;;AAI5D;EACI,QAAQ;EACR,mCAAmC;EACnC,YAAY,EAAA;EAHhB;IAKQ,iCAAiC;IACjC,sDAAoD,EAAA;;AAI5D;EACI,QAAQ;EACR,uBAAuB;EACvB,WAAW;EACX,aAAa,EAAA;EACb;IALJ;MAMQ,uBAAuB;MACvB,UAAU,EAAA,EAqBjB;EA5BD;IAWQ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B,EAAA;EAdtC;IAkBQ,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW,EAAA;EAvBnB;IA0BQ,uBAAuB,EAAA;;ACzL/B;EACI,oCAAoC;EACpC,yBAAyB;EACzB,OAAO;EACP,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,WAAW;EACX,aAAa,EAAA;;AAGjB;EACI,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB,EAAA;;AAGvB;EACI,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,6BAAkC;EAClC,mBAAmB;EACnB,8BAA8B;EAC9B,iCAAiC,EAAA;;AAGrC;EACI;IACI,uBAAuB,EAAA;EAG3B;IACI,yBAAyB,EAAA,EAAA;;AAIjC;EACI;IACI,uBAAuB,EAAA;EAG3B;IACI,yBAAyB,EAAA,EAAA;;AAIjC;EACI;IACI,uBAAuB,EAAA;EAG3B;IACI,yBAAyB,EAAA,EAAA;;AC5DjC;EAGQ,gBAAgB,EAAA;EAHxB;IAMY,wCAAuC;IACvC,uBAAsB;IACtB,aAAa,EAAA;IARzB;MAWgB,WAAW;MACX,UAAU,EAAA;MAZ1B;QAeoB,mBAAmB;QACnB,WAAW,EAAA;MAhB/B;QAoBoB,WAAW;QACX,UAAU,EAAA;;AArB9B;EA4BQ,mBAAmB;EACnB,UAAU,EAAA;EA7BlB;IAgCY,sBAAsB;IACtB,YAAY;IACZ,2BAA2B;IAC3B,cT9Be,EAAA;;AUiB3B;EACI,uBAAuB;EACvB,uBAAuB,EAAA;;ACxB3B;EAEQ,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,WAAW,EAAA;;AARnB;EAYQ,6BAA6B,EAAA;;AAIrC;EACI,UAAU;EACV,UAAU;EACV,uBAAuB,EAAA;;AAI3B;EACI,cAAc,EAAA;;AAGlB;EACI,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,UAAU,EAAA;EALd;IAQQ,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU,EAAA;EApBlB;IAwBQ,cX7CmB;IW8CnB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,WAAW,EAAA;EA7BnB;IAiCQ,yBXtDmB;IWuDnB,WAAW;IACX,kBAAkB;IAClB,QAAQ,EAAA;IApChB;MAuCY,sBAAsB;MACtB,yBX7De;MW8Df,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,YAAY;MACZ,SAAS;MACT,WAAW;MACX,UAAU,EAAA;EAhDtB;IAqDQ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,WAAW,EAAA;;AAKnB;EACI,WAAW,EAAA;EADf;IAOY,cAAc;IACd,kBAAkB,EAAA;;AAQ9B;EAGQ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,UAAU,EAAA;EANlB;IAQY,UAAU;IACV,yBX3Ge;IW4Gf,SAAS;IACT,kBAAkB,EAAA;IAX9B;MAcgB,sBAAsB;MACtB,yBXjHW;MWkHX,kBAAkB;MAClB,YAAY;MACZ,WAAW;MACX,cAAc;MACd,YAAY;MACZ,UAAU;MACV,kBAAkB;MAClB,WAAW;MACX,UAAU,EAAA;;AAxB1B;EAgCY,sBAAsB;EACtB,yBXnIe;EWoIf,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,UAAU,EAAA;EAxCtB;IA2CgB,oBAAoB,EAAA;;ACnJpC;EACI,sBAAsB;EACtB,yBAAyB;EACzB,qBAAoB;EACpB,iBAAgB;EAChB,oBAAmB;EACnB,uBAAuB;EACvB,eAAe,EAAA;EAPnB;IAUQ,eAAe;IACf,cAAc,EAAA;IAXtB;MAaY,cZFe,EAAA;EYX3B;IAkBQ,iBAAiB;IACjB,oBAAoB,EAAA;IAnB5B;MAqBY,cAAc,EAAA;EArB1B;IA0BQ,yBAA0B;IAC1B,mBAAmB,EAAA;IA3B3B;MA6BY,cZfe;MYgBf,qBAAqB,EAAA;;AC9BjC;EACI,yBAAyB;EACzB,WAAW;EACX,WAAW,EAAA;EAHf;IAMQ,qBAAoB,EAAA;EAN5B;IAUQ,yBbJmB;IaKnB,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,UAAU,EAAA;EAdlB;IAiBQ,yBAAyB,EAAA;IAjBjC;MAmBY,yBbNe,EAAA;;Acb3B;EACI,cAAc;EACd,YAAY;EACZ,WAAW,EAAA;EAHf;IAMQ,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ,EAAA;EAThB;IAaQ,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB,EAAA;;ACnB7B;EAEI,oCAAwC;EACxC,aAAa;EAEb,qBAAoB,EAAA;EACpB;IANJ;MAOQ,mBAAmB;MACnB,sBAAsB;MACtB,aAAa;MACb,2BAA0B;MAC1B,4BAA2B;MAC3B,wBAAuB,EAAA,EAiC9B;EA7CD;IAgBQ,0BAA0B;IAC1B,iBAAiB;IACjB,iBAAiB,EAAA;IACjB;MAnBR;QAoBY,gBAAgB;QAChB,aAAa;QACb,uBAAuB;QACvB,gCAAgC;QAChC,UAAU,EAAA,EAEjB;EA1BL;IA4BQ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,aAAa,EAAA;IACb;MAlCR;QAmCY,aAAa;QACb,sBAAsB;QACtB,2BAA2B;QAC3B,YAAY;QACZ,UAAU,EAAA,EAKjB;IA5CL;MA0CY,cAAc,EAAA;;AAK1B;EAEQ,gBAAgB,EAAA;EAChB;IAHR;MAIY,mBAAmB,EAAA,EAE1B;;AANL;EAQQ,aAAa;EACb,mBAAmB;EACnB,8BAA8B,EAAA;EAC9B;IAXR;MAYY,mBAAmB,EAAA,EA2B1B;EAvCL;IAiBY,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB,EAAA;IACnB;MAtBZ;QAuBgB,UAAU,EAAA,EAejB;IAtCT;MA2BgB,kBAAkB,EAAA;IA3BlC;MA+BgB,mBAAmB,EAAA;IA/BnC;MAmCgB,mBAAmB;MACnB,kBAAkB,EAAA;;AAMlC;EACI,aAAa;EACb,mBAAmB;EACnB,8BAA8B,EAAA;EAHlC;IAKQ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,UAAU,EAAA;IACV;MAVR;QAWY,UAAU,EAAA,EAEjB;EAGG;IAhBR;MAiBY,2BAA2B,EAAA,EAElC;EAnBL;IAsBQ,kBAAkB,EAAA;EAtB1B;IA0BQ,kBAAkB,EAAA;;ACjHlB;EAFR;IAGY,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY,EAAA,EAEnB;;AAVL;EAaQ,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB,EAAA;EAlB1B;IAqBY,aAAa;IACb,mBAAmB;IACnB,uBAAuB,EAAA;EAvBnC;IA2BY,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,6CAA6C;IAC7C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,WAAW,EAAA;IArCvB;MAwCgB,WAAW,EAAA;EAxC3B;IA6CY,6CAA6C;IAC7C,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY,EAAA;EAlDxB;IAsDY,gBAAgB;IAChB,kBAAkB,EAAA;IAvD9B;MA0DgB,sBAAsB;MACtB,yBAAyB;MACzB,kBAAkB;MAClB,WAAW;MACX,cAAc;MACd,YAAY;MACZ,UAAU;MACV,kBAAkB;MAClB,WAAW;MACX,UAAU,EAAA;MAEV;QArEhB;UAsEoB,UAAU,EAAA,EAEjB;EAxEb;IA4EY,mBAAmB,EAAA;EA5E/B;IAgFY,aAAa;IACb,mBAAmB;IACnB,WAAW,EAAA;;AAlFvB;EAuFQ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe,EAAA;EA5FvB;IA+FY,6CAA6C;IAC7C,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,YAAY,EAAA;EArGxB;IAyGY,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,6CAA6C;IAC7C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,wBAAwB;IACxB,UAAU;IACV,YAAY,EAAA;IApHxB;MAuHgB,YAAY,EAAA;EAvH5B;IA4HY,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,UAAU;IACV,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB,EAAA;EAlI/B;IAsIY,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,UAAU,EAAA;EAzItB;IA6IY,gBAAgB;IAChB,kBAAkB,EAAA;IA9I9B;MAiJgB,sBAAsB;MACtB,yBAAyB;MACzB,kBAAkB;MAClB,WAAW;MACX,cAAc;MACd,YAAY;MACZ,sBAAsB;MACtB,iBAAiB;MACjB,kBAAkB;MAClB,WAAW;MACX,UAAU,EAAA;EA3J1B;IAgKY,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,WAAW,EAAA;EApKvB;IAwKY,aAAa;IACb,WAAW,EAAA;;AAzKvB;EAkLQ,mBAAmB,EAAA;;AAlL3B;EAsLQ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB,EAAA;EAEhB;IA1LR;MA2LY,kBAAkB;MAClB,8BAA8B,EAAA,EAkErC;EA9PL;IAgMY,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAA;IAnMnC;MAsMgB,ahB3LW;MgB4LX,YAAY;MACZ,WAAW,EAAA;IAxM3B;MA4MgB,aAAa,EAAA;EA5M7B;IAiNY,eAAe;IACf,mBAAmB,EAAA;IAEnB;MApNZ;QAqNgB,eAAe,EAAA,EAwCtB;IA7PT;MA0NoB,wBAA2B,EAAA;MA1N/C;QA6NwB,wBAA2B,EAAA;IA7NnD;MAmOgB,mBAAmB,EAAA;MAnOnC;QAuOwB,wBAA4B,EAAA;QAvOpD;UA0O4B,wBAA4B,EAAA;IA1OxD;MAkPoB,wBAAwB,EAAA;MAlP5C;QAqPwB,wBAAwB,EAAA;IArPhD;MA0PoB,yBAAyB,EAAA;;AA1P7C;EAiQQ,uBAAuB;EACvB,6CAA6C;EAC7C,aAAa;EACb,+BAA+B;EAC/B,8BAA8B,EAAA;EAG1B;IAxQZ;MAyQgB,mBAAmB;MACnB,aAAa;MACb,mBAAmB;MACnB,kBAAkB,EAAA,EAEzB;EA9QT;IAiRY,eAAe,EAAA;EAjR3B;IAqRY,WAAW,EAAA;EArRvB;IAiSY,aAAa;IACb,mBAAmB;IACnB,uBAAuB,EAAA;IAVvB;MAzRZ;QA4RgB,UAAU,EAAA,EAQjB;IApST;MA+RgB,aAAa,EAAA;EAQjB;IAvSZ;MAwSgB,aAAa;MACb,mBAAmB;MACnB,2BAA2B;MAC3B,mBAAmB;MACnB,UAAU,EAAA,EAKjB;EAjTT;IA+SgB,aAAa,EAAA;EA/S7B;IAoTY,mBAAmB,EAAA;EApT/B;IAwTY,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,sDAAsD;IACtD,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,WAAW,EAAA;IAEX;MArUZ;QAsUgB,gBAAgB;QAChB,SAAS;QACT,WAAW,EAAA,EA0BlB;IAvBG;MA3UZ;QA4UgB,gBAAgB;QAChB,WAAW;QACX,uBAAuB,EAAA,EAoB9B;IAjBG;MAjVZ;QAkVgB,gBAAgB;QAChB,UAAU;QACV,WAAW,EAAA,EAclB;IAXG;MAvVZ;QAwVgB,gBAAgB;QAChB,uBAAuB;QACvB,WAAW,EAAA,EAQlB;IALG;MA7VZ;QA8VgB,gBAAgB;QAChB,uBAAuB;QACvB,WAAW,EAAA,EAElB;EAGG;IArWZ;MAsWgB,iBAAiB;MACjB,sBAAsB;MACtB,WAAW,EAAA,EAQlB;EALG;IA3WZ;MA4WgB,gBAAgB;MAChB,uBAAuB;MACvB,WAAW,EAAA,EAElB;EAhXT;IAmXY,eAAe;IACf,iBAAiB,EAAA;IAGjB;MAvXZ;QAwXgB,iBAAiB;QACjB,gBAAgB,EAAA,EASvB;IANG;MACqC;QA7XjD;UA+XgB,iBAAA;UACA,iBAAiB,EAAA,EAExB,EAAA;EAGG;IArYZ;MAsYgB,aAAa;MACb,iBAAiB;MACjB,gBAAgB;MAChB,WAAW,EAAA,EASlB;EANG;IA5YZ;MA6YgB,aAAa;MACb,iBAAiB;MACjB,gBAAgB;MAChB,WAAW,EAAA,EAElB;EAGG;IArZZ;MAsZgB,aAAa;MACb,iBAAiB;MACjB,gBAAgB;MAChB,WAAW,EAAA,EAQlB;EALG;IA5ZZ;MA6ZgB,iBAAiB;MACjB,gBAAgB;MAChB,aAAa,EAAA,EAEpB;EAGG;IApaZ;MAqagB,4BAA4B,EAAA,EAEnC;;AAvaT;EA2aQ,aAAa,EAAA;EACb;IA5aR;MA6aY,aAAa;MACb,gBAAgB;MAChB,iBAAiB;MACjB,gBAAgB,EAAA,EAEvB;;AAlbL;EAqbQ,aAAa;EACb,mBAAmB;EACnB,gBAAgB,EAAA;EAChB;IAxbR;MA0bgB,cAAc;MACd,mBAAmB,EAAA,EACtB;EA5bb;IAgcY,gBAAgB;IAChB,WAAW,EAAA;EAEf;IAncR;MAqcgB,aAAa;MACb,UAAU,EAAA,EACb;;AAvcb;EA2cQ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB,EAAA;;AC9c3B;EAGY,WAAW,EAAA;;AAHvB;EAQQ,aAAa;EACb,sBAAsB;EACtB,6BAA6B,EAAA;EAE7B;IAZR;MAaY,2BAA2B,EAAA,EAElC;;AAfL;EAkBQ,yBjBZmB;EiBanB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,kBAAkB,EAAA;;AAI1B;EACI,aAAa;EACb,mBAAmB;EACnB,6BAA6B,EAAA;EAHjC;IAMQ,UAAU,EAAA;IANlB;MASY,YAAY,EAAA;IATxB;MAaY,YAAY;MACZ,kBAAkB;MAClB,WAAW;MACX,UAAU;MACV,kBAAkB,EAAA;MAElB;QAnBZ;UAoBgB,YAAY;UACZ,WAAW,EAAA,EAElB;EAvBT;IA2BQ,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,UAAU,EAAA;;AAKlB;EAIQ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,6BAA6B,EAAA;EAPrC;IAUY,aAAa;IACb,sBAAsB,EAAA;IAEtB;MAbZ;QAcgB,6BAA6B;QAC7B,mBAAmB,EAAA,EAE1B;EAGG;IApBZ;MAqBgB,YAAY;MACZ,gBAAgB;MAChB,UAAU,EAAA,EAEjB;;AAzBT;EA6BQ,mBAAmB,EAAA;EA7B3B;IAgCY,kBAAkB;IAClB,YAAY,EAAA;EAjCxB;IAqCY,sBAAsB;IACtB,iBAAiB;IACjB,YAAY,EAAA;;AAvCxB;EA4CQ,aAAa;EACb,sBAAsB;EACtB,8BAA8B,EAAA;EAE9B;IAhDR;MAiDY,iBAAiB;MACjB,UAAU,EAAA,EAgCjB;EAlFL;IAsDY,gBAAgB;IAChB,gBAAgB,EAAA;EAIhB;IA3DZ;MA4DgB,UAAU,EAAA,EAEjB;EAGG;IAjEZ;MAkEgB,UAAU,EAAA,EAOjB;EAzET;IAsEgB,cjB/HW;IiBgIX,gBAAgB,EAAA;EAvEhC;IA4EY,yBjB/He,EAAA;IiBiIf;MA9EZ;QA+EgB,UAAU,EAAA,EAEjB;;AAjFT;EAqFQ,aAAa;EACb,oBAAoB;EACpB,oBAAoB;EACpB,WAAW,EAAA;EAEX;IA1FR;MA2FY,mBAAmB,EAAA,EAG1B;;AA9FL;EAkGY,WAAW,EAAA;;AAlGvB;EAuGQ,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB,EAAA;;AAzG9B;EA8GQ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU,EAAA;EAEV;IArHR;MAsHY,sBAAsB,EAAA,EAM7B;EAHG;IAzHR;MA0HY,sBAAsB,EAAA,EAE7B;;AA5HL;EA+HQ,UAAU,EAAA;EAEV;IAjIR;MAkIY,sBAAsB,EAAA,EAM7B;EAHG;IArIR;MAsIY,sBAAsB,EAAA,EAE7B;;AAxIL;EA6IY,sBAAsB;EACtB,yBAAyB;EACzB,qBAAoB;EACpB,iBAAgB;EAChB,oBAAmB;EACnB,4BAA2B;EAC3B,kBAAkB,EAAA;EAClB;IApJZ;MAqJgB,4BAA2B,EAAA,EAElC;;AAvJT;EA0JY,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB,EAAA;;AA9J/B;EAkKY,qBAAqB;EACrB,aAAa;EACb,qBAAqB,EAAA;EApKjC;IAuKgB,cjB1NW,EAAA;EiBmD3B;IA2KgB,kBAAkB;IAClB,WAAW,EAAA;;AA5K3B;EAkLQ,uBAAuB;EACvB,kBAAkB;EAClB,aAAa,EAAA;EAEb;IAtLR;MAuLY,kBAAkB,EAAA,EAsBzB;EA7ML;IA4LgB,gCjB/OW;IiBgPX,mBAAmB,EAAA;EA7LnC;IAiMgB,iCAAiC;IACjC,eAAe,EAAA;IAlM/B;MAqMoB,iBAAiB,EAAA;IArMrC;MAyMoB,eAAe,EAAA;;AAOnC;EACI,yBAAwB,EAAA;EAD5B;IAGQ,YAAY;IACZ,gBAAgB,EAAA;IAJxB;MAOY,mBAAmB;MACnB,gCAAgC;MAChC,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,gBAAgB,EAAA;MAZ5B;QAegB,UAAU,EAAA;QAf1B;UAkBoB,SAAS;UACT,gBAAgB;UAChB,2BAA2B;UAC3B,qBAAqB;UACrB,uBAAuB;UACvB,mBAAmB,EAAA;MAvBvC;QA4BgB,kBAAkB;QAClB,cjBhSW;QiBiSX,aAAa;QACb,yBAAyB;QACzB,kBAAkB;QAClB,QAAQ;QACR,UAAU,EAAA;QAlC1B;UAqCoB,iBAAiB,EAAA;IArCrC;MA2CY,kBAAkB,EAAA;;ACzT9B;EACI,yBlBIuB;EkBHvB,sBAAsB,EAAA;EAEtB;IAJJ;MAKQ,mBAAmB,EAAA,EAgC1B;EA5BO;IATR;MAUY,UAAU,EAAA,EAUjB;EAPG;IAbR;MAcY,eAAe,EAAA,EAMtB;EApBL;IAkBY,WAAW,EAAA;EAlBvB;IAuBQ,UAAU,EAAA;IAvBlB;MA0BY,aAAa;MACb,YAAY,EAAA;EA3BxB;IAgCQ,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB,EAAA;;AAI3B;EACI,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB,EAAA;EAClB;IALJ;MAMQ,YAAY,EAAA,EAEnB;;AAED;EACI,mBAAmB;EACnB,aAAa;EACb,mBAAmB,EAAA;EAHvB;IAMQ,kBAAkB,EAAA;EAN1B;IAUQ,YAAY;IACZ,cAAc;IACd,WAAW,EAAA;IAZnB;MAeY,kBAAkB;MAClB,WAAW,EAAA;MAhBvB;QAmBgB,WAAW;QACX,YAAY,EAAA;;AAM5B;EAEQ,yBAAyB,EAAA;;AAFjC;EAMQ,gBAAgB,EAAA;EAChB;IAPR;MAQY,cAAc,EAAA,EAErB;;AAVL;EAcY,cAAc;EACd,kBAAkB;EAClB,cAAc,EAAA;;AAhB1B;EAmBY,aAAa;EACb,mBAAmB;EACnB,UAAU,EAAA;EArBtB;IAwBgB,mBAAmB;IACnB,aAAa;IACb,YAAY,EAAA;;AA1B5B;EA8BY,UAAU,EAAA;;AA9BtB;EAmCQ,aAAa;EACb,mBAAmB,EAAA;EACnB;IArCR;MAsCY,YAAY,EAAA,EAEnB;;AAxCL;EA2CQ,kBAAkB;EAClB,UAAU,EAAA;EA5ClB;IA8CY,SAAS,EAAA;EAEb;IAhDR;MAiDY,UAAU,EAAA,EAQjB;EANG;IAnDR;MAoDY,UAAU,EAAA,EAKjB;EAzDL;IAuDY,WAAW,EAAA;;AAKvB;EACI,QAAQ;EACR,mCAAmC;EACnC,UAAU,EAAA;EACV;IAJJ;MAKQ,UAAU,EAAA,EAEjB;;AAED;;EAEI,OAAO;EACP,iCAAiC;EACjC,sDAAsD;EACtD,WAAW,EAAA;EAEX;IAPJ;;MAQQ,UAAU;MACV,QAAQ;MACR,UAAU,EAAA,EAEjB;;AAED;EACI,QAAQ;EACR,mCAAmC,EAAA;EACnC;IAHJ;MAIQ,UAAU,EAAA,EAEjB;;AAED;;EAEI,mCAAmC;EACnC,sDAAsD,EAAA;;ACzK1D;EACI,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,iBAAgB,EAAA;EANpB;IASQ,qEAA2E;IAC3E,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B,EAAA;IAE3B;MAdR;QAeY,WAAW;QACX,2BAA2B,EAAA,EAOlC;IAJG;MAnBR;QAoBY,WAAW;QACX,8BAA8B,EAAA,EAErC;EAvBL;IA0BQ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB,EAAA;IAEvB;MA/BR;QAgCY,mBAAmB;QACnB,mBAAmB,EAAA,EAE1B;EAnCL;IAsCQ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB,EAAA;IAzC1B;MA4CY,YAAY;MACZ,cAAc;MACd,YAAY;MACZ,kBAAkB,EAAA;IA/C9B;MAmDY,aAAa,EAAA;IAnDzB;MAuDY,kBAAkB;MAClB,kBAAkB;MAClB,iBAAiB,EAAA;MAzD7B;QA4DgB,iBAAiB,EAAA;IAKzB;MAjER;QAkEY,mBAAmB;QACnB,gBAAgB,EAAA;QAnE5B;UAsEgB,cAAc;UACd,iBAAiB;UACjB,UAAU;UACV,YAAY;UACZ,qBAAqB,EAAA;QA1ErC;UA8EgB,YAAY;UACZ,YAAY,EAAA;QA/E5B;UAmFgB,eAAe;UACf,gBAAgB,EAAA;UApFhC;YAuFoB,eAAe,EAAA,EAClB;EAxFjB;IA+FQ,WAAW;IACX,aAAa;IACb,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB,EAAA;IAEzB;MAvGR;QAwGY,YAAY,EAAA,EAiDnB;IAzJL;MA4GY,iBAAiB;MACjB,WAAW;MACX,kBAAkB;MAClB,gBAAgB,EAAA;MA/G5B;QAkHgB,iBAAiB,EAAA;MAGrB;QArHZ;UAsHgB,iBAAiB,EAAA;UAtHjC;YAyHoB,iBAAiB,EAAA,EACpB;IA1HjB;MA+HY,gBAAgB;MAChB,aAAa,EAAA;MAEb;QAlIZ;UAmIgB,YAAY;UACZ,UAAU,EAAA,EAWjB;MARG;QAvIZ;UAwIgB,gBAAgB;UAChB,kBAAkB;UAClB,gBAAgB;UAChB,UAAU;UACV,UAAU,EAAA,EAGjB;IA/IT;MAkJY,mBAAmB,EAAA;IAlJ/B;MAsJY,gBAAe,EAAA;EAKvB;IA3JJ;MA4JQ,qBAAqB,EAAA,EA2D5B;EAxDG;IACI,cnBrJmB;ImBsJnB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,UAAU,EAAA;IACV;MANJ;QAOQ,UAAU,EAAA,EAEjB;EAxKL;IA2KQ,WAAW;IACX,aAAa;IACb,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB,EAAA;IAEzB;MAnLR;QAoLY,YAAY,EAAA,EAuBnB;IA3ML;MAwLY,iBAAiB;MACjB,kBAAkB,EAAA;MAzL9B;QA4LgB,iBAAiB,EAAA;MAGrB;QA/LZ;UAgMgB,iBAAiB,EAAA;UAhMjC;YAmMoB,iBAAiB,EAAA,EACpB;IApMjB;MAyMY,kBAAkB,EAAA;EAzM9B;IA8MQ,gBAAgB;IAChB,gBAAgB,EAAA;IAEhB;MAjNR;QAkNY,eAAe;QACf,iBAAiB,EAAA,EAExB;;AAIL;EACI,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB,EAAA;EAP7B;IAUQ,WAAW,EAAA;EAVnB;IAcQ,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,UAAU,EAAA;IACV;MAtBR;QAuBY,cAAc,EAAA,EAErB;EAzBL;IA4BQ,WAAW,EAAA;;AAKnB;EACI,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW,EAAA;EACX;IARJ;MASQ,aAAa,EAAA,EAoBpB;EA7BD;IAaQ,iBAAiB;IACjB,YAAY,EAAA;IACZ;MAfR;QAgBY,gBAAgB;QAChB,YAAY,EAAA,EAGnB;EApBL;IAuBQ,kBAAkB;IAClB,YAAY,EAAA;IACZ;MAzBR;QA0BY,iBAAiB,EAAA,EAExB;;AAGL;EAEI,aAAa;EACb,oBAAoB,EAAA;EAEpB;IALJ;MAMQ,4BAA4B,EAAA,EAGnC;;AClSD;EACI,aAAa,EAAA;EACb;IAFJ;MAGQ,aAAa,EAAA,EAmIpB;EAtID;IAOQ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B,EAAA;IAVtC;MAaY,WAAW,EAAA;MACX;QAdZ;UAegB,cAAc;UACd,UAAU,EAAA;UAhB1B;YAkBoB,kBAAkB,EAAA;UAlBtC;YAqBoB,kBAAkB,EAAA,EACrB;MAEL;QAxBZ;UAyBgB,UAAU,EAAA,EAEjB;IA3BT;MA8BY,mBAAmB;MACnB,aAAa;MACb,qBAAqB,EAAA;IAhCjC;MAqCY,aAAa,EAAA;MACb;QAtCZ;UAuCgB,aAAa;UACb,UAAU,EAAA;UAxC1B;YA2CoB,UAAU,EAAA,EACb;IA5CjB;MAiDY,WAAW,EAAA;MACX;QAlDZ;UAmDgB,aAAa;UACb,UAAU,EAAA,EAEjB;IAtDT;MAyDY,YAAY;MACZ,kBAAkB,EAAA;IA1D9B;MA8DY,mBAAmB;MACnB,aAAa,EAAA;MACb;QAhEZ;UAiEgB,aAAa;UACb,mBAAmB;UACnB,yBAAyB,EAAA,EAEhC;EArET;IAyEQ,mBAAmB;IACnB,aAAa;IACb,mBAAmB,EAAA;EA3E3B;IA8EQ,WAAW;IACX,iBAAiB,EAAA;EA/EzB;IAoFY,wCAAuC;IACvC,YAAY;IACZ,yBAA2B;IAC3B,UAAU,EAAA;IAvFtB;MA2FgB,uBAAsB;MACtB,2BAA0B,EAAA;EAIlC;IAhGR;MAkGgB,wDAAuD;MACvD,kBAAkB;MAClB,+CAA8C;MAC9C,UAAU,EAAA,EACb;EAtGb;IA0GY,mBAAmB;IACnB,aAAa;IACb,qBAAqB;IACrB,2BAA2B,EAAA;EA7GvC;IAkHQ,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,WAAW,EAAA;IAtHnB;MAwHY,kBAAkB;MAClB,WAAW,EAAA;IAEf;MA3HR;QA4HY,gBAAgB,EAAA,EAQvB;IApIL;MA+HY,WAAW,EAAA;MACX;QAhIZ;UAiIgB,UAAU,EAAA,EAEjB;;ACnIT;EAIQ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe,EAAA;EATvB;IAYY,aAAa,EAAA;IAEb;MAdZ;QAegB,aAAa;QACb,mBAAmB;QACnB,2BAA2B;QAC3B,YAAY;QACZ,eAAe;QACf,UAAU,EAAA,EAEjB;;AAtBT;EA2BQ,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW,EAAA;EAEX;IAjCR;MAkCY,UAAU,EAAA,EA0BjB;EA5DL;IAsCY,kBAAkB;IAClB,gBAAgB,EAAA;IAvC5B;MA0CgB,YAAY,EAAA;MA1C5B;QA4CoB,eAAe,EAAA;IA5CnC;MAiDgB,YAAY;MACZ,kBAAkB;MAClB,WAAW;MACX,SAAS;MACT,WAAW;MACX,UAAU,EAAA;MACV;QAvDhB;UAwDoB,SAAS,EAAA,EAEhB;;AA1Db;EA+DQ,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB,EAAA;EAnExB;IAqEY,iBAAiB;IACjB,WAAW,EAAA;IACX;MAvEZ;QAwEgB,UAAU,EAAA,EAQjB;IAhFT;MA4EgB,WAAW;MACX,cAAc;MACd,WAAW,EAAA;;AAMnB;EApFR;IAqFY,iBAAiB,EAAA,EAExB;;AAvFL;EA0FQ,gBAAgB,EAAA;;AA1FxB;EA8FQ,UAAU,EAAA;EA9FlB;IAiGY,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,kBAAkB,EAAA;EApG9B;IAwGY,yBAAyB;IACzB,kBAAkB,EAAA;EAzG9B;IA6GY,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB,EAAA;;AAK5B;EACI,aAAa;EACb,mBAAmB;EACnB,8BAA8B,EAAA;;AAGlC;EACI,gBAAgB;EAChB,WAAW,EAAA;EAFf;IAKQ,WAAW,EAAA;EALnB;IASQ,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,gBAAgB,EAAA;EAZxB;IAgBQ,gBAAgB;IAChB,mBAAmB;IACnB,yBAA4B;IAC5B,cAAc,EAAA;EAnBtB;IAuBQ,6BAA6B;IAC7B,eAAe,EAAA;;AAIvB;EACI,aAAa;EACb,yBAAyB;EACzB,mBAAmB,EAAA;EAHvB;IAKQ,qBAAqB,EAAA;EAGzB;IARJ;MASQ,mBAAmB,EAAA;MAT3B;QAWY,kBAAkB,EAAA,EACrB;;AAIT;EAGQ,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,aAAa,EAAA;EAEb;IARR;MASY,oBAAoB,EAAA,EAQ3B;EAjBL;IAaY,WAAW;IACX,kBAAkB,EAAA;;AAd9B;EAqBQ,aAAa;EACb,sBAAsB;EACtB,iBAAiB,EAAA;EAvBzB;IA0BY,eAAe,EAAA;IA1B3B;MA6BgB,cAAc;MACd,kBAAkB;MAClB,cAAc;MACd,SAAS,EAAA;;AAhCzB;EAuCQ,cAAc;EACd,kBAAkB;EAClB,WAAW,EAAA;EAEX;IA3CR;MA4CY,kBAAkB,EAAA,EAEzB;;AA9CL;EAiDQ,cAAc;EACd,kBAAkB;EAClB,kBAAkB,EAAA;;AAnD1B;EAuDQ,aAAa;EACb,4CAA4C,EAAA;EAE5C;IA1DR;MA2DY,eAAe;MACf,aAAa,EAAA,EAEpB;;AA9DL;EAiEQ,aAAa,EAAA;EAEb;IAnER;MAoEY,aAAa,EAAA,EAWpB;EA/EL;IAwEY,WAAW;IACX,0BAA0B;IAC1B,OAAO;IACP,cAAc;IACd,kBAAkB;IAClB,WAAW,EAAA;;AAKf;EAlFR;IAmFY,yBAAyB;IACzB,kBAAkB,EAAA,EAEzB;;AAIG;EA1FR;IA2FY,uBAAuB,EAAA,EAE9B;;AA7FL;EAkGgB,mBAAmB;EACnB,aAAa;EACb,YAAY,EAAA;;AApG5B;EAuGgB,mBAAmB,EAAA;;AAMnC;EACI,eAAe;EACf,kBAAkB;EAClB,sBAAqB,EAAA;EACrB;IAJJ;MAKQ,qBAAoB,EAAA,EAK3B;EAVD;IAQQ,eAAe,EAAA;;AC7RvB;EACI,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA0B,EAAA;;AAG1B;EADJ;IAEQ,gBAAgB,EAAA,EA0CvB;;AAvCG;EACI,mBAAmB,EAAA;;AAGvB;EACI,mBAAmB,EAAA;;AAIvB;EACI,mBAAmB;EACnB,SAAS;EACT,6BtBlBmB;EsBmBnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,UAAU,EAAA;EACV;IAZJ;MAaQ,uBAAuB;MACvB,YAAY;MACZ,6BAA6B;MAC7B,iBAAiB;MACjB,WAAW,EAAA,EAYlB;EA7BA;IAqBO,gBAAgB,EAAA;EArBvB;IAyBO,mBAAmB;IACnB,aAAa;IACb,mBAAmB,EAAA;;AAI/B;EACI,yBtB/CuB;EsBgDvB,kBAAkB;EAClB,eAAe;EACf,aAAa,EAAA;EACb;IALJ;MAMQ,gBAAgB,EAAA,EAmBvB;EAjBG;IARJ;MASQ,iBAAiB;MACjB,YAAY,EAAA,EAenB;EAzBD;IAcQ,eAAe,EAAA;EAdvB;IAkBQ,mBAAmB,EAAA;EAlB3B;IAsBQ,iBAAiB;IACjB,mBAAmB,EAAA;;AC1E3B;EACI,iBAAiB,EAAA;EADrB;IAIQ,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,sBAAsB,EAAA;IAEtB;MATR;QAUY,+BAA+B;QAC/B,UAAU,EAAA,EAMjB;IAjBL;MAeY,mBAAmB,EAAA;EAf/B;IAoBQ,WAAW,EAAA;IAEX;MAtBR;QAuBY,UAAU,EAAA,EA4DjB;IAnFL;MA2BY,8BAA8B,EAAA;IA3B1C;MAiCY,mBAAmB,EAAA;IAjC/B;MAqCY,cvB1Be;MuB2Bf,iBAAiB,EAAA;IAtC7B;MA0CY,2BAA2B,EAAA;IA1CvC;MAiDgB,iBAAiB;MACjB,+BAA2C,EAAA;IAlD3D;MAiDgB,iBAAiB;MACjB,gCAA2C,EAAA;IAlD3D;MAiDgB,iBAAiB;MACjB,4BAA2C,EAAA;IAlD3D;MAiDgB,iBAAiB;MACjB,gCAA2C,EAAA;IAlD3D;MAiDgB,iBAAiB;MACjB,gCAA2C,EAAA;IAlD3D;MAiDgB,iBAAiB;MACjB,4BAA2C,EAAA;IAlD3D;MAiDgB,iBAAiB;MACjB,gCAA2C,EAAA;IAlD3D;MAiDgB,iBAAiB;MACjB,gCAA2C,EAAA;IAlD3D;MAiDgB,iBAAiB;MACjB,4BAA2C,EAAA;IAlD3D;MAiDgB,iBAAiB;MACjB,gCAA2C,EAAA;IAlD3D;MAiDgB,iBAAiB;MACjB,gCAA2C,EAAA;IAlD3D;MAiDgB,iBAAiB;MACjB,6BAA2C,EAAA;IAlD3D;MAyDY,gBAAgB,EAAA;IAzD5B;MA+DgB,mBAAmB;MACnB,aAAa;MACb,mBAAmB;MACnB,eAAe;MACf,uBAAuB;MACvB,YAAY;MACZ,UAAU,EAAA;IArE1B;MAwEgB,kBAAiB,EAAA;IAxEjC;MA8EY,qBAAqB;MACrB,aAAa;MACb,mBAAmB,EAAA;;AAO/B;EACI,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EAAC,6BAA4B,EAAA;;ACxFlD;EAFR;IAGY,uBAAuB;IACvB,uBAAuB,EAAA,EAE9B;;ACNL;EACI,aAAa;EACb,sBAAsB;EACtB,8BAA8B,EAAA;EAC9B;IAJJ;MAKQ,mBAAmB,EAAA,EAoC1B;EAjCO;IARR;MAUgB,WAAW;MACX,0BAA0B;MAC1B,OAAO;MACP,cAAc;MACd,kBAAkB;MAClB,WAAW,EAAA,EACd;EAEL;IAlBR;MAmBY,UAAU,EAAA,EAEjB;EArBL;IAuBQ,gBAAgB,EAAA;IAChB;MAxBR;QAyBY,aAAa;QACb,UAAU,EAAA,EAcjB;IAxCL;MA8BY,mBAAmB,EAAA;IA9B/B;MAkCY,yBAAuB;MACvB,mBAAmB,EAAA;MACnB;QApCZ;UAqCgB,gBAAgB,EAAA,EAEvB;;ACvCT;EAGQ,iBAAiB;EACjB,iCAAiC,EAAA;;AAGzC;EACI,aAAa;EACb,sBAAsB;EACtB,8BAA8B,EAAA;EAHlC;IAMQ,kBAAkB,EAAA;IAN1B;MAQY,WAAW;MACX,0BAA0B;MAC1B,OAAO;MACP,cAAc;MACd,kBAAkB;MAClB,WAAW,EAAA;EAKf;IAlBR;MAmBY,UAAU,EAAA,EAEjB;EArBL;IAuBQ,aAAa,EAAA;IACb;MAxBR;QAyBY,eAAe,EAAA,EAEtB;;AAIL;EACI,YAAY,EAAA;EACZ;IAFJ;MAGQ,SAAS,EAAA,EAEhB;;AAED;EACI,yBAAyB;EACzB,kBAAkB;EAClB,6CAA6C;EAC7C,YAAY;EACZ,kBAAkB,EAAA;EALtB;IAQQ,kCAAkC,EAAA;EAR1C;IAYQ,kCAAkC,EAAA;EAZ1C;IAgBQ,kCAAkC,EAAA;EAhB1C;IAmBQ,kCAAkC,EAAA;EAnB1C;IAsBQ,kCAAkC,EAAA;EAtB1C;IAyBQ,kCAAkC,EAAA;EAzB1C;IA4BQ,kCAAkC,EAAA;EA5B1C;IAgCQ,cAAc;IACd,kBAAkB;IAClB,kBAAkB,EAAA;EAlC1B;IAsCQ,kBAAkB;IAClB,SAAS,EAAA;EAvCjB;IA2CQ,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,cAAc,EAAA;IA9CtB;MAiDY,cAAc,EAAA;;AC9F1B;EAGQ,wBAAwB,EAAA;;AAHhC;;EAQQ,cACJ,EAAA;;AATJ;EAYQ,eAAe;EACf,iBAAiB,EAAA;;AAbzB;EAiBQ,cAAc;EACd,iBAAiB,EAAA;;AAMzB;EACI,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB,EAAA;EAErB;IAPJ;MAQQ,qBAAqB;MACrB,sBAAsB,EAAA,EAkE7B;EA3ED;IAaQ,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,WAAW,EAAA;IAEX;MAnBR;QAoBY,yBAAyB;QACzB,UAAU,EAAA,EAEjB;EAvBL;IA0BQ,WAAW,EAAA;IAEX;MA5BR;QA6BY,UAAU,EAAA,EAQjB;IAJO;MAjCZ;QAkCgB,iBAAiB,EAAA,EAExB;EAID;IAxCR;MAyCY,sBAAsB,EAAA,EAE7B;EAGG;IA9CR;MA+CY,qBAAqB,EAAA,EAE5B;EAjDL;IAoDQ,yB3BjEmB;I2BkEnB,mBAAmB;IACnB,c3BnEmB;I2BoEnB,YAAY;IACZ,kBAAkB;IAClB,YAAY,EAAA;EAzDpB;IA6DQ,UAAU,EAAA;IA7DlB;MAgEY,kBAAkB,EAAA;IAhE9B;MAoEY,gBAAgB;MAChB,iBAAiB;MACjB,UAAU,EAAA;;AAOtB;EAIY,c3B9Fe,EAAA;;A2BoG3B;EAIY,kBAAkB,EAAA;;AAJ9B;EAYQ,kBAAkB;EAClB,QAAQ,EAAA;EAbhB;IAUY,kBAAkB,EAAA;;AAV9B;EAiBQ,4BAA4B;EAC5B,6BAA6B,EAAA;;AAlBrC;EAsBQ,kBAAkB,EAAA;EAtB1B;;IA0BY,kBAAkB,EAAA;;AA1B9B;EA+BQ,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB,EAAA;;AArC/B;EAyCQ,oBAAoB;EACpB,iBAAiB;EACjB,OAAO,EAAA;;AA3Cf;EA+CQ,iBAAiB;EACjB,kBAAkB,EAAA;EAhD1B;IAmDY,kBAAkB,EAAA;;AAnD9B;EA0DY,YAAY;EACZ,WAAW;EACX,mBAAmB,EAAA;EA5D/B;IA+DgB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,mBAAmB,EAAA;IAlEnC;MAqEoB,cAAc;MACd,iBAAiB;MACjB,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,YAAY,EAAA;MA1EhC;QA6EwB,kBAAkB;QAClB,iBAAiB;QACjB,mBAAmB;QACnB,YAAY;QACZ,WAAW;QAEX,sBAAsB;QACtB,mBAAmB,EAAA;;AAQ3C;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;C/B23EC;A+B11ED;EACI,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB,EAAA;;AAGtB;EACI,mCAAI;EACJ,wCAAI;EACJ,+CAAU;EACV,sGAAsG;EACtG,8FAA8F;EAC9F,YAAY;EACZ,kBAAkB;EAClB,uFAAuF;EACvF,+EAA+E;EAC/E,kCAAkC;EAClC,0BAA0B;EAC1B,WAAW,EAAA;;AAGf;;EAEI,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW,EAAA;;AAGf;EACI,+CAAU;EACV,yEAAyE;EACzE,iEAAiE;EACjE,gCAAgC;EAChC,wBAAwB,EAAA;;AAG5B;EACI,yBAAyB,EAAA;;AAG7B;EACI,WAAW,EAAA;EACX;IAFJ;MAGQ,yBAAyB;MACzB,qBAAqB,EAAA,EAE5B;;AAED;EACI,WAAW,EAAA;EACX;IAFJ;MAGQ,yBAAyB;MACzB,sBAAsB;MACtB,aAAa;MACb,yBAAyB;MACzB,gBAAgB,EAAA,EAEvB;;ACzSD;EACI,wBAAwB,EAAA;;AAG5B;EACI,qBAAqB,EAAA;EADzB;IAIQ,qBAAqB,EAAA;;AAI7B;EACI,eAAe,EAAA;;AAKf;EACI,qBAA0C,EAAA;;AAD9C;EACI,qBAA0C,EAAA;;AAD9C;EACI,qBAA0C,EAAA;;AAD9C;EACI,qBAA0C,EAAA;;AAD9C;EACI,qBAA0C,EAAA;;AAD9C;EACI,qBAA0C,EAAA;;AAD9C;EACI,qBAA0C,EAAA;;AAD9C;EACI,qBAA0C,EAAA;;AAD9C;EACI,qBAA0C,EAAA;;AAD9C;EACI,sBAA0C,EAAA;;AAKlD;EACI,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB,EAAA;EACtB;IALJ;MAMQ,YAAY;MACZ,mBAAmB;MACnB,gBAAgB;MAChB,kBAAkB,EAAA,EAEzB;;AAED;EACI,yBAAyB,EAAA;;AAG7B;EACI,yBAAyB,EAAA;;AAG7B;EACI,qBAAoB,EAAA;;AhCFxB;EACI,wBAAwB;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EAClB,kBAAkB;EAClB,cAAc,EAAA;EAPlB;IAUY,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,SAAS,EAAA","sourcesContent":["@import '../node_modules/react-image-crop/lib/ReactCrop.scss';\r\n@import '../node_modules/toastify-js/src/toastify.css';\r\n\r\n@import \"Sass/settings/settings\";\r\n\r\n@import \"Sass/tools/tools\";\r\n\r\n@import \"Sass/generic/generic\";\r\n\r\n@import \"Sass/objects/YC-Checkbox\";\r\n@import \"Sass/objects/YC-FormGroup\";\r\n@import \"Sass/objects/YC-InputPassword\";\r\n@import \"Sass/objects/YC-Modal\";\r\n@import \"Sass/objects/YC-Table\";\r\n\r\n@import \"Sass/components/YC-BookCard\";\r\n@import \"Sass/components/YC-Footer\";\r\n@import \"Sass/components/YC-Lateral\";\r\n@import \"Sass/components/YC-Loader\";\r\n@import \"Sass/components/YC-MessageCard\";\r\n@import \"Sass/components/YC-Modal\";\r\n@import \"Sass/components/YC-SearchBar\";\r\n@import \"Sass/components/YC-ProfileCard\";\r\n@import \"Sass/components/YC-Pagination\";\r\n@import \"Sass/components/YC-ProgressBar\";\r\n@import \"Sass/components/YC-Tag\";\r\n\r\n@import \"Sass/pages/YC-About\";\r\n@import \"Sass/pages/YC-Country\";\r\n@import \"Sass/pages/YC-Courses\";\r\n@import \"Sass/pages/YC-Home\";\r\n@import \"Sass/pages/YC-Login\";\r\n@import \"Sass/pages/YC-ManageUsers\";\r\n@import \"Sass/pages/YC-Messages\";\r\n@import \"Sass/pages/YC-OnlineTeacher\";\r\n@import \"Sass/pages/YC-Profile\";\r\n@import \"Sass/pages/YC-ReportsPage\";\r\n@import \"Sass/pages/YC-Support\";\r\n@import \"Sass/pages/YC-TravelWorld\";\r\n@import \"Sass/pages/YC-ViewReport\";\r\n\r\n@import \"Sass/trumps/trumps\";\r\n\r\n\r\ninput[type=checkbox]{\r\n    -webkit-appearance: none;\r\n\tborder: 1px solid #4e2d78;\r\n\tpadding: inherit;\r\n\tborder-radius: 3px;\r\n\tdisplay: inline-block;\r\n    position: relative;\r\n    color: #4e2d78;\r\n    &:checked{\r\n        &:after{\r\n            content: \"\\2714\";\r\n            font-size: 20px;\r\n            position: absolute;\r\n            left: 4px;\r\n            top: -3px;\r\n            \r\n        }\r\n    }\r\n}","// SASS variables for normal drag handle and bar size.\n// Override in your scss file by setting these variables FIRST, then including this file.\n$drag-handle-width: 10px !default;\n$drag-handle-height: 10px !default;\n$drag-bar-size: 6px !default;\n\n// Query to kick us into \"mobile\" mode with larger drag handles/bars.\n// See: https://developer.mozilla.org/en-US/docs/Web/CSS/@media/pointer\n$mobile-media-query: '(pointer: coarse)' !default;\n\n// Mobile handle/bar sizes.  Override as above.\n$drag-handle-mobile-width: 24px !default;\n$drag-handle-mobile-height: 24px !default;\n\n// Handle color/border.\n$drag-handle-background-colour: rgba(0, 0, 0, 0.2) !default;\n$drag-handle-border: 1px solid rgba(255, 255, 255, 0.7) !default;\n\n.ReactCrop {\n  position: relative;\n  display: inline-block;\n  cursor: crosshair;\n  overflow: hidden;\n  max-width: 100%;\n\n  &:focus {\n    outline: none;\n  }\n\n  &--disabled,\n  &--locked {\n    cursor: inherit;\n  }\n\n  &__image {\n    display: block;\n    max-width: 100%;\n    touch-action: manipulation;\n  }\n\n  &__crop-selection {\n    position: absolute;\n    top: 0;\n    left: 0;\n    transform: translate3d(0, 0, 0);\n    box-sizing: border-box;\n    cursor: move;\n    box-shadow: 0 0 0 9999em rgba(0, 0, 0, 0.5);\n    touch-action: manipulation;\n\n    .ReactCrop--disabled & {\n      cursor: inherit;\n    }\n\n    .ReactCrop--circular-crop & {\n      border-radius: 50%;\n      box-shadow: 0px 0px 1px 1px white, 0 0 0 9999em rgba(0, 0, 0, 0.5);\n    }\n\n    border: 1px solid;\n    border-image-source: url('data:image/gif;base64,R0lGODlhCgAKAJECAAAAAP///////wAAACH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUDw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OEI5RDc5MTFDNkE2MTFFM0JCMDZEODI2QTI4MzJBOTIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OEI5RDc5MTBDNkE2MTFFM0JCMDZEODI2QTI4MzJBOTIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuZGlkOjAyODAxMTc0MDcyMDY4MTE4MDgzQzNDMjA5MzREQ0ZDIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjAyODAxMTc0MDcyMDY4MTE4MDgzQzNDMjA5MzREQ0ZDIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEBQoAAgAsAAAAAAoACgAAAhWEERkn7W3ei7KlagMWF/dKgYeyGAUAIfkEBQoAAgAsAAAAAAoACgAAAg+UYwLJ7RnQm7QmsCyVKhUAIfkEBQoAAgAsAAAAAAoACgAAAhCUYgLJHdiinNSAVfOEKoUCACH5BAUKAAIALAAAAAAKAAoAAAIRVISAdusPo3RAzYtjaMIaUQAAIfkEBQoAAgAsAAAAAAoACgAAAg+MDiem7Q8bSLFaG5il6xQAIfkEBQoAAgAsAAAAAAoACgAAAg+UYRLJ7QnQm7SmsCyVKhUAIfkEBQoAAgAsAAAAAAoACgAAAhCUYBLJDdiinNSEVfOEKoECACH5BAUKAAIALAAAAAAKAAoAAAIRFISBdusPo3RBzYsjaMIaUQAAOw==');\n    border-image-slice: 1;\n    border-image-repeat: repeat;\n  }\n  &--invisible-crop &__crop-selection {\n    display: none;\n  }\n\n  &__rule-of-thirds-vt::before,\n  &__rule-of-thirds-vt::after,\n  &__rule-of-thirds-hz::before,\n  &__rule-of-thirds-hz::after {\n    content: '';\n    display: block;\n    position: absolute;\n    background-color: rgba(255, 255, 255, 0.4);\n  }\n\n  &__rule-of-thirds-vt {\n    &::before,\n    &::after {\n      width: 1px;\n      height: 100%;\n    }\n\n    &::before {\n      left: 33.3333%;\n      left: calc(100% / 3);\n    }\n\n    &::after {\n      left: 66.6666%;\n      left: calc(100% / 3 * 2);\n    }\n  }\n\n  &__rule-of-thirds-hz {\n    &::before,\n    &::after {\n      width: 100%;\n      height: 1px;\n    }\n\n    &::before {\n      top: 33.3333%;\n      top: calc(100% / 3);\n    }\n\n    &::after {\n      top: 66.6666%;\n      top: calc(100% / 3 * 2);\n    }\n  }\n\n  &__drag-handle {\n    position: absolute;\n\n    &::after {\n      position: absolute;\n      content: '';\n      display: block;\n      width: $drag-handle-width;\n      height: $drag-handle-height;\n      background-color: $drag-handle-background-colour;\n      border: $drag-handle-border;\n      box-sizing: border-box;\n\n      // This stops the borders disappearing when keyboard\n      // nudging.\n      outline: 1px solid transparent;\n    }\n  }\n\n  .ord-nw {\n    top: 0;\n    left: 0;\n    margin-top: -(ceil($drag-handle-height / 2));\n    margin-left: -(ceil($drag-handle-width / 2));\n    cursor: nw-resize;\n\n    &::after {\n      top: 0;\n      left: 0;\n    }\n  }\n  .ord-n {\n    top: 0;\n    left: 50%;\n    margin-top: -(ceil($drag-handle-height / 2));\n    margin-left: -(ceil($drag-handle-width / 2));\n    cursor: n-resize;\n\n    &::after {\n      top: 0;\n    }\n  }\n  .ord-ne {\n    top: 0;\n    right: 0;\n    margin-top: -(ceil($drag-handle-height / 2));\n    margin-right: -(ceil($drag-handle-width / 2));\n    cursor: ne-resize;\n\n    &::after {\n      top: 0;\n      right: 0;\n    }\n  }\n  .ord-e {\n    top: 50%;\n    right: 0;\n    margin-top: -(ceil($drag-handle-height / 2));\n    margin-right: -(ceil($drag-handle-width / 2));\n    cursor: e-resize;\n\n    &::after {\n      right: 0;\n    }\n  }\n  .ord-se {\n    bottom: 0;\n    right: 0;\n    margin-bottom: -(ceil($drag-handle-height / 2));\n    margin-right: -(ceil($drag-handle-width / 2));\n    cursor: se-resize;\n\n    &::after {\n      bottom: 0;\n      right: 0;\n    }\n  }\n  .ord-s {\n    bottom: 0;\n    left: 50%;\n    margin-bottom: -(ceil($drag-handle-height / 2));\n    margin-left: -(ceil($drag-handle-width / 2));\n    cursor: s-resize;\n\n    &::after {\n      bottom: 0;\n    }\n  }\n  .ord-sw {\n    bottom: 0;\n    left: 0;\n    margin-bottom: -(ceil($drag-handle-height / 2));\n    margin-left: -(ceil($drag-handle-width / 2));\n    cursor: sw-resize;\n\n    &::after {\n      bottom: 0;\n      left: 0;\n    }\n  }\n  .ord-w {\n    top: 50%;\n    left: 0;\n    margin-top: -(ceil($drag-handle-height / 2));\n    margin-left: -(ceil($drag-handle-width / 2));\n    cursor: w-resize;\n\n    &::after {\n      left: 0;\n    }\n  }\n\n  // Use the same specificity as the ords above but just\n  // come after.\n  &__disabled &__drag-handle {\n    cursor: inherit;\n  }\n\n  &__drag-bar {\n    position: absolute;\n\n    &.ord-n {\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: $drag-bar-size;\n      margin-top: -($drag-bar-size / 2);\n    }\n    &.ord-e {\n      right: 0;\n      top: 0;\n      width: $drag-bar-size;\n      height: 100%;\n      margin-right: -($drag-bar-size / 2);\n    }\n    &.ord-s {\n      bottom: 0;\n      left: 0;\n      width: 100%;\n      height: $drag-bar-size;\n      margin-bottom: -($drag-bar-size / 2);\n    }\n    &.ord-w {\n      top: 0;\n      left: 0;\n      width: $drag-bar-size;\n      height: 100%;\n      margin-left: -($drag-bar-size / 2);\n    }\n  }\n\n  &--new-crop &__drag-bar,\n  &--new-crop &__drag-handle,\n  &--fixed-aspect &__drag-bar {\n    display: none;\n  }\n\n  &--fixed-aspect &__drag-handle.ord-n,\n  &--fixed-aspect &__drag-handle.ord-e,\n  &--fixed-aspect &__drag-handle.ord-s,\n  &--fixed-aspect &__drag-handle.ord-w {\n    display: none;\n  }\n\n  @media #{$mobile-media-query} {\n    .ord-n,\n    .ord-e,\n    .ord-s,\n    .ord-w {\n      display: none;\n    }\n\n    &__drag-handle {\n      width: $drag-handle-mobile-width;\n      height: $drag-handle-mobile-height;\n    }\n  }\n}\n","// Pode ser qualquer coisa, desde mixins de font-face, até mixins de animações, etc\r\n\r\n\r\n// @font-face{\r\n//     font-family:\"Roboto-Regular\";\r\n//     src:url(\"Assets/fonts/Roboto-Regular.otf\");\r\n// }\r\n\r\n@font-face{\r\n    font-family:\"Panton-Black\";\r\n    src:url(\"Assets/fonts/Panton-Black.otf\");\r\n}\r\n\r\n@font-face{\r\n    font-family:\"Panton-BlackItalic\";\r\n    src:url(\"Assets/fonts/Panton-BlackItalic.otf\");\r\n}\r\n\r\n@font-face{\r\n    font-family:\"Panton-Bold\";\r\n    src:url(\"Assets/fonts/Panton-Bold.otf\");\r\n}\r\n\r\n@font-face{\r\n    font-family:\"Panton-BoldItalic\";\r\n    src:url(\"Assets/fonts/Panton-BoldItalic.otf\");\r\n}\r\n\r\n\r\n@font-face{\r\n    font-family:\"Panton-ExtraBold\";\r\n    src:url(\"Assets/fonts/Panton-ExtraBold.otf\");\r\n}\r\n\r\n\r\n@font-face{\r\n    font-family:\"Panton-ExtraBoldItalic\";\r\n    src:url(\"Assets/fonts/Panton-ExtraBoldItalic.otf\");\r\n}\r\n\r\n\r\n@font-face{\r\n    font-family:\"Panton-ExtraLight\";\r\n    src:url(\"Assets/fonts/Panton-ExtraLight.otf\");\r\n}\r\n\r\n@font-face{\r\n    font-family:\"Panton-Fat\";\r\n    src:url(\"Assets/fonts/Panton-Fat.otf\");\r\n}\r\n\r\n@font-face{\r\n    font-family:\"Panton-FatItalic\";\r\n    src:url(\"Assets/fonts/Panton-FatItalic.otf\");\r\n}\r\n\r\n@font-face{\r\n    font-family:\"Panton-Heavy\";\r\n    src:url(\"Assets/fonts/Panton-Heavy.otf\");\r\n}\r\n\r\n@font-face{\r\n    font-family:\"Panton-Light\";\r\n    src:url(\"Assets/fonts/Panton-Light.otf\");\r\n}\r\n\r\n@font-face{\r\n    font-family:\"Panton-LightItalic\";\r\n    src:url(\"Assets/fonts/Panton-LightItalic.otf\");\r\n}\r\n\r\n@font-face{\r\n    font-family:\"Panton-Regular\";\r\n    src:url(\"Assets/fonts/Panton-Regular.otf\")\r\n}\r\n\r\n@font-face{\r\n    font-family:\"Panton-RegularItalic\";\r\n    src:url(\"Assets/fonts/Panton-RegularItalic.otf\")\r\n}\r\n\r\n@font-face{\r\n    font-family:\"Panton-SemiBold\";\r\n    src:url(\"Assets/fonts/Panton-SemiBold.otf\")\r\n}\r\n\r\n@font-face{\r\n    font-family:\"Panton-SemiBoldItalic\";\r\n    src:url(\"Assets/fonts/Panton-SemiBoldItalic.otf\")\r\n}\r\n\r\n@font-face{\r\n    font-family:\"Panton-Thin\";\r\n    src:url(\"Assets/fonts/Panton-Thin.otf\")\r\n}\r\n\r\n@font-face{\r\n    font-family:\"Panton-ThinItalic\";\r\n    src:url(\"Assets/fonts/Panton-ThinItalic.otf\")\r\n}\r\n\r\n@font-face{\r\n    font-family:\"OpenDyslexic\";\r\n    src:url(\"Assets/fonts/OpenDyslexic-Regular.otf\")\r\n}\r\n\r\n@font-face{\r\n    font-family:\"OpenDyslexic-Italic\";\r\n    src:url(\"Assets/fonts/OpenDyslexic-Italic.otf\")\r\n}\r\n\r\n@font-face{\r\n    font-family:\"OpenDyslexic-BoldItalic\";\r\n    src:url(\"Assets/fonts/OpenDyslexic-BoldItalic.otf\")\r\n}\r\n\r\n@font-face{\r\n    font-family:\"OpenDyslexic-Bold\";\r\n    src:url(\"Assets/fonts/OpenDyslexic-Bold.otf\")\r\n}\r\n","//é onde colocamos resets, box-sizing, etc.\r\n\r\n* {\r\n    box-sizing: border-box;\r\n    font-size: 16px;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\nbody{\r\n    background-color: #f0f5f6;\r\n    background-image: url('Assets/png/background.png');\r\n    color: #565656;\r\n    font-family: 'Panton-Regular', 'arial';\r\n    overflow-x: hidden;\r\n}\r\n\r\nmain {\r\n    position: relative;\r\n    //margin-bottom: 120px;\r\n    min-height: calc(100vh - 80px - 280px);\r\n    @media screen and (min-width: 768px) {\r\n        margin-bottom: 0;\r\n        position: initial;\r\n        top: 0;\r\n    }\r\n}\r\n\r\n.main-container {\r\n    min-height: calc(100vh - 80px - 350px);\r\n    margin-top: calc(50px + 32px);\r\n    @media screen and (min-width: 768px) {\r\n        margin-top: 0;\r\n    }\r\n}\r\n\r\nh1, .h1 {\r\n    font-size: 1.5rem;\r\n    line-height: 1.875rem; \r\n    @media screen and (min-width: 768px) {\r\n        font-size: 2.125rem;\r\n        line-height: 2.625rem; \r\n    }\r\n}\r\n\r\nh2, .h2 {\r\n    font-size: 1.1875rem;\r\n    line-height: 1.75rem; \r\n    @media screen and (min-width: 768px) {\r\n        font-size: 1.75rem;\r\n        line-height: 2.25rem; \r\n    } \r\n}\r\n\r\nh3, .h3 {\r\n    font-size: 1rem;\r\n    line-height: 1.375rem; \r\n    @media screen and (min-width: 768px) {\r\n        font-size: 1.25rem;\r\n        line-height: 1.75rem; \r\n    } \r\n}\r\n\r\nh4, .h4 {\r\n    font-size: 0.875rem;\r\n    line-height: 0.889rem; \r\n    @media screen and (min-width: 768px) {\r\n        font-size: 1.0625rem;\r\n        line-height: 1.1875rem; \r\n    } \r\n}\r\n\r\na {\r\n    color: $clickable;\r\n    font-size: 0.9375rem;\r\n    line-height: 1.125rem; \r\n    @media screen and (min-width: 768px) {\r\n        font-size: 1rem;\r\n        line-height: 0.843rem; \r\n    } \r\n}\r\n\r\np {\r\n    font-size: 0.9375rem;\r\n    @media screen and (min-width: 768px) {\r\n        line-height: 1.5rem; \r\n    } \r\n}\r\n\r\n.toastify-error {\r\n    background: #BD362F;\r\n}\r\n\r\n.toastify-warning {\r\n    background: #F89406;\r\n}\r\n\r\n.toastify-success {\r\n    background: #51A351;\r\n}","//Em geral, são as variáveis globais que vão definir cores,\r\n//espaçamentos e outras configurações desejadas para o funcionamento do seu framework em si.\r\n\r\n$backgroundPage:    #f0f5f6;\r\n\r\n$mainPurple:        #4e2d78;\r\n$lightPurple:       #643E94;\r\n$darkPurple:        #2C134C;\r\n\r\n$progressBar:       #D5B3FF;\r\n\r\n$clickable:         #79b100;\r\n$lightGreen:        #BFD747;\r\n$completed:         #00a281;\r\n$disabled:          #F0F5F6;\r\n$muted:             #989898;\r\n\r\n$textColor:         #424242;\r\n$line:              #79B100;\r\n$baseFooter:        #505759;\r\n$title:             #565656;\r\n\r\n$error:             #f44336;\r\n\r\n$baseContainer:     #fff;\r\n",".container-input {\r\n    align-items: flex-end;\r\n    position: relative;\r\n    padding-left: 35px;\r\n    margin-bottom: 12px;\r\n    cursor: pointer;\r\n    user-select: none;\r\n    display: flex;\r\n    flex-flow: row wrap;\r\n}\r\n\r\n/* Hide the browser's default checkbox */\r\n.container-input input {\r\n    position: absolute;\r\n    opacity: 0;\r\n    cursor: pointer;\r\n    height: 0;\r\n    width: 0;\r\n    margin: 0;\r\n\r\n}\r\n\r\n/* Create the checkmark/indicator (hidden when not checked) */\r\n.checkmark:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    display: none;\r\n}\r\n\r\n/* Show the checkmark when checked */\r\n.container-input input:checked~.checkmark:after {\r\n    display: block;\r\n}\r\n\r\n/* Style the checkmark/indicator */\r\n.container-input .checkmark:after {\r\n    left: 9px;\r\n    top: 5px;\r\n    width: 5px;\r\n    height: 10px;\r\n    border: 2px solid $clickable;\r\n    border-width: 0 3px 3px 0;\r\n    transform: rotate(45deg);\r\n}\r\n",".input-password {\r\n    position: relative;\r\n    .input-toggle-password {\r\n        cursor: pointer;\r\n        position: absolute;\r\n        right: 15px;\r\n        top: 32px;\r\n        z-index: 3;\r\n    }\r\n}",".modal-backdrop {\r\n    height: 100%;\r\n    min-width: 100vw;\r\n    min-height: 100vh;\r\n    width: 100%;\r\n}\r\n\r\n.modal-backdrop.show {\r\n    opacity: .9;\r\n}\r\n\r\n.modal-background {\r\n    @media screen and (min-width: 1024px) {\r\n        background-image: url('Assets/png/first-video-bg.png');\r\n        background-size: 95%;\r\n        background-repeat: no-repeat;\r\n        background-position: center;\r\n    }\r\n}\r\n\r\n/* TODO Renomear na é usado somente no first access */\r\n.first-access {\r\n    align-items: flex-start;\r\n    border-bottom: 0;\r\n    display: flex;\r\n    flex-flow: column-reverse;\r\n\r\n    @media screen and (min-width: 1024px) {\r\n        display: flex;\r\n        flex-flow: row;\r\n        align-items: center;\r\n    }\r\n\r\n    .close {\r\n        margin-bottom: 40px;\r\n        text-align: right;\r\n        text-shadow: none;\r\n        width: 100%;\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            width: auto;\r\n            margin-bottom: 0;\r\n        }\r\n\r\n        span:first-child {\r\n            float: right;\r\n            position: relative;\r\n            top: 8px;\r\n        }\r\n\r\n        .sr-only {\r\n            position: relative;\r\n            margin-right: 15px;\r\n        }\r\n    }\r\n\r\n    .modal-content {\r\n        background-color: transparent !important;\r\n        border: none !important;\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            padding: 50px;\r\n        }\r\n\r\n        .modal-header {\r\n            color: #fff;\r\n            padding: 0;\r\n\r\n            @media screen and (min-width: 1024px) {\r\n                flex-flow: row nowrap;\r\n            }\r\n\r\n            &.first-access {\r\n                font-size: 24px;\r\n                margin-bottom: 15px;\r\n\r\n                @media screen and (min-width: 1024px) {\r\n                    font-size: 34px;\r\n                    margin-bottom: 30px;\r\n                }\r\n            }\r\n\r\n            button {\r\n                color: #fff;\r\n                opacity: 1;\r\n            }\r\n        }\r\n    }\r\n\r\n    .first-access-iframe {\r\n        height: auto;\r\n        object-fit: cover;\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            height: 452px;\r\n        }\r\n    }\r\n}\r\n\r\n.modal-content {\r\n    padding: 24px;\r\n\r\n\r\n    .modal-body {\r\n        padding: 0;\r\n        border-radius: 8px;\r\n    }\r\n}\r\n",".explore-table {\r\n    thead th:last-child,\r\n    .table-line td:last-child {\r\n        text-align: right;\r\n    }\r\n}","\r\n.card-container {\r\n    width: 70%;\r\n    margin-left: 8px;\r\n    @media screen and (min-width: 1024px) {\r\n        width: 33%;\r\n    }\r\n}\r\n",".YC-Footer {\r\n    margin-top: 48px;\r\n    @media screen and (min-width: 1027px) {\r\n        margin-top: 100px;\r\n    }\r\n}\r\n\r\n.YC-Footer-bottom {\r\n    background-color: #505759;\r\n    color: #C5CBCC;\r\n    display: flex;\r\n    flex-flow: column wrap;\r\n    justify-content: center;\r\n    height: 86px;\r\n//margin-bottom: 50px;\r\n    @media (min-width: 768px) {\r\n        margin-bottom: 0;\r\n    }\r\n\r\n    .container {\r\n        align-items: center;\r\n        display: flex;\r\n        flex-flow: row wrap;\r\n        justify-content: space-between;\r\n\r\n        img {\r\n            width: 120px;\r\n        }\r\n    }\r\n}\r\n\r\n.allrights {\r\n    color: #FFFFFF;\r\n    font-size: 0.75rem;\r\n    margin: 16px 0 0;\r\n    opacity: 0.6;\r\n    text-align: center;\r\n    @media screen and (min-width: 1024px) {\r\n        margin: 0;\r\n        text-align: right;\r\n    }\r\n}\r\n",".YC-lateral {\r\n    background-color: #fff;\r\n    color: #424242;\r\n    height: 100vh;\r\n    padding: 36px;\r\n    position: fixed;\r\n    transition: transform 1s cubic-bezier(0, .52, 0, 1);\r\n    top: 0;\r\n    z-index: 10;\r\n    @media screen and (min-width: 768px) {\r\n        padding: 36px;\r\n    }\r\n\r\n    h4 {\r\n        .close-modal {\r\n            max-width: 80px;\r\n            padding-right: 0;\r\n            text-align: right;\r\n        }\r\n    }\r\n}\r\n\r\n.YC-lateral-menu-enter {\r\n    right: 0;\r\n    transform: translate3d(100vw, 0, 0);\r\n    width: 80%;\r\n    @media screen and (min-width: 768px) {\r\n        width: 65%;\r\n    }\r\n}\r\n\r\n.YC-lateral-menu-enter-active,\r\n.YC-lateral-menu-enter-done {\r\n    left: 0;\r\n    transform: translate3d(0vw, 0, 0);\r\n    transition: transform .8s cubic-bezier(0, .52, 0, 1);\r\n    width: 100%;\r\n\r\n    @media screen and (min-width: 768px) {\r\n        left: auto;\r\n        right: 0;\r\n        width: 65%;\r\n    }\r\n}\r\n\r\n.YC-lateral-menu-exit {\r\n    box-shadow: none!important;\r\n    right: 0;\r\n    transform: translate3d(100vw, 0, 0);\r\n    @media screen and (min-width: 768px) {\r\n        width: 65%;\r\n    }\r\n}\r\n\r\n.YC-lateral-menu-exit-active,\r\n.YC-lateral-menu-exit-done {\r\n    transform: translate3d(100vw, 0, 0);\r\n    transition: transform .8s cubic-bezier(0, .52, 0, 1);\r\n}\r\n\r\n.lateral-header {\r\n    right: 0;\r\n    padding: 62px 16px 34px;\r\n    width: 80%;\r\n    z-index: 10000;\r\n    @media screen and (min-width: 1024px) {\r\n        padding: 16px 16px 34px;\r\n        width: 50%;\r\n    }\r\n\r\n    .lateral-header--title {\r\n        align-items: center;\r\n        display: flex;\r\n        flex-flow: row wrap;\r\n        justify-content: space-between;\r\n    }\r\n\r\n    .header-filter {\r\n        align-self: end;\r\n        align-items: center;\r\n        display: flex;\r\n        flex-flow: row wrap;\r\n        justify-content: space-around;\r\n        width: 100%;\r\n\r\n        .header-filter--select {\r\n            width: 33%;\r\n            @media screen and (min-width: 1024px) {\r\n                // TODO Change to this width when input text is done\r\n                // width: 25%;\r\n                width: 43%;\r\n            }\r\n        }\r\n    }\r\n    &.with-navbar {\r\n        padding: 64px 16px 34px;\r\n    }\r\n}\r\n\r\n.lateral-menu-mobile {\r\n    height: calc(100vh - 55px);\r\n    overflow-y: scroll;\r\n    max-height: calc(100vh - 55px);\r\n    padding: 0;\r\n    top: 55px;\r\n    width: 80%;\r\n    @media screen and (min-width: 768px) {\r\n        display: none;\r\n        height: calc(100vh - 80px);\r\n        top: 80px;\r\n        width: 50%;\r\n    }\r\n}\r\n\r\n.lateral-course-stamps {\r\n    right: 0;\r\n    transform: translate3d(700px, 0, 0);\r\n    width: 700px;\r\n    &.active {\r\n        transform: translate3d(0vw, 0, 0);\r\n        transition: transform .8s cubic-bezier(0, .52, 0, 1);\r\n    }\r\n}\r\n\r\n.lateral-course-download {\r\n    right: 0;\r\n    transform: translate3d(700px, 0, 0);\r\n    width: 700px;\r\n    &.active {\r\n        transform: translate3d(0vw, 0, 0);\r\n        transition: transform .8s cubic-bezier(0, .52, 0, 1);\r\n    }\r\n}\r\n\r\n\r\n.lateral-audio {\r\n    right: 0;\r\n    transform: translate3d(110vw, 0, 0);\r\n    width: 100vw;\r\n    z-index: 1030;\r\n    @media screen and (min-width: 1024px) {\r\n        width: 50%;\r\n    }\r\n    &.active {\r\n        transform: translate3d(0vw, 0, 0);\r\n        transition: transform .8s cubic-bezier(0, .52, 0, 1);\r\n    }\r\n}\r\n\r\n.lateral-progress {\r\n    right: 0;\r\n    transform: translate3d(800px, 0, 0);\r\n    width: 800px;\r\n    &.active {\r\n        transform: translate3d(0vw, 0, 0);\r\n        transition: transform .8s cubic-bezier(0, .52, 0, 1);\r\n    }\r\n}\r\n\r\n.lateral-filter {\r\n    right: 0;\r\n    padding: 16px 16px 34px;\r\n    width: 100%;\r\n    z-index: 1040;\r\n    @media screen and (min-width: 1024px) {\r\n        padding: 16px 16px 34px;\r\n        width: 50%;\r\n    }\r\n\r\n    .lateral-header--title {\r\n        align-items: center;\r\n        display: flex;\r\n        flex-flow: row wrap;\r\n        justify-content: space-between;\r\n    }\r\n\r\n    .header-filter {\r\n        align-self: end;\r\n        align-items: center;\r\n        display: flex;\r\n        flex-flow: row wrap;\r\n        justify-content: space-around;\r\n        width: 100%;\r\n    }\r\n    &.with-navbar {\r\n        padding: 64px 16px 34px;\r\n    }\r\n}\r\n",".bg-loader {\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    height: calc(100% + 50px);\r\n    left: 0;\r\n    max-width: 100vw;\r\n    position: fixed;\r\n    top: -50px;\r\n    width: 100%;\r\n    z-index: 9999;\r\n}\r\n\r\n.loader-bg {\r\n    position: absolute;\r\n    left: calc(50% - 20px);\r\n    top: calc(50% - 20px);\r\n    width: 40px;\r\n    height: 40px;\r\n    border: 4px #FAFAFA solid;\r\n    border-radius: 30px;\r\n}\r\n\r\n.loader {\r\n    position: absolute;\r\n    left: calc(50% - 20px);\r\n    top: calc(50% - 20px);\r\n    width: 40px;\r\n    height: 40px;\r\n    border: 4px transparent solid;\r\n    border-top: 4px $lightPurple solid;\r\n    border-radius: 30px;\r\n    animation: loader .7s infinite;\r\n    animation-timing-function: linear;\r\n}\r\n\r\n@-moz-keyframes loader {\r\n    0% {\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@-webkit-keyframes loader {\r\n    0% {\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@keyframes loader {\r\n    0% {\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n        transform: rotate(360deg);\r\n    }\r\n}",".modal-dialog {\r\n\r\n    .first-access {\r\n        border-bottom: 0;\r\n\r\n        .modal-content {\r\n            background-color: transparent!important;\r\n            border: none!important;\r\n            padding: 50px;\r\n\r\n            .modal-header {\r\n                color: #fff;\r\n                padding: 0;\r\n\r\n                &.first-access {\r\n                    margin-bottom: 30px;\r\n                    z-index: 10;\r\n                }\r\n\r\n                button {\r\n                    color: #fff;\r\n                    opacity: 1;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .modal-header {\r\n        margin-bottom: 24px;\r\n        padding: 0;\r\n\r\n        .modal-title {\r\n            background-color: #fff;\r\n            padding: 4px;\r\n            transform: translateY(-50%);\r\n            color: $mainPurple;\r\n        }\r\n    }\r\n}\r\n\r\n// .modal-qrcode {\r\n//     .modal-dialog {\r\n//         height: 80vh;\r\n\r\n//         .modal-content {\r\n//             height: 100%;\r\n//         }\r\n//     }\r\n// }","// .searchbar {\r\n//     border: 0.5px solid #E1E6E7;\r\n\r\n//     .searchbar-input {\r\n//         border: none;\r\n//         border-left: 1px solid #e1e6e7;\r\n//         border-bottom: $clickable solid 2px;\r\n//         border-radius: 0;\r\n//         height: 50px;\r\n//     }\r\n    \r\n//     .input-group-text {\r\n//         background-color: #fff;\r\n//         border: #fff solid 1px;\r\n//         border-bottom: $clickable solid 2px;\r\n//         border-right: 1px solid #e1e6e7;\r\n//         border-radius: 0;\r\n//         height: 50px;\r\n//     }\r\n// }\r\n\r\n\r\n.search-file{\r\n    cursor: text !important;\r\n    width: 14rem !important;\r\n}\r\n",".YC-ProfileCard {\r\n    .user-level {\r\n        border-radius: 50%;\r\n        bottom: 0;\r\n        color: #fff;\r\n        height: 40px;\r\n        position: absolute;\r\n        right: 10%;\r\n        width: 40px;\r\n    }\r\n\r\n    .border-line {\r\n        border-top: 1px solid #eeeeee;\r\n    }\r\n}\r\n\r\n.border-white {\r\n    width: 20%;\r\n    z-index: 3;\r\n    justify-content: center;\r\n\r\n}\r\n\r\n.level-progress-patent {\r\n    font-size: 70%;\r\n}\r\n\r\n.level-progress-bar {\r\n    background-color: #c9c9c9;\r\n    border-radius: 50px;\r\n    height: 6px;\r\n    margin: 16px 0;\r\n    width: 60%;\r\n\r\n    .progress-bar-number {\r\n        align-items: center;\r\n        border: solid 2px #fff;\r\n        border-radius: 50%;\r\n        color: #fff;\r\n        display: flex;\r\n        flex-flow: row wrap;\r\n        font-size: .75rem;\r\n        justify-content: center;\r\n        height: 25px;\r\n        position: relative;\r\n        top: -15px;\r\n        width: 25px;\r\n        z-index: 3;\r\n    }\r\n\r\n    small {\r\n        color: $lightPurple;\r\n        display: block;\r\n        position: relative;\r\n        text-align: center;\r\n        top: -5px;\r\n        width: 80px;\r\n    }\r\n\r\n    .completed-progress-bar {\r\n        background-color: $lightPurple;\r\n        height: 2px;\r\n        position: relative;\r\n        top: 2px;\r\n    \r\n        &::after {\r\n            background-color: #fff;\r\n            border: 2px solid $lightPurple;\r\n            border-radius: 50%;\r\n            content: '';\r\n            height: 15px;\r\n            position: relative;\r\n            float: right;\r\n            top: -6px;\r\n            width: 15px;\r\n            z-index: 2;\r\n        }\r\n    }\r\n\r\n    .completed-tags {\r\n        font-size: 0.75rem;\r\n        margin-top: 8px;\r\n        text-align: center;\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n\r\n.profile-status {\r\n    width: 100%;\r\n\r\n    .profile-status-item {\r\n        // width: 25%;\r\n\r\n        .status-item-title {\r\n            color: #c0c0c0;\r\n            font-size: 0.75rem;\r\n\r\n        }\r\n\r\n        .status-item-subtitle {}\r\n    }\r\n}\r\n\r\n.progress-user-steps {\r\n\r\n    .progress-steps-bar {\r\n        background-color: #c9c9c9;\r\n        border-radius: 8px;\r\n        max-height: 90%;\r\n        width: 3px;\r\n        .current-progress {\r\n            width: 1px;\r\n            background-color: $lightPurple;\r\n            left: 1px;\r\n            position: relative;\r\n\r\n            &::after {\r\n                background-color: #fff;\r\n                border: 2px solid $lightPurple;\r\n                border-radius: 50%;\r\n                bottom: -5px;\r\n                content: '';\r\n                display: block;\r\n                height: 15px;\r\n                left: -7px;\r\n                position: absolute;\r\n                width: 15px;\r\n                z-index: 2;\r\n            }\r\n        }\r\n    }\r\n\r\n    .user-step {\r\n\r\n        .user-step-tag {\r\n            background-color: #fff;\r\n            border: 2px solid $lightPurple;\r\n            border-radius: 50%;\r\n            filter: grayscale(100%);\r\n            left: -19px;\r\n            padding: 5px;\r\n            position: relative;\r\n            width: 35px;\r\n            z-index: 3;\r\n\r\n            &.completed {\r\n                filter: grayscale(0);\r\n            }\r\n        }\r\n    }\r\n}\r\n",".YC-Pagination {\r\n    -moz-user-select: none;\r\n    -webkit-user-select: none;\r\n    -ms-user-select:none;\r\n    user-select:none;\r\n    -o-user-select:none;\r\n    justify-content: center;\r\n    padding: 16px 0;\r\n\r\n    li {\r\n        cursor: pointer;\r\n        padding: 0 4px;\r\n        &:hover {\r\n            color: $clickable;\r\n        }\r\n    }\r\n\r\n    li.active {\r\n        font-weight: bold;\r\n        cursor: context-menu;\r\n        > a {\r\n            color: #424242;\r\n        }\r\n    }\r\n\r\n    .disabled {\r\n        color: $disabled!important;\r\n        cursor: not-allowed;\r\n        &:hover {\r\n            color: $disabled;\r\n            text-decoration: none;\r\n        }\r\n    }\r\n}\r\n",".progress {\r\n    background-color: #e1e6e7;\r\n    height: 8px;\r\n    width: 100%;\r\n\r\n    &.w-35 {\r\n        width: 35%!important;\r\n    }\r\n\r\n    .progress-bar {\r\n        background-color: $lightPurple;\r\n        border-radius: 50px;\r\n        height: 4px;\r\n        margin: 2px;\r\n        width: 40%;\r\n    }\r\n    &.completed {\r\n        background-color: #b8f2e6;\r\n        .progress-bar {\r\n            background-color: $completed;\r\n        }\r\n\r\n    }\r\n}\r\n",".tag {\r\n    flex: 1 1 auto;\r\n    height: 60px;\r\n    width: 60px;\r\n\r\n    .tag-title {\r\n        color: #424242;\r\n        position: relative;\r\n        text-align: center;\r\n        top: 4px;\r\n    }\r\n\r\n    .tag-country {\r\n        color: #616161;\r\n        font-size: 13px;\r\n        line-height: 1rem;\r\n        margin-top: 8px;\r\n        position: relative;\r\n        text-align: center;\r\n        text-decoration: none;\r\n    }\r\n}\r\n",".about-card {\r\n    \r\n    background-color: $lightPurple!important;\r\n    display: flex;\r\n    \r\n    padding: 0!important;\r\n    @media screen and (min-width: 1024px) {\r\n        align-items: center;\r\n        flex-flow: column wrap;\r\n        height: 351px;\r\n        margin-top: 48px!important;\r\n        margin-left: 56px!important;\r\n        padding: 40px!important;\r\n    }\r\n\r\n    .about-card-video {\r\n        border-radius: 8px 8px 0 0;\r\n        max-height: 200px;\r\n        object-fit: cover;\r\n        @media screen and (min-width: 1024px) {\r\n            border-radius: 0;\r\n            height: 350px;\r\n            max-height: fit-content;\r\n            transform: translate(-20%, -30%);\r\n            width: 50%;\r\n        }\r\n    }\r\n    .about-card-info {\r\n        color: #fff;\r\n        display: flex;\r\n        flex-flow: column wrap;\r\n        justify-content: center;\r\n        height: 100%;\r\n        padding: 16px;\r\n        @media screen and (min-width: 1024px) {\r\n            display: flex;\r\n            flex-flow: column wrap;\r\n            justify-content: flex-start;\r\n            height: 100%;\r\n            width: 50%;\r\n        }\r\n        .card-info--title {\r\n            margin: 16px 0;\r\n        }\r\n    }\r\n}\r\n\r\n.learning {\r\n    .learning-title {\r\n        margin: 0 0 16px;\r\n        @media screen and (min-width: 1024px) {\r\n            margin: 60px 0 40px;\r\n        }\r\n    }\r\n    .learning-cards {\r\n        display: flex;\r\n        flex-flow: row wrap;\r\n        justify-content: space-between;\r\n        @media screen and (min-width: 1024px) {\r\n            margin-bottom: 60px;\r\n        }\r\n\r\n    \r\n        .learning-card {\r\n            align-items: center;\r\n            display: flex;\r\n            flex-flow: column wrap;\r\n            justify-content: space-around;\r\n            margin-bottom: 24px;\r\n            @media screen and (min-width: 1024px) {\r\n                width: 30%;\r\n            }\r\n\r\n            figure {\r\n                margin: 8px 0 24px;\r\n            }\r\n\r\n            .learning-card--title {\r\n                margin-bottom: 16px;\r\n            }\r\n\r\n            .learning-card--description {\r\n                margin-bottom: 24px;\r\n                text-align: center;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.comments-cards {\r\n    display: flex;\r\n    flex-flow: row wrap;\r\n    justify-content: space-between;\r\n    .comment {\r\n        display: flex;\r\n        flex-flow: row wrap;\r\n        justify-content: space-between;\r\n        margin-right: 8px;\r\n        width: 90%;\r\n        @media screen and (min-width: 1024px) {\r\n            width: 45%;\r\n        }\r\n    }\r\n\r\n    .comment-figure {\r\n        @media screen and (min-width: 1024px) {\r\n            transform: translateX(-30%);\r\n        }\r\n    }\r\n\r\n    .comment-img {\r\n        border-radius: 50%;\r\n    }\r\n\r\n    .comment-statement {\r\n        font-size: 0.75rem;\r\n    }\r\n}",".countrypage {\r\n    .country-curiosity {\r\n        @media screen and (min-width: 1024px) {\r\n            font-size: 19px;\r\n            font-weight: 600;\r\n            line-height: 26px;\r\n            position: absolute;\r\n            text-align: left;\r\n            width: 330px;\r\n        }\r\n    }\r\n\r\n    .country-about {\r\n        border-left: solid 2px #e1e6e7;\r\n        display: flex;\r\n        flex-flow: column wrap;\r\n        margin-top: 37px;\r\n        margin-left: 8px;\r\n        padding-left: 24px;\r\n\r\n        .about-img-and-stamp {\r\n            display: flex;\r\n            flex-direction: row;\r\n            justify-content: center;\r\n        }\r\n\r\n        .about-img-stamp {\r\n            align-items: center;\r\n            background-color: #ffffff;\r\n            border-radius: 100%;\r\n            box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.11);\r\n            display: flex;\r\n            flex-flow: row wrap;\r\n            justify-content: center;\r\n            height: 90px;\r\n            position: absolute;\r\n            right: calc(16%);\r\n            width: 90px;\r\n\r\n            img {\r\n                width: 70px;\r\n            }\r\n        }\r\n\r\n        .country-about-img {\r\n            box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.11);\r\n            display: block;\r\n            margin: 0 0 37px 0;\r\n            position: relative;\r\n            right: 32px;\r\n            width: 120px;\r\n        }\r\n\r\n        .country-about-subtitle {\r\n            font-weight: 600;\r\n            margin: 0 0 16px 0;\r\n\r\n            &::before {\r\n                background-color: #fff;\r\n                border: 3px solid #e1e6e7;\r\n                border-radius: 50%;\r\n                content: \"\";\r\n                display: block;\r\n                height: 15px;\r\n                left: 17px;\r\n                position: absolute;\r\n                width: 15px;\r\n                z-index: 2;\r\n\r\n                @media screen and (min-width: 768px) {\r\n                    left: 42px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .country-about-description {\r\n            margin-bottom: 40px;\r\n        }\r\n\r\n        .country-about-map {\r\n            height: 320px;\r\n            margin-bottom: 24px;\r\n            width: 100%;\r\n        }\r\n    }\r\n\r\n    .country-about-desktop {\r\n        border-left: none;\r\n        display: flex;\r\n        flex-flow: row wrap;\r\n        margin-top: 37px;\r\n        margin-left: 0;\r\n        padding-left: 0;\r\n\r\n        .country-about-img {\r\n            box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.11);\r\n            display: block;\r\n            height: 167px;\r\n            margin: -32px auto 80px;\r\n            position: relative;\r\n            right: 0;\r\n            width: 251px;\r\n        }\r\n\r\n        .about-img-stamp {\r\n            align-items: center;\r\n            background-color: #ffffff;\r\n            border-radius: 100%;\r\n            box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.11);\r\n            display: flex;\r\n            flex-flow: row wrap;\r\n            justify-content: center;\r\n            height: 140px;\r\n            position: absolute;\r\n            right: calc(45% - 140px);\r\n            top: 110px;\r\n            width: 140px;\r\n\r\n            img {\r\n                width: 100px;\r\n            }\r\n        }\r\n\r\n        .about-country {\r\n            display: flex;\r\n            flex-flow: column wrap;\r\n            text-align: right;\r\n            width: 50%;\r\n            border-right: solid 2px #e1e6e7;\r\n            margin-left: 0px;\r\n            padding-right: 24px;\r\n        }\r\n\r\n        .about-map {\r\n            display: flex;\r\n            flex-flow: column wrap;\r\n            padding: 0 24px;\r\n            width: 50%;\r\n        }\r\n\r\n        .country-about-subtitle {\r\n            font-weight: 600;\r\n            margin: 0 0 16px 0;\r\n\r\n            &::after {\r\n                background-color: #fff;\r\n                border: 3px solid #e1e6e7;\r\n                border-radius: 50%;\r\n                content: \"\";\r\n                display: block;\r\n                height: 15px;\r\n                right: calc(50% - 6px);\r\n                margin-top: -20px;\r\n                position: absolute;\r\n                width: 15px;\r\n                z-index: 2;\r\n            }\r\n        }\r\n\r\n        .country-map-subtitle {\r\n            font-weight: 600;\r\n            display: block;\r\n            margin: 0 0 16px 0;\r\n            height: 26px;\r\n            width: 100%;\r\n        }\r\n\r\n        .country-about-map {\r\n            height: 320px;\r\n            width: 100%;\r\n\r\n            // div {\r\n            //     width: 450px;\r\n            // }\r\n        }\r\n    }\r\n\r\n    .tags {\r\n        margin-bottom: 36px;\r\n    }\r\n\r\n    .nav-tabs {\r\n        flex-flow: row nowrap;\r\n        overflow-x: scroll;\r\n        margin-bottom: 0;\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            overflow-x: hidden;\r\n            justify-content: space-between;\r\n        }\r\n\r\n        .tabheader-icon {\r\n            align-items: center;\r\n            display: flex;\r\n            flex-flow: column wrap;\r\n            justify-content: center;\r\n\r\n            svg {\r\n                fill: $clickable;\r\n                height: 35px;\r\n                width: 35px;\r\n            }\r\n\r\n            span {\r\n                margin: 8px 0;\r\n            }\r\n        }\r\n\r\n        .nav-link {\r\n            padding: 0 66px;\r\n            white-space: nowrap;\r\n\r\n            @media screen and (min-width: 1024px) {\r\n                padding: 0 46px;\r\n            }\r\n\r\n            .tabheader-icon {\r\n                svg {\r\n                    fill: $clickable !important;\r\n\r\n                    g {\r\n                        fill: $clickable !important;\r\n                    }\r\n                }\r\n            }\r\n\r\n            &.active {\r\n                white-space: nowrap;\r\n\r\n                .tabheader-icon {\r\n                    svg {\r\n                        fill: $mainPurple !important;\r\n\r\n                        g {\r\n                            fill: $mainPurple !important;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n            &.disabled {\r\n                svg {\r\n                    fill: #c5cbcc !important;\r\n\r\n                    g {\r\n                        fill: #c5cbcc !important;\r\n                    }\r\n                }\r\n\r\n                span {\r\n                    color: #c5cbcc !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .tab-content {\r\n        background-color: white;\r\n        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\r\n        padding: 16px;\r\n        border-bottom-right-radius: 8px;\r\n        border-bottom-left-radius: 8px;\r\n\r\n        .countrytab {\r\n            @media screen and (min-width: 1024px) {\r\n                align-items: center;\r\n                display: flex;\r\n                flex-flow: row wrap;\r\n                padding: 24px 50px;\r\n            }\r\n        }\r\n\r\n        .countrytab-picture {\r\n            max-width: 35px;\r\n        }\r\n\r\n        &.w-100 {\r\n            width: 100%;\r\n        }\r\n\r\n        .countrytab-content1 {\r\n            @media screen and (min-width: 1024px) {\r\n\r\n                // transform: translateY(-65px);\r\n                width: 45%;\r\n            }\r\n            ul {\r\n                padding: 16px;\r\n            }\r\n            display: flex;\r\n            flex-flow: row wrap;\r\n            justify-content: center;\r\n        }\r\n\r\n        .countrytab-content2 {\r\n            @media screen and (min-width: 1024px) {\r\n                display: flex;\r\n                flex-flow: row wrap;\r\n                justify-content: flex-start;\r\n                padding-left: 100px;\r\n                width: 55%;\r\n            }\r\n            ul {\r\n                padding: 16px;\r\n            }\r\n        }\r\n\r\n        .countrytab-title {\r\n            margin: 40px 0 16px;\r\n        }\r\n\r\n        .countrytab-tag {\r\n            align-items: center;\r\n            background-color: #fff;\r\n            border-radius: 50%;\r\n            box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.11) !important;\r\n            display: flex;\r\n            flex-flow: row wrap;\r\n            height: 90px;\r\n            justify-content: center;\r\n            position: absolute;\r\n            margin-top: -51px;\r\n            right: 15%;\r\n            width: 90px;\r\n\r\n            @media screen and (min-width: 360px) and (max-width: 767px) {\r\n                margin-top: 88px;\r\n                right: 4%;\r\n                width: 90px;\r\n            }\r\n\r\n            @media screen and (min-width: 767px) {\r\n                margin-top: 88px;\r\n                width: 90px;\r\n                right: calc(18% - 20px);\r\n            }\r\n\r\n            @media screen and (min-width: 992px) {\r\n                margin-top: 88px;\r\n                right: 24%;\r\n                width: 90px;\r\n            }\r\n\r\n            @media screen and (min-width: 1024px) {\r\n                margin-top: 90px;\r\n                right: calc(52% - 25px);\r\n                width: 90px;\r\n            }\r\n\r\n            @media screen and (min-width: 1200px) {\r\n                margin-top: 90px;\r\n                right: calc(54% - 25px);\r\n                width: 90px;\r\n            }\r\n        }\r\n\r\n        .video-tab {\r\n            @media screen and (min-width: 360px) {\r\n                margin-top: 130px;\r\n                right: calc(1% - 25px);\r\n                width: 90px;\r\n            }\r\n\r\n            @media screen and (min-width: 1024px) {\r\n                margin-top: 82px;\r\n                right: calc(52% - 20px);\r\n                width: 90px;\r\n            }\r\n        }\r\n\r\n        .countrytab-tag-padronizing {\r\n            max-width: 100%;\r\n            max-height: 268px;\r\n\r\n\r\n            @media screen and (min-width: 1024px) {\r\n                max-height: 405px;\r\n                max-width: 415px;\r\n            }\r\n\r\n            @media not all and (min-resolution:.001dpcm)\r\n            { @supports (-webkit-appearance:none) {\r\n\r\n                /*Safari browser*/\r\n                height: intrinsic;\r\n            }}\r\n        }\r\n\r\n        .bigger-width {\r\n            @media screen and (min-width: 1024px) {\r\n                height: 270px;\r\n                max-height: 270px;\r\n                max-width: 405px;\r\n                width: 100%;\r\n            }\r\n\r\n            @media screen and (min-width: 350px) {\r\n                height: 270px;\r\n                max-height: 270px;\r\n                max-width: 402px;\r\n                width: 100%;\r\n            }\r\n        }\r\n\r\n        .bigger-height {\r\n            @media screen and (min-width: 1024px) {\r\n                height: 415px;\r\n                max-height: 415px;\r\n                max-width: 275px;\r\n                width: 100%;\r\n            }\r\n\r\n            @media screen and (min-width: 360px) and (max-width: 1022px) {\r\n                max-height: 268px;\r\n                max-width: 178px;\r\n                height: 267px;\r\n            }\r\n        }\r\n\r\n        .default-image {\r\n            @media screen and (max-width: 1024px) {\r\n                max-height: 250px !important;\r\n            }\r\n        }\r\n    }\r\n\r\n    .testimonials {\r\n        height: 420px;\r\n        @media screen and (min-width: 1024px) {\r\n            height: 342px;\r\n            margin-top: 30px;\r\n            max-height: 342px;\r\n            overflow: hidden;\r\n        }\r\n    }\r\n\r\n    .share-card {\r\n        display: flex;\r\n        flex-flow: row wrap;\r\n        margin-top: 30px;\r\n        @media screen and (max-width: 768px) {\r\n            figure {\r\n                display: block;\r\n                margin: 0 auto 16px;\r\n            }\r\n        }\r\n\r\n        .form-group {\r\n            margin-top: 16px;\r\n            width: 100%;\r\n        }\r\n        @media screen and (min-width: 1024px) {\r\n            .form-group {\r\n                margin-top: 0;\r\n                width: 85%;\r\n            }\r\n        }\r\n    }\r\n    .share-footer {\r\n        display: flex;\r\n        flex-flow: row wrap;\r\n        justify-content: flex-end;\r\n        margin-bottom: 64px;\r\n    }\r\n}\r\n",".courses {\r\n    .courses-header {\r\n        img {\r\n            width: 80px;\r\n        }\r\n    }\r\n\r\n    .courses-header-title {\r\n        display: flex;\r\n        flex-flow: column wrap;\r\n        justify-content: space-around;\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            justify-content: flex-start;\r\n        }\r\n    }\r\n\r\n    .courses-stamps {\r\n        border: 1px solid $lightPurple;\r\n        border-radius: 50px;\r\n        font-size: 0.75rem;\r\n        margin: 0;\r\n        padding: 2px 10px;\r\n        text-align: center;\r\n    }\r\n}\r\n\r\n.courses-desktop {\r\n    display: flex;\r\n    flex-flow: row wrap;\r\n    justify-content: space-around;\r\n\r\n    figure {\r\n        width: 30%;\r\n\r\n        img {\r\n            width: 250px;\r\n        }\r\n\r\n        .courses-stamps {\r\n            bottom: 24px;\r\n            border-color: #fff;\r\n            color: #fff;\r\n            left: 70px;\r\n            position: absolute;\r\n\r\n            @media screen and (min-width: 1024px) {\r\n                bottom: 60px;\r\n                left: 100px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .courses-info {\r\n        display: flex;\r\n        flex-flow: column wrap;\r\n        justify-content: space-evenly;\r\n        width: 70%;\r\n\r\n    }\r\n}\r\n\r\n.courses-page {\r\n\r\n    .course-teacher-header {\r\n        // mb-4 d-flex flex-row justify-content-around align-items-center\r\n        align-items: center;\r\n        display: flex;\r\n        flex-flow: row wrap;\r\n        justify-content: space-around;\r\n\r\n        .course-teacher-content {\r\n            display: flex;\r\n            flex-flow: column wrap;\r\n\r\n            @media screen and (min-width: 1024px) {\r\n                justify-content: space-around;\r\n                align-items: center;\r\n            }\r\n        }\r\n\r\n        .searchbar {\r\n            @media screen and (min-width: 1024px) {\r\n                margin: auto;\r\n                max-width: 500px;\r\n                width: 40%;\r\n            }\r\n        }\r\n    }\r\n\r\n    .input-group {\r\n        margin-bottom: 43px;\r\n\r\n        .searchbar-input {\r\n            border-right: none;\r\n            height: 58px;\r\n        }\r\n\r\n        .input-group-text {\r\n            background-color: #fff;\r\n            border-left: none;\r\n            height: 58px;\r\n        }\r\n    }\r\n\r\n    .course-info {\r\n        display: flex;\r\n        flex-flow: column wrap;\r\n        justify-content: space-between;\r\n\r\n        @media screen and (min-width: 768px) {\r\n            margin-left: 3rem;\r\n            width: 60%;\r\n        }\r\n\r\n        .course-info-subtitle {\r\n            font-size: 0.5em;\r\n            margin-left: 8px;\r\n        }\r\n\r\n        .progress {\r\n            @media screen and (min-width: 768px) {\r\n                width: 35%;\r\n            }\r\n        }\r\n\r\n        .course-info-tasks {\r\n            @media screen and (min-width: 768px) {\r\n                width: 35%;\r\n            }\r\n\r\n            .course-info-percent {\r\n                color: $mainPurple;\r\n                font-size: 1.3em;\r\n            }\r\n        }\r\n\r\n        .btn-success {\r\n            background-color: $clickable;\r\n\r\n            @media screen and (min-width: 768px) {\r\n                width: 50%;\r\n            }\r\n        }\r\n    }\r\n\r\n    .book-courses {\r\n        display: flex;\r\n        justify-content: end;\r\n        margin-bottom: 100px;\r\n        width: 100%;\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            flex-flow: row wrap;\r\n        }\r\n\r\n    }\r\n\r\n    .book-courses.teacher-card {\r\n        .YC-CourseCard {\r\n            width: 100%;\r\n        }\r\n    }\r\n\r\n    .yconnect-course {\r\n        background-position: bottom;\r\n        background-repeat: no-repeat;\r\n        background-size: cover;\r\n\r\n    }\r\n\r\n    .YC-CourseLink {\r\n        cursor: pointer;\r\n        display: flex;\r\n        flex-flow: row wrap;\r\n        justify-content: space-between;\r\n        margin-bottom: 30px;\r\n        width: 80%;\r\n\r\n        @media screen and (min-width: 768px) {\r\n            width: calc(40% - 5px);\r\n        }\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            width: calc(24% - 5px);\r\n        }\r\n    }\r\n\r\n    .YC-CourseCard {\r\n        width: 80%;\r\n\r\n        @media screen and (min-width: 768px) {\r\n            width: calc(40% - 5px);\r\n        }\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            width: calc(24% - 5px);\r\n        }\r\n    }\r\n\r\n    .download-menu {\r\n\r\n        &.download-tab {\r\n            -moz-user-select: none;\r\n            -webkit-user-select: none;\r\n            -ms-user-select:none;\r\n            user-select:none;\r\n            -o-user-select:none;\r\n            max-height: 300px!important;\r\n            overflow-y: scroll;\r\n            @media screen and (min-width: 1440px) {\r\n                max-height: 450px!important;\r\n            }\r\n        }\r\n\r\n        .download-title {\r\n            max-width: 420px;\r\n            overflow: hidden !important;\r\n            text-decoration: none;\r\n            text-overflow: ellipsis;\r\n            white-space: nowrap;\r\n        }\r\n\r\n        .download-link {\r\n            align-items: baseline;\r\n            display: flex;\r\n            flex-flow: row nowrap;\r\n\r\n            &:hover {\r\n                color: $clickable;\r\n            }\r\n\r\n            img {\r\n                padding-left: 16px;\r\n                width: 30px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .lateral-header-course {\r\n        padding: 18px 16px 34px;\r\n        overflow-y: scroll;\r\n        z-index: 9999;\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            overflow-y: hidden;\r\n        }\r\n\r\n        .download-mobile {\r\n            .book {\r\n                border-bottom: 1px solid $clickable;\r\n                margin-bottom: 30px;\r\n            }\r\n\r\n            .book-row {\r\n                border-bottom: .3px solid #C5CBCC;\r\n                padding: 16px 0;\r\n\r\n                span {\r\n                    font-weight: bold;\r\n                }\r\n\r\n                small {\r\n                    font-size: 13px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.lateral-audio {\r\n    z-index: 99999!important;\r\n    .audios {\r\n        height: 80vh;\r\n        overflow-y: auto;\r\n\r\n        .audio-task {\r\n            align-items: center;\r\n            border-bottom: 1px solid #c9c9c9;\r\n            display: flex;\r\n            flex-flow: row wrap;\r\n            justify-content: space-between;\r\n            margin: 16px 0px;\r\n\r\n            .audio-task--player {\r\n                width: 70%;\r\n\r\n                .audio-title {\r\n                    margin: 0;\r\n                    max-width: 250px;\r\n                    overflow: hidden !important;\r\n                    text-decoration: none;\r\n                    text-overflow: ellipsis;\r\n                    white-space: nowrap;\r\n                }\r\n            }\r\n\r\n            .audio-task--download {\r\n                align-self: center;\r\n                color: $clickable;\r\n                display: flex;\r\n                justify-content: flex-end;\r\n                position: relative;\r\n                top: 5px;\r\n                width: 30%;\r\n\r\n                img {\r\n                    padding-left: 8px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .text-muted {\r\n            font-size: 0.75rem;\r\n        }\r\n    }\r\n}\r\n",".recommended {\r\n    border: 2px solid $mainPurple;\r\n    flex-direction: column;\r\n\r\n    @media screen and (min-width: 768px) {\r\n        flex-direction: row;\r\n    }\r\n\r\n    .recommended-content {\r\n        @media screen and (min-width: 768px) {\r\n            width: 70%;\r\n        }\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            padding: 0 32px;\r\n        }\r\n\r\n        .content-header {\r\n            width: 100%;\r\n        }\r\n    }\r\n\r\n    .recommended-photo {\r\n        width: 30%;\r\n\r\n        img {\r\n            height: 248px;\r\n            width: 220px;\r\n        }\r\n    }\r\n\r\n    .recommended-buttons {\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        display: flex;\r\n        flex-flow: row wrap;\r\n    }\r\n}\r\n\r\n.home-teacher-books {\r\n    display: flex;\r\n    flex-flow: column wrap;\r\n    height: 500px;\r\n    overflow-x: scroll;\r\n    @media screen and (min-width: 1024px) {\r\n        height: auto;\r\n    }\r\n}\r\n\r\n.home-tags {\r\n    align-items: center;\r\n    display: flex;\r\n    flex-flow: row wrap;\r\n\r\n    img {\r\n        align-self: center;\r\n    }\r\n\r\n    .tag {\r\n        height: auto;\r\n        margin: 0 16px;\r\n        width: 60px;\r\n\r\n        figure {\r\n            text-align: center;\r\n            width: 100%;\r\n\r\n            img {\r\n                width: 60px;\r\n                height: auto;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.home-page {\r\n    .recommended-card {\r\n        border: 2px solid #643e94;\r\n    }\r\n\r\n    .home-title {\r\n        margin: 0 0 32px;\r\n        @media screen and (min-width: 768px) {\r\n            margin: 24px 0;\r\n        }\r\n    }\r\n\r\n    .courses-desktop {\r\n        .text-muted {\r\n            color: #989898;\r\n            font-size: 0.75rem;\r\n            display: block;\r\n        }\r\n        figure {\r\n            display: flex;\r\n            flex-flow: row wrap;\r\n            width: 35%;\r\n\r\n            img {\r\n                object-fit: contain;\r\n                height: 180px;\r\n                width: 180px;\r\n            }\r\n        }\r\n        .courses-info {\r\n            width: 65%;\r\n        }\r\n    }\r\n\r\n    .lateral-scroll-books {\r\n        display: flex;\r\n        margin-bottom: 24px;\r\n        @media screen and (min-width: 1024px) {\r\n            height: auto;\r\n        }\r\n    }\r\n\r\n    .YC-CourseLink {\r\n        margin: 0 16px 0 0;\r\n        width: 80%;\r\n        &:last-child {\r\n            margin: 0;\r\n        }\r\n        @media screen and (min-width: 768px) {\r\n            width: 40%;\r\n        }\r\n        @media screen and (min-width: 1024px) {\r\n            width: 30%;\r\n        }\r\n        .YC-CourseCard {\r\n            width: 100%;\r\n        }\r\n    }\r\n}\r\n\r\n.lateral-progress-enter {\r\n    right: 0;\r\n    transform: translate3d(100vw, 0, 0);\r\n    width: 80%;\r\n    @media screen and (min-width: 768px) {\r\n        width: 50%;\r\n    }\r\n}\r\n\r\n.lateral-progress-enter-active,\r\n.lateral-progress-enter-done {\r\n    left: 0;\r\n    transform: translate3d(0vw, 0, 0);\r\n    transition: transform 0.8s cubic-bezier(0, 0.52, 0, 1);\r\n    width: 100%;\r\n\r\n    @media screen and (min-width: 768px) {\r\n        left: auto;\r\n        right: 0;\r\n        width: 50%;\r\n    }\r\n}\r\n\r\n.lateral-progress-exit {\r\n    right: 0;\r\n    transform: translate3d(100vw, 0, 0);\r\n    @media screen and (min-width: 768px) {\r\n        width: 50%;\r\n    }\r\n}\r\n\r\n.lateral-progress-exit-active,\r\n.lateral-progress-exit-done {\r\n    transform: translate3d(100vw, 0, 0);\r\n    transition: transform 0.8s cubic-bezier(0, 0.52, 0, 1);\r\n}\r\n",".login {\r\n    display: flex;\r\n    flex-flow: column wrap;\r\n    width: 100%;\r\n    min-height: calc(90vh);\r\n    height: auto;\r\n    top: 0!important;\r\n\r\n    .bg-login {\r\n        background-image: url('Assets/png/background-yconnect-login.png')!important;\r\n        background-repeat: no-repeat;\r\n        background-size: cover;\r\n        background-position: center;\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            width: 100%;\r\n            background-position: center;\r\n        }\r\n        \r\n        @media screen and (min-width: 1400px) {\r\n            width: 100%;\r\n            background-position: 100% 100%;\r\n        }\r\n    }\r\n\r\n    .content-container{\r\n        display: flex;\r\n        flex-direction: column;\r\n        margin-bottom: 0px;\r\n        justify-content: center;\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            flex-direction: row;\r\n            margin-bottom: 30px;\r\n        }\r\n    }\r\n\r\n    .header-container{\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        text-align: center;\r\n        \r\n        .header-logo {\r\n            height: 36px;\r\n            margin: 40px 0;\r\n            width: 134px;\r\n            align-self: center;\r\n        }\r\n    \r\n        .header-separator{\r\n            display: none;\r\n        }\r\n    \r\n        .login-body-title {\r\n            margin: 0 0 20px 0;\r\n            text-align: center;\r\n            font-size: 1.5rem;\r\n    \r\n            strong{\r\n                font-size: 1.5rem;\r\n            }\r\n    \r\n        }\r\n    \r\n        @media screen and (min-width: 1024px) {\r\n            flex-direction: row;\r\n            text-align: left;\r\n    \r\n            .header-separator{\r\n                display: block;\r\n                margin: 40px 20px;\r\n                width: 1px;\r\n                height: 40px;\r\n                background: #50575938;\r\n            }\r\n    \r\n            .header-logo{\r\n                height: 48px;\r\n                width: 180px;\r\n            }\r\n    \r\n            .login-body-title {\r\n                font-size: 2rem;\r\n                margin: 40px 0px;\r\n    \r\n                strong{\r\n                    font-size: 2rem;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    \r\n    .login-body{\r\n    \r\n        width: 100%;\r\n        height: 420px;\r\n        padding: 40px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        background-color: #FFFFFF;\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            width: 400px;\r\n        }\r\n    \r\n        .login-label{\r\n            font-size: 1.2rem;\r\n            width: 100%;\r\n            text-align: center;\r\n            font-weight: 500;\r\n    \r\n            strong{\r\n                font-size: 1.2rem;\r\n            }\r\n\r\n            @media screen and (min-width: 1024px) {\r\n                font-size: 1.5rem;\r\n\r\n                strong{\r\n                    font-size: 1.5rem;\r\n                }\r\n            }\r\n        }\r\n\r\n        .login-form {\r\n            background: #fff;\r\n            padding: 16px;\r\n            \r\n            @media screen and (min-width: 768px) {\r\n                height: 100%;\r\n                width: 35%;\r\n            }\r\n            \r\n            @media screen and (min-width: 1024px) {\r\n                margin-left: 18%;\r\n                margin-right: 60px;\r\n                max-width: 286px;\r\n                padding: 0;\r\n                width: 36%;\r\n            }\r\n    \r\n        }\r\n    \r\n        .form-group {\r\n            margin-bottom: 40px;\r\n        }\r\n    \r\n        .form-group:first-child {\r\n            margin-top:40px;\r\n        }\r\n    \r\n    }\r\n\r\n    @media screen and (min-width: 1024px) {\r\n        flex-flow: row nowrap;\r\n    }\r\n\r\n    &-forgot {\r\n        color: $clickable;\r\n        font-weight: bold;\r\n        position: relative;\r\n        text-decoration: none;\r\n        top: -29px;\r\n        @media screen and (min-width: 1024px) {\r\n            top: -40px;\r\n        }\r\n    }\r\n\r\n    .placement-link-container{\r\n        width: 100%;\r\n        height: 200px;\r\n        padding: 80px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        background-color: #FFFFFF;\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            width: 400px;\r\n        }\r\n\r\n        .placement-label{\r\n            font-size: 1.2rem;\r\n            text-align: center;\r\n\r\n            strong{\r\n                font-size: 1.2rem;\r\n            }\r\n\r\n            @media screen and (min-width: 1024px) {\r\n                font-size: 1.5rem;\r\n\r\n                strong{\r\n                    font-size: 1.5rem;\r\n                }\r\n            }\r\n        }\r\n\r\n        button{\r\n            align-self: center;\r\n        }\r\n    }\r\n\r\n    .optional-features{\r\n        margin-top: 20px;\r\n        margin-left: 0px;\r\n        \r\n        @media screen and (min-width: 1024px) {\r\n            margin-top: 0px;\r\n            margin-left: 50px;    \r\n        }\r\n    }\r\n\r\n}\r\n\r\n.login-footer-yconnect{\r\n    width: 100%;\r\n    align-items: center;\r\n    display: flex;\r\n    height: 80px;\r\n    flex-flow: row wrap;\r\n    justify-content: center;\r\n    background-color: #FFFFFF;\r\n\r\n    .logo-gse {\r\n        width: 70px;\r\n    }\r\n\r\n    .logo-separator {\r\n        background: #50575938;\r\n        display: flex;\r\n        flex-flow: row wrap;\r\n        height: 30px;\r\n        justify-content: center;\r\n        text-align: center;\r\n        margin: 0 24px;\r\n        width: 1px;\r\n        @media screen and (min-width: 1024px) {\r\n            margin: 0 40px;\r\n        }\r\n    }\r\n\r\n    .logo-yazigi {\r\n        width: 80px;\r\n    }\r\n}\r\n\r\n\r\n.login-footer-pearson {\r\n    align-items: center;\r\n    background-color: #505759;\r\n    display: flex;\r\n    flex-flow: row wrap;\r\n    justify-content: space-between;\r\n    min-height: 64px;\r\n    width: 100%;\r\n    @media screen and (min-width: 1024px) {\r\n        margin-top: 0;\r\n    }\r\n\r\n    .logo-pearson {\r\n        margin-left: 16px;\r\n        width: 110px;\r\n        @media screen and (min-width: 1024px) {\r\n            margin-left: 18%;\r\n            width: 132px;\r\n            \r\n        }\r\n    }\r\n\r\n    .logo-always {\r\n        margin-right: 16px;\r\n        width: 120px;\r\n        @media screen and (min-width: 1024px) {\r\n            margin-right: 18%;\r\n        }\r\n    }\r\n}\r\n\r\n#forgotPassword{\r\n\r\n    padding: 20px;\r\n    margin: 0 !important;\r\n\r\n    @media screen and (min-width: 1024px) {\r\n        margin-left: 10px !important;\r\n    }\r\n\r\n}\r\n",".users-table {\r\n    padding: 16px;\r\n    @media screen and (min-width: 768px) {\r\n        padding: 40px;\r\n    }\r\n\r\n    .users-table-header {\r\n        align-items: center;\r\n        display: flex;\r\n        flex-flow: row wrap;\r\n        justify-content: space-between;\r\n\r\n        .header-options {\r\n            width: 100%;\r\n            @media (min-width: 768px) {\r\n                padding: 0 8px;\r\n                width: 25%;\r\n                &:first-child {\r\n                    padding: 0 8px 0 0;\r\n                }\r\n                &:last-child {\r\n                    padding: 0 0 0 8px;\r\n                }\r\n            }\r\n            @media (min-width: 1024px) {\r\n                width: 19%;\r\n            }\r\n        }\r\n\r\n        .header-filter {\r\n            align-items: center;\r\n            display: flex;\r\n            flex-flow: row nowrap;\r\n            // justify-content: flex-end;\r\n        }\r\n\r\n        .user-profile-filter  {\r\n            display: none;\r\n            @media screen and (min-width: 768px) {\r\n                display: flex;\r\n                width: 30%;\r\n\r\n                .form-group {\r\n                    width: 50%;\r\n                }\r\n            }\r\n        }\r\n\r\n        .search-filter {\r\n            width: 100%;\r\n            @media screen and (min-width: 768px) {\r\n                display: flex;\r\n                width: 30%;\r\n            }\r\n        }\r\n\r\n        .btn-table-header {\r\n            bottom: 12px;\r\n            position: relative;\r\n        }\r\n\r\n        .user-pagination {\r\n            align-items: center;\r\n            display: none;\r\n            @media screen and (min-width: 768px) {\r\n                display: flex;\r\n                flex-flow: row wrap;\r\n                justify-content: flex-end;\r\n            }\r\n        }\r\n    }\r\n\r\n    .users-table-name {\r\n        align-items: center;\r\n        display: flex;\r\n        flex-flow: row wrap;\r\n    }\r\n    .users-table-icon {\r\n        width: 30px;\r\n        margin-right: 8px;\r\n    }\r\n\r\n    .users-dropdown {\r\n        button {\r\n            background-color: transparent!important;\r\n            border: none;\r\n            color: $clickable!important;\r\n            padding: 0;\r\n\r\n            &:active,\r\n            &:focus {\r\n                border: none!important;\r\n                box-shadow: none!important;\r\n            }\r\n        }\r\n\r\n        @media screen and (max-width: 1024px) {\r\n            .dropdown-menu-right {\r\n                box-shadow: 1px 1px 8px 0 rgba(0, 0, 0, 0.31)!important;\r\n                border-radius: 8px;\r\n                transform: translate3d(0, 25px, 0px)!important;\r\n                top: -10px;\r\n            }\r\n        }\r\n\r\n        .dropdown-item {\r\n            align-items: center;\r\n            display: flex;\r\n            flex-flow: row nowrap;\r\n            justify-content: flex-start;\r\n        }\r\n    }\r\n\r\n    .select-page {\r\n        display: flex;\r\n        flex-flow: row wrap;\r\n        justify-content: flex-end;\r\n        margin-top: 32px;\r\n        width: 100%;\r\n        &-label {\r\n            margin-bottom: 8px;\r\n            width: 100%;\r\n        }\r\n        @media screen and (min-width: 1024px) {\r\n            margin-top: 46px;\r\n        }\r\n        &-formgroup {\r\n            width: 100%;\r\n            @media screen and (min-width: 1024px) {\r\n                width: 25%;\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n",".messages {\r\n\r\n   \r\n    .inbox-header {\r\n        align-items: center;\r\n        display: flex;\r\n        flex-flow: row wrap;\r\n        justify-content: space-between;\r\n        margin-bottom: 24px;\r\n        padding: 0 11px;\r\n\r\n        .email-input {\r\n            display: none;\r\n\r\n            @media screen and (min-width: 1024px) {\r\n                display: flex;\r\n                flex-flow: row wrap;\r\n                justify-content: flex-start;\r\n                height: 42px;\r\n                margin-top: 8px;\r\n                width: 40%;\r\n            }\r\n        }\r\n\r\n    }\r\n\r\n    .email-filter {\r\n        align-items: baseline;\r\n        display: flex;\r\n        flex-flow: row wrap;\r\n        justify-content: flex-end;\r\n        width: 100%;\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            width: 60%;\r\n        }\r\n\r\n        .searchbar {\r\n            margin: 0 0 0 auto;\r\n            max-width: 350px;\r\n\r\n            .searchbar-input {\r\n                height: 56px;\r\n                &::placeholder {\r\n                    font-size: 14px;\r\n                }\r\n            }\r\n\r\n            img {\r\n                height: 20px;\r\n                position: absolute;\r\n                right: 15px;\r\n                top: 18px;\r\n                width: 20px;\r\n                z-index: 5;\r\n                @media screen and (min-width: 1024px) {\r\n                    top: 15px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .pagination-footer {\r\n        align-items: center;\r\n        display: flex;\r\n        flex-flow: row nowrap;\r\n        justify-content: flex-end;\r\n        margin-top: 46px;\r\n        .select-page {\r\n            margin-left: 30px;\r\n            width: 100%;\r\n            @media screen and (min-width: 1024px) {\r\n                width: 25%;\r\n            }\r\n    \r\n            &:after {\r\n                content: \"\";\r\n                display: table;\r\n                clear: both;\r\n            }\r\n        }\r\n    }\r\n\r\n    .pagination {\r\n        @media screen and (min-width: 1024px) {\r\n            margin-left: 25px;\r\n        }\r\n    }\r\n\r\n    .message-body {\r\n        max-width: 350px;\r\n    }\r\n\r\n    .message-mobile-body {\r\n        width: 70%;\r\n\r\n        .mobile-body-header {\r\n            display: flex;\r\n            flex-flow: row nowrap;\r\n            justify-content: space-between;\r\n            margin-bottom: 8px;\r\n        }\r\n\r\n        .message-author {\r\n            color: #565656 !important;\r\n            font-size: 0.75rem;\r\n        }\r\n\r\n        .mobile-body-message {\r\n            color: #565656 !important;\r\n            font-size: 0.75rem;\r\n            font-weight: bold;\r\n            text-decoration: none;\r\n            margin-top: 16px;\r\n        }\r\n    }\r\n}\r\n\r\n.message-page-title {\r\n    display: flex;\r\n    flex-flow: row wrap;\r\n    justify-content: space-between;\r\n}\r\n\r\n.option-message {\r\n    min-height: 48px;\r\n    width: 100%;\r\n\r\n    .recipient-message {\r\n        width: 100%;\r\n    }\r\n\r\n    .message__control {\r\n        align-items: center;\r\n        border: 0;\r\n        min-height: 56px;\r\n        padding-top: 4px;\r\n    }\r\n\r\n    .message__multi-value {\r\n        background: #fff;\r\n        border-radius: 40px;\r\n        border: $clickable 1px solid;\r\n        padding: 0 7px;\r\n    }\r\n\r\n    .message__multi-value__remove:hover {\r\n        background-color: transparent;\r\n        cursor: pointer;\r\n    }\r\n}\r\n\r\n.message-page-actions {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    margin-bottom: 16px;\r\n    .btn-delete {\r\n        margin: 0 16px 16px 0;\r\n    }\r\n\r\n    @media screen and (min-width: 1024px) {\r\n        padding-right: 15px;\r\n        .btn-delete {\r\n            margin-right: 20px;\r\n        }\r\n    }\r\n}\r\n\r\n.YC-messageById {\r\n\r\n    .message-header {\r\n        border-bottom: 1px solid rgba(0, 0, 0, 0.11);\r\n        display: flex;\r\n        flex-flow: row wrap;\r\n        padding: 16px;\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            padding: 40px 40px 0;\r\n        }\r\n\r\n        .message-header-photo {\r\n            width: 50px;\r\n            border-radius: 50%;\r\n        }\r\n\r\n    }\r\n\r\n\r\n    .message-header-info {\r\n        display: flex;\r\n        flex-flow: column wrap;\r\n        margin-left: 16px;\r\n\r\n        .userinfo {\r\n            font-size: 14px;\r\n\r\n            .email {\r\n                color: #989898;\r\n                font-size: 0.75rem;\r\n                display: block;\r\n                margin: 0;\r\n            }\r\n        }\r\n\r\n    }\r\n\r\n    .users {\r\n        color: #989898;\r\n        font-size: 0.75rem;\r\n        width: 100%;\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            font-size: 0.85rem;\r\n        }\r\n    }\r\n\r\n    .header-datetime {\r\n        color: #989898;\r\n        font-size: 0.75rem;\r\n        margin: 0 0 0 auto;\r\n    }\r\n\r\n    .message-body {\r\n        padding: 16px;\r\n        border-bottom: 1px solid rgba(0, 0, 0, 0.11);\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            max-width: 100%;\r\n            padding: 40px;\r\n        }\r\n    }\r\n\r\n    .message-reply {\r\n        padding: 16px;\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            padding: 40px;\r\n        }\r\n\r\n        &::after {\r\n            content: '';\r\n            border: .3px solid #C5CBCC; \r\n            left: 0;\r\n            margin: 24px 0;\r\n            position: absolute;\r\n            width: 100%;\r\n        }\r\n    }\r\n\r\n    .message-reply--btn {\r\n        @media screen and (min-width: 1024px) {\r\n            justify-content: flex-end;\r\n            padding: 30px 40px;\r\n        }  \r\n    }\r\n\r\n    footer {\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            padding: 30px 40px 40px;\r\n        }\r\n    }\r\n\r\n    .message-reply {\r\n        .reply-to {\r\n            label {\r\n                align-items: center;\r\n                display: flex;\r\n                width: 100px;\r\n            }\r\n            .message__control {\r\n                align-items: center;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.lateral-header-messages {\r\n    margin-right: 0;\r\n    overflow-y: scroll;\r\n    width: 100%!important;\r\n    @media screen and (min-width: 1024px) {\r\n        width: 50%!important;\r\n    }\r\n    .header-messages-btn {\r\n        max-width: 85px;\r\n    }\r\n}\r\n",".online-teacher {\r\n    display: flex;\r\n    flex-flow: row wrap;\r\n    justify-content: space-between;\r\n    margin: 0 0 60px!important;\r\n}\r\n.chat-text {\r\n    @media screen and (min-width: 768px) {\r\n        max-width: 460px;\r\n    }\r\n\r\n    &-title {\r\n        margin-bottom: 16px;\r\n    }\r\n\r\n    &-subtitle {\r\n        margin-bottom: 24px;\r\n    }\r\n\r\n\r\n    &-cta {\r\n        align-items: center;\r\n        bottom: 0;\r\n        border-top: 1px solid $mainPurple;\r\n        display: flex;\r\n        flex-flow: column wrap;\r\n        left: 0px;\r\n        padding: 8px 0;\r\n        position: fixed;\r\n        text-align: center;\r\n        width: 100vw;\r\n        z-index: 5;\r\n        @media screen and (min-width: 768px) {\r\n            align-items: flex-start;\r\n            border: none;\r\n            background-color: transparent;\r\n            position: initial;\r\n            width: auto;\r\n        }\r\n\r\n        .btn-success {\r\n            margin-top: 16px;\r\n        }\r\n\r\n        .chat-direct-message {\r\n            align-items: center;\r\n            display: flex;\r\n            flex-flow: row wrap;\r\n        }\r\n    }\r\n}\r\n.chat-schedule {\r\n    border: 1px solid $mainPurple;\r\n    border-radius: 8px;\r\n    font-size: 13px;\r\n    padding: 16px;\r\n    @media screen and (min-width: 768px) {\r\n        max-width: 396px;\r\n    }\r\n    @media screen and (min-width: 1024px) {\r\n        max-height: 243px;\r\n        width: 396px;\r\n    }\r\n\r\n    .text-secondary, b {\r\n        font-size: 13px;\r\n    }\r\n\r\n    .text-secondary:last-child {\r\n        margin-bottom: 16px;\r\n    }\r\n\r\n    .chat-schedule-title {\r\n        font-weight: bold;\r\n        margin-bottom: 16px;\r\n    }\r\n}\r\n",".profile {\r\n    min-height: 460px;\r\n\r\n    .profile-picture {\r\n        align-items: center;\r\n        display: flex;\r\n        flex-flow: column wrap;\r\n        justify-content: start;\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            border-right: 2px solid #e8e8e8;\r\n            width: 25%;\r\n        }\r\n\r\n        .profile-picture--updatePhoto {\r\n            margin-bottom: 20px;\r\n        }\r\n    }\r\n\r\n    .profile-tabs {\r\n        width: 100%;\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            width: 75%;\r\n        }\r\n\r\n        .nav-tabs {\r\n            justify-content: space-between;\r\n\r\n\r\n        }\r\n\r\n        .form-component {\r\n            margin-bottom: 16px;\r\n        }\r\n\r\n        .control-label {\r\n            color: $clickable;\r\n            font-weight: bold;\r\n        }\r\n\r\n        .row {\r\n            justify-content: flex-start;\r\n        }\r\n\r\n        $i: 1;\r\n\r\n        @while $i <=12 {\r\n            .col-#{$i} {\r\n                margin-right: 8px;\r\n                max-width: calc(#{($i * 8.3333333%)} - 8px);\r\n            }\r\n\r\n            $i: $i+1;\r\n        }\r\n\r\n        .form-group {\r\n            margin-bottom: 0;\r\n        }\r\n\r\n        .gender-btn {\r\n\r\n            .btn-radio {\r\n                align-items: center;\r\n                display: flex;\r\n                flex-flow: row wrap;\r\n                font-size: 12px;\r\n                justify-content: center;\r\n                padding: 8px;\r\n                width: 30%;\r\n            }\r\n            .isInvalidRadio{\r\n                border-color:#f00;\r\n            }  \r\n\r\n        }\r\n\r\n        .profile-reset-password {\r\n            align-items: baseline;\r\n            display: flex;\r\n            flex-flow: row wrap;\r\n        }\r\n\r\n    }\r\n\r\n}\r\n\r\n.btn-profile {\r\n    display: flex;\r\n    flex-flow: row wrap;\r\n    justify-content: flex-end;align-items: right!important;\r\n}\r\n",".reportsPage {\r\n    .YC-CourseCard {\r\n        @media screen and (min-width: 1024px) {\r\n            margin: 15px !important;\r\n            width: calc(25% - 30px);\r\n        }\r\n    }\r\n}\r\n",".support {\r\n    display: flex;\r\n    flex-flow: column wrap;\r\n    justify-content: space-between;\r\n    @media screen and (min-width: 1024px) {\r\n        flex-direction: row;\r\n    }\r\n    .support-info {\r\n        @media screen and (max-width: 1023px) {\r\n            &::after {\r\n                content: '';\r\n                border: .3px solid #C5CBCC; \r\n                left: 0;\r\n                margin: 24px 0;\r\n                position: absolute;\r\n                width: 100%;\r\n            }\r\n        }\r\n        @media screen and (min-width: 1024px) {\r\n            width: 40%;\r\n        }\r\n    }\r\n    .support-form {\r\n        margin-top: 58px;\r\n        @media screen and (min-width: 1024px) {\r\n            margin-top: 0;\r\n            width: 50%;\r\n        } \r\n\r\n        .support-recaptcha {\r\n            margin-bottom: 24px;\r\n        }\r\n\r\n        .text-muted {\r\n            color: $muted!important;\r\n            margin-bottom: 32px;\r\n            @media screen and (min-width: 1024px) {\r\n                margin-bottom: 0;\r\n            } \r\n        }\r\n    }\r\n}\r\n",".travel {\r\n\r\n    .col-md-8 {\r\n        margin-right: 8px;\r\n        max-width: calc(66.666667% - 8px);\r\n    }\r\n}\r\n.travel-world {\r\n    display: flex;\r\n    flex-flow: column wrap;\r\n    justify-content: space-between;\r\n\r\n    .travel-subtitle {\r\n        margin: 0 0 16px 0;\r\n        &::after {\r\n            content: '';\r\n            border: .3px solid #C5CBCC; \r\n            left: 0;\r\n            margin: 30px 0;\r\n            position: absolute;\r\n            width: 100%;\r\n        }\r\n    }\r\n\r\n    .countries-list {\r\n        @media screen and (min-width: 768px) {\r\n            width: 50%;\r\n        }\r\n    }\r\n    .world-map {\r\n        display: none;\r\n        @media screen and (min-width: 1024px) {\r\n            display: inline;\r\n        }\r\n    }\r\n\r\n}\r\n\r\n.travel-profile {\r\n    margin: 1rem;\r\n    @media screen and (min-width: 768px) {\r\n        margin: 0;\r\n    }\r\n}\r\n\r\n.dropdown-continent {\r\n    background-color: #FFFFFF;\r\n    border-radius: 8px;\r\n    box-shadow: 1px 1px 8px 0 rgba(0, 0, 0, 0.31);\r\n    padding: 8px;\r\n    position: absolute;\r\n\r\n    &.northAmerica-dropdown {\r\n        transform: translate(150px, 330px);\r\n    }\r\n\r\n    &.centralAmerica-dropdown {\r\n        transform: translate(200px, 390px);\r\n    }\r\n\r\n    &.southAmerica-dropdown {\r\n        transform: translate(150px, 490px);\r\n    }\r\n    &.europe-dropdown {\r\n        transform: translate(380px, 320px);\r\n    }\r\n    &.africa-dropdown {\r\n        transform: translate(350px, 420px);\r\n    }\r\n    &.asia-dropdown {\r\n        transform: translate(550px, 385px);\r\n    }\r\n    &.oceania-dropdown {\r\n        transform: translate(520px, 505px);\r\n    }\r\n\r\n    .continent-title {\r\n        color: #989898;\r\n        font-size: 0.75rem;\r\n        margin-right: 16px;\r\n    }\r\n\r\n    .continent-close {\r\n        position: relative;\r\n        top: -4px;\r\n    }\r\n\r\n    .continent-countries {\r\n        margin: 8px 0;\r\n        max-height: 200px;\r\n        min-width: 160px;\r\n        overflow: auto;\r\n\r\n        > span {\r\n            display: block;\r\n        }\r\n    }\r\n}\r\n",".final-score {\r\n\r\n    >.card {\r\n        width: calc(100% + 16px);\r\n    }\r\n\r\n    .title,\r\n    .subtitle {\r\n        width: 33.333%\r\n    }\r\n\r\n    .title {\r\n        font-size: 1rem;\r\n        font-weight: bold;\r\n    }\r\n\r\n    .subtitle {\r\n        color: #989898;\r\n        font-size: .75rem;\r\n    }\r\n}\r\n\r\n\r\n\r\n.score-header {\r\n    align-items: flex-start;\r\n    display: flex;\r\n    flex-flow: row wrap;\r\n    justify-content: space-between;\r\n    margin: 32px 0 32px 0;\r\n\r\n    @media screen and (min-width: 1024px) {\r\n        align-items: flex-end;\r\n        flex-flow: row-reverse;\r\n    }\r\n\r\n    .score-filter {\r\n        align-items: baseline;\r\n        display: flex;\r\n        flex-flow: row wrap;\r\n        margin-top: 16px;\r\n        width: 100%;\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            justify-content: flex-end;\r\n            width: 65%;\r\n        }\r\n    }\r\n\r\n    .header-cta {\r\n        width: 100%;\r\n\r\n        @media screen and (min-width: 1024px) {\r\n            width: 40%;\r\n        }\r\n\r\n        .btn:last-child {\r\n            @media screen and (min-width: 1024px) {\r\n                margin-left: 20px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .header-student {\r\n        @media screen and (min-width: 1024px) {\r\n            width: 100% !important;\r\n        }\r\n    }\r\n\r\n    .grade-sending {\r\n        @media screen and (min-width: 1024px) {\r\n            width: 40% !important;\r\n        }\r\n    }\r\n\r\n    .btn-rounded {\r\n        border: 2px solid $clickable;\r\n        border-radius: 20px;\r\n        color: $clickable;\r\n        height: 42px;\r\n        margin: 0 16px 0 0;\r\n        width: 170px;\r\n    }\r\n\r\n    .header-filter {\r\n        width: 60%;\r\n\r\n        .filter-label {\r\n            align-self: center;\r\n        }\r\n\r\n        .form-group {\r\n            margin-bottom: 0;\r\n            padding-bottom: 0;\r\n            width: 25%;\r\n\r\n\r\n        }\r\n    }\r\n}\r\n\r\n.score-table {\r\n\r\n    .task-link {\r\n        a {\r\n            color: $clickable;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.learning-track {\r\n\r\n    .font-20 {\r\n        div{\r\n            font-size: 1.25rem;\r\n        }\r\n    }\r\n\r\n    .learning-class{\r\n        div{\r\n            font-size: 1.25rem;\r\n        }\r\n        align-self: center;\r\n        top: 8px;\r\n    }\r\n\r\n    .learning-row {\r\n        margin-left: -8px !important;\r\n        margin-right: -8px !important;\r\n    }\r\n\r\n    .next-reenroll {\r\n        font-size: 0.75rem;\r\n\r\n        b,\r\n        span {\r\n            font-size: 0.75rem;\r\n        }\r\n    }\r\n\r\n    .learning-card-name {\r\n        font-size: 1.125rem;\r\n        color: #5C3989;\r\n        font-weight: bold;\r\n        width: 100%;\r\n        white-space: nowrap;\r\n        overflow: hidden !important;\r\n        text-overflow: ellipsis;\r\n    }\r\n\r\n    .learning-card-current {\r\n        font-size: 0.8125rem;\r\n        font-weight: bold;\r\n        flex: 1;\r\n    }\r\n\r\n    .learning-card-started {\r\n        font-weight: bold;\r\n        font-size: 0.75rem;\r\n\r\n        div {\r\n            font-size: 0.75rem;\r\n        }\r\n    }\r\n\r\n    .learning-card-porcent {\r\n\r\n        .learning-card-porcent-border {\r\n            height: 5rem;\r\n            width: 5rem;\r\n            border-radius: 5rem;\r\n\r\n            .learning-card-porcent-circle {\r\n                border: 1px #C8CA2A solid;\r\n                position: relative;\r\n                width: 100%;\r\n                border-radius: 3rem;\r\n\r\n                .learning-card-porcent-value {\r\n                    color: #5F3B8D;\r\n                    font-weight: bold;\r\n                    display: flex;\r\n                    justify-content: center;\r\n                    align-items: center;\r\n                    height: 100%;\r\n\r\n                    div {\r\n                        text-align: center;\r\n                        background: white;\r\n                        border-radius: 2rem;\r\n                        height: 3rem;\r\n                        width: 3rem;\r\n\r\n                        padding: 0.8rem 0.4rem;\r\n                        font-size: 0.875rem;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/*\r\n@-moz-keyframes loader-aaa {\r\n    0% {\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@-webkit-keyframes loader-aaa {\r\n    0% {\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@keyframes loader-aaa {\r\n    0% {\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n*/\r\n\r\n//codeburst.io/how-to-pure-css-pie-charts-w-css-variables-38287aea161e\r\n.pie {\r\n    border-radius: 100%;\r\n    height: calc(var(--size, 5) * 1rem);\r\n    overflow: hidden;\r\n    width: calc(var(--size, 5) * 1rem);\r\n    position: absolute;\r\n}\r\n\r\n.pie__segment {\r\n    --a: calc(var(--over50, 0) * -100%);\r\n    --b: calc((1 + var(--over50, 0)) * 100%);\r\n    --degrees: calc((var(--offset, 0) / 100) * 360);\r\n    -webkit-clip-path: polygon(var(--a) var(--a), var(--b) var(--a), var(--b) var(--b), var(--a) var(--b));\r\n    clip-path: polygon(var(--a) var(--a), var(--b) var(--a), var(--b) var(--b), var(--a) var(--b));\r\n    height: 100%;\r\n    position: absolute;\r\n    -webkit-transform: translate(0, -50%) rotate(90deg) rotate(calc(var(--degrees) * 1deg));\r\n    transform: translate(0, -50%) rotate(90deg) rotate(calc(var(--degrees) * 1deg));\r\n    -webkit-transform-origin: 50% 100%;\r\n    transform-origin: 50% 100%;\r\n    width: 100%;\r\n}\r\n\r\n.pie__segment:after,\r\n.pie__segment:before {\r\n    background: var(--bg, #000);\r\n    content: '';\r\n    height: 100%;\r\n    position: absolute;\r\n    width: 100%;\r\n}\r\n\r\n.pie__segment:before {\r\n    --degrees: calc((var(--value, 45) / 100) * 360);\r\n    -webkit-transform: translate(0, 100%) rotate(calc(var(--degrees) * 1deg));\r\n    transform: translate(0, 100%) rotate(calc(var(--degrees) * 1deg));\r\n    -webkit-transform-origin: 50% 0%;\r\n    transform-origin: 50% 0%;\r\n}\r\n\r\n.pie__segment:after {\r\n    opacity: var(--over50, 0);\r\n}\r\n\r\n.select-period{\r\n    width: 100%;\r\n    @media (min-width: 768px) {\r\n        padding: 0 0px !important;\r\n        width: 45% !important;\r\n    }\r\n}\r\n\r\n.select-period-resource{\r\n    width: 100%;\r\n    @media (min-width: 768px) {\r\n        padding: 0 0px !important;\r\n        width: 100% !important;\r\n        display: flex;\r\n        justify-content: flex-end;\r\n        margin-top: 15px;\r\n    }\r\n}",".is-hidden {\r\n    display: none !important;\r\n}\r\n\r\n.deco-none {\r\n    text-decoration: none;\r\n\r\n    &:hover {\r\n        text-decoration: none;\r\n    }\r\n}\r\n\r\n.pointer {\r\n    cursor: pointer;\r\n}\r\n\r\n$i: 10;\r\n@while $i <= 100 {\r\n    .w-#{$i} {\r\n        width: round(percentage($i/100))!important;\r\n    }\r\n    $i: $i+10;\r\n}\r\n\r\n.lateral-scroll-books {\r\n    max-height: 500px;\r\n    overflow-x: scroll;\r\n    overflow-y: hidden;\r\n    flex-flow: column wrap;\r\n    @media screen and (min-width: 1024px) {\r\n        height: 100%;\r\n        flex-flow: row wrap;\r\n        max-height: none;\r\n        overflow-x: hidden;\r\n    }\r\n}\r\n\r\n.rotate {\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.rotate.down {\r\n    transform: rotate(180deg);\r\n}\r\n\r\n.react-datepicker-popper {\r\n    z-index: 3!important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
